(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea33f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea33f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2aJDM", function(module, exports) {






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter",
        "get-size/get-size",
        "fizzy-ui-utils/utils",
        "./cell",
        "./slide",
        "./animate"
    ], function(EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
        return factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("3BvQE")), (parcelRequire("lDySy")), (parcelRequire("22N8l")), (parcelRequire("59HCK")), (parcelRequire("gvjP9")), (parcelRequire("85A74")));
    else {
        // browser global
        var _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(window, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ "use strict";
    // vars
    var jQuery = window1.jQuery;
    var getComputedStyle = window1.getComputedStyle;
    var console = window1.console;
    function moveElements(elems, toElem) {
        elems = utils.makeArray(elems);
        while(elems.length)toElem.appendChild(elems.shift());
    }
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    var GUID = 0;
    // internal store of all Flickity intances
    var instances = {};
    function Flickity(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error("Bad element for Flickity: " + (queryElement || element));
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            var instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: "center",
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.createMethods = [];
    var proto = Flickity.prototype;
    // inherit EventEmitter
    utils.extend(proto, EvEmitter.prototype);
    proto._create = function() {
        // add id for Flickity.data
        var id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.originSide = this.options.rightToLeft ? "right" : "left";
        // create viewport & slider
        this.viewport = document.createElement("div");
        this.viewport.className = "flickity-viewport";
        this._createSlider();
        if (this.options.resize || this.options.watchCSS) window1.addEventListener("resize", this);
        // add listeners from on option
        for(var eventName in this.options.on){
            var listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        Flickity.createMethods.forEach(function(method) {
            this[method]();
        }, this);
        if (this.options.watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        utils.extend(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add("flickity-enabled");
        if (this.options.rightToLeft) this.element.classList.add("flickity-rtl");
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        var cellElems = this._filterFindCellElements(this.element.children);
        moveElements(cellElems, this.slider);
        this.viewport.appendChild(this.slider);
        this.element.appendChild(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener("keydown", this);
        }
        this.emitEvent("activate");
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent("ready");
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        var slider = document.createElement("div");
        slider.className = "flickity-slider";
        slider.style[this.originSide] = 0;
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        var cellElems = this._filterFindCellElements(elems);
        // create new Flickity for collection
        var cells = cellElems.map(function(cellElem) {
            return new Cell(cellElem, this);
        }, this);
        return cells;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        var cellX = 0;
        // get cellX
        if (index > 0) {
            var startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        var len = this.cells.length;
        for(var i = index; i < len; i++){
            var cell = this.cells[i];
            cell.setPosition(cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        }
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach(function(cell) {
            cell.getSize();
        });
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        var slide = new Slide(this);
        this.slides.push(slide);
        var isOriginLeft = this.originSide == "left";
        var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";
        var canCellFit = this._getCanCellFit();
        this.cells.forEach(function(cell, i) {
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);
            if (canCellFit.call(this, i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(this);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        }, this);
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        var groupCells = this.options.groupCells;
        if (!groupCells) return function() {
            return false;
        };
        else if (typeof groupCells == "number") {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            var number = parseInt(groupCells, 10);
            return function(i) {
                return i % number !== 0;
            };
        }
        // default, group by width of slide
        // parse '75%
        var percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
        var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
        return function(i, slideWidth) {
            /* eslint-disable-next-line no-invalid-this */ return slideWidth <= (this.size.innerWidth + 1) * percent;
        };
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    var cellAlignShorthands = {
        // cell align, then based on origin side
        center: {
            left: 0.5,
            right: 0.5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    proto.setCellAlign = function() {
        var shorthand = cellAlignShorthands[this.options.cellAlign];
        this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
    };
    proto.setGallerySize = function() {
        if (this.options.setGallerySize) {
            var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = height + "px";
        }
    };
    proto._getWrapShiftCells = function() {
        // only for wrap-around
        if (!this.options.wrapAround) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        var gapX = this.cursorPosition;
        var cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        gapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(gapX, 0, 1);
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        var cells = [];
        while(gapX > 0){
            var cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        if (!this.options.contain || this.options.wrapAround || !this.cells.length) return;
        var isRightToLeft = this.options.rightToLeft;
        var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
        var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
        var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
        // content is less than gallery size
        var isContentSmaller = contentWidth < this.size.innerWidth;
        // bounds
        var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
        var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
        // contain each cell target
        this.slides.forEach(function(slide) {
            if (isContentSmaller) // all cells fit inside gallery
            slide.target = contentWidth * this.cellAlign;
            else {
                // contain to bounds
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            }
        }, this);
    };
    // -----  ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        var emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? ".flickity" : "";
            var $event = type;
            if (event) {
                // create jQuery event
                var jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.options.wrapAround || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        var prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent("select", null, [
            index
        ]);
        // change event if new index
        if (index != prevIndex) this.dispatchEvent("change", null, [
            index
        ]);
        // old v1 event name, remove in v3
        this.dispatchEvent("cellSelect");
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        var len = this.slides.length;
        var isWrapping = this.options.wrapAround && len > 1;
        if (!isWrapping) return index;
        var wrapIndex = utils.modulo(index, len);
        // go to shortest
        var delta = Math.abs(wrapIndex - this.selectedIndex);
        var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
        var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
        if (!this.isDragSelect && backWrapDelta < delta) index += len;
        else if (!this.isDragSelect && forewardWrapDelta < delta) index -= len;
        // wrap position so slider is within normal area
        if (index < 0) this.x -= this.slideableWidth;
        else if (index >= len) this.x += this.slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        var slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        // Remove in v3?
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        var initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == "string") {
            var cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        var index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        var cell = this.queryCell(value);
        if (!cell) return;
        var index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slides that has cell
        for(var i = 0; i < this.slides.length; i++){
            var slide = this.slides[i];
            var index = slide.cells.indexOf(cell);
            if (index != -1) return i;
        }
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for(var i = 0; i < this.cells.length; i++){
            var cell = this.cells[i];
            if (cell.element == elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        var cells = [];
        elems.forEach(function(elem) {
            var cell = this.getCell(elem);
            if (cell) cells.push(cell);
        }, this);
        return cells;
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        var cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        elem = utils.getParent(elem, ".flickity-slider > *");
        return this.getCell(elem);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        var len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements();
        var cellElems = [];
        for(var i = index - adjCount; i <= index + adjCount; i++){
            var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
            var slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == "number") // use number as index
        return this.cells[selector];
        if (typeof selector == "string") {
            // do not select invalid selectors from hash: #123, #/. #791
            if (selector.match(/^[#.]?[\d/]/)) return;
            // use string as selector, get element
            selector = this.element.querySelector(selector);
        }
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent("uiChange");
    };
    // keep focus on element when child UI elements are clicked
    proto.childUIPointerDown = function(event) {
        // HACK iOS does not allow touch events to bubble up?!
        if (event.type != "touchstart") event.preventDefault();
        this.focus();
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, "onresize", 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.options.wrapAround) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
        this.emitEvent("resize");
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        var selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        var watchOption = this.options.watchCSS;
        if (!watchOption) return;
        var afterContent = getComputedStyle(this.element, ":after").content;
        // activate if :after { content: 'flickity' }
        if (afterContent.indexOf("flickity") != -1) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        // only work if element is in focus
        var isNotFocused = document.activeElement && document.activeElement != this.element;
        if (!this.options.accessibility || isNotFocused) return;
        var handler = Flickity.keyboardHandlers[event.keyCode];
        if (handler) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        // left arrow
        37: function() {
            var leftMethod = this.options.rightToLeft ? "next" : "previous";
            this.uiChange();
            this[leftMethod]();
        },
        // right arrow
        39: function() {
            var rightMethod = this.options.rightToLeft ? "previous" : "next";
            this.uiChange();
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        // TODO remove scrollTo once focus options gets more support
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
        //    #Browser_compatibility
        var prevScrollY = window1.pageYOffset;
        this.element.focus({
            preventScroll: true
        });
        // hack to fix scroll jump after focus, #76
        if (window1.pageYOffset != prevScrollY) window1.scrollTo(window1.pageXOffset, prevScrollY);
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove("flickity-enabled");
        this.element.classList.remove("flickity-rtl");
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach(function(cell) {
            cell.destroy();
        });
        this.element.removeChild(this.viewport);
        // move child elements back into element
        moveElements(this.slider.children, this.element);
        if (this.options.accessibility) {
            this.element.removeAttribute("tabIndex");
            this.element.removeEventListener("keydown", this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent("deactivate");
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener("resize", this);
        this.allOff();
        this.emitEvent("destroy");
        if (jQuery && this.$element) jQuery.removeData(this.element, "flickity");
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    utils.extend(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.flickityGUID;
        return id && instances[id];
    };
    utils.htmlInit(Flickity, "flickity");
    if (jQuery && jQuery.bridget) jQuery.bridget("flickity", Flickity);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRegister("3BvQE", function(module, exports) {
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */ /* jshint unused: true, undef: true, strict: true */ (function(global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */ if (typeof define == "function" && define.amd) // AMD - RequireJS
    define(factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != "undefined" ? window : module.exports, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});

});

parcelRegister("lDySy", function(module, exports) {
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */ /* jshint browser: true, strict: true, undef: true, unused: true */ /* globals console: false */ (function(window1, factory) {
    /* jshint strict: false */ /* globals define, module */ if (typeof define == "function" && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    "use strict";
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf("%") == -1 && !isNaN(num);
        return isValid && num;
    }
    function noop() {}
    var logError = typeof console == "undefined" ? noop : function(message) {
        console.error(message);
    };
    // -------------------------- measurements -------------------------- //
    var measurements = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth"
    ];
    var measurementsLength = measurements.length;
    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }
    // -------------------------- getStyle -------------------------- //
    /**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) logError("Style returned " + style + ". Are you running this code in a hidden iframe on Firefox? " + "See https://bit.ly/getsizebug1");
        return style;
    }
    // -------------------------- setup -------------------------- //
    var isSetup = false;
    var isBoxSizeOuter;
    /**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */ function setup() {
        // setup once
        if (isSetup) return;
        isSetup = true;
        // -------------------------- box sizing -------------------------- //
        /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */ var div = document.createElement("div");
        div.style.width = "200px";
        div.style.padding = "1px 2px 3px 4px";
        div.style.borderStyle = "solid";
        div.style.borderWidth = "1px 2px 3px 4px";
        div.style.boxSizing = "border-box";
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        setup();
        // use querySeletor if elem is string
        if (typeof elem == "string") elem = document.querySelector(elem);
        // do not proceed on non-objects
        if (!elem || typeof elem != "object" || !elem.nodeType) return;
        var style = getStyle(elem);
        // if hidden, everything is 0
        if (style.display == "none") return getZeroSize();
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = size.isBorderBox = style.boxSizing == "border-box";
        // get all measurements
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("22N8l", function(module, exports) {

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == "function" && define.amd) // AMD
    define([
        "desandro-matches-selector/matches-selector"
    ], function(matchesSelector) {
        return factory(window1, matchesSelector);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("7Farg")));
    else // browser global
    window1.fizzyUIUtils = factory(window1, window1.matchesSelector);
})(window, function factory(window1, matchesSelector) {
    "use strict";
    var utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        for(var prop in b)a[prop] = b[prop];
        return a;
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    var arraySlice = Array.prototype.slice;
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        if (Array.isArray(obj)) // use object if already an array
        return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        var isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) // convert nodeList to array
        return arraySlice.call(obj);
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == "string") return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        var method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function(elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) return;
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) ffElems.push(elem);
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for(var i = 0; i < childElems.length; i++)ffElems.push(childElems[i]);
        });
        return ffElems;
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function() {
            var timeout = this[timeoutName];
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function() {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(callback) {
        var readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(callback);
        else document.addEventListener("DOMContentLoaded", callback);
    };
    // ----- htmlInit ----- //
    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + "-" + $2;
        }).toLowerCase();
    };
    var console = window1.console;
    /**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */ utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = "data-" + dashedNamespace;
            var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
            var jsDashElems = document.querySelectorAll(".js-" + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + "-options";
            var jQuery = window1.jQuery;
            elems.forEach(function(elem) {
                var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error("Error parsing " + dataAttr + " on " + elem.className + ": " + error);
                    return;
                }
                // initialize
                var instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});
parcelRegister("7Farg", function(module, exports) {
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */ /*jshint browser: true, strict: true, undef: true, unused: true */ (function(window1, factory) {
    /*global define: false, module: false */ "use strict";
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.matchesSelector = factory();
})(window, function factory() {
    "use strict";
    var matchesMethod = function() {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) return "matches";
        // check un-prefixed
        if (ElemProto.matchesSelector) return "matchesSelector";
        // check vendor prefixes
        var prefixes = [
            "webkit",
            "moz",
            "ms",
            "o"
        ];
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var method = prefix + "MatchesSelector";
            if (ElemProto[method]) return method;
        }
    }();
    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };
});

});


parcelRegister("59HCK", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "get-size/get-size"
    ], function(getSize) {
        return factory(window1, getSize);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("lDySy")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1, window1.getSize);
    }
})(window, function factory(window1, getSize) {
    "use strict";
    function Cell(elem, parent) {
        this.element = elem;
        this.parent = parent;
        this.create();
    }
    var proto = Cell.prototype;
    proto.create = function() {
        this.element.style.position = "absolute";
        this.element.setAttribute("aria-hidden", "true");
        this.x = 0;
        this.shift = 0;
        this.element.style[this.parent.originSide] = 0;
    };
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.style.position = "";
        var side = this.parent.originSide;
        this.element.style[side] = "";
        this.element.style.transform = "";
        this.element.removeAttribute("aria-hidden");
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.setPosition = function(x) {
        this.x = x;
        this.updateTarget();
        this.renderPosition(x);
    };
    // setDefaultTarget v1 method, backwards compatibility, remove in v3
    proto.updateTarget = proto.setDefaultTarget = function() {
        var marginProperty = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
    };
    proto.renderPosition = function(x) {
        // render position of cell with in slider
        var sideOffset = this.parent.originSide === "left" ? 1 : -1;
        var adjustedX = this.parent.options.percentPosition ? x * sideOffset * (this.parent.size.innerWidth / this.size.width) : x * sideOffset;
        this.element.style.transform = "translateX(" + this.parent.getPositionValue(adjustedX) + ")";
    };
    proto.select = function() {
        this.element.classList.add("is-selected");
        this.element.removeAttribute("aria-hidden");
    };
    proto.unselect = function() {
        this.element.classList.remove("is-selected");
        this.element.setAttribute("aria-hidden", "true");
    };
    /**
 * @param {Integer} shift - 0, 1, or -1
 */ proto.wrapShift = function(shift) {
        this.shift = shift;
        this.renderPosition(this.x + this.parent.slideableWidth * shift);
    };
    proto.remove = function() {
        this.element.parentNode.removeChild(this.element);
    };
    return Cell;
});

});

parcelRegister("gvjP9", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(window, function factory() {
    "use strict";
    function Slide(parent) {
        this.parent = parent;
        this.isOriginLeft = parent.originSide == "left";
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    var proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length == 1) {
            this.x = cell.x; // x comes from first cell
            var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = cell.size[beginMargin];
        }
    };
    proto.updateTarget = function() {
        var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
        var lastCell = this.getLastCell();
        var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
        var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach(function(cell) {
            cell.select();
        });
    };
    proto.unselect = function() {
        this.cells.forEach(function(cell) {
            cell.unselect();
        });
    };
    proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    return Slide;
});

});

parcelRegister("85A74", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "fizzy-ui-utils/utils"
    ], function(utils) {
        return factory(window1, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("22N8l")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1, window1.fizzyUIUtils);
    }
})(window, function factory(window1, utils) {
    "use strict";
    // -------------------------- animate -------------------------- //
    var proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        var previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) {
            var _this = this;
            requestAnimationFrame(function animateFrame() {
                _this.animate();
            });
        }
    };
    proto.positionSlider = function() {
        var x = this.x;
        // wrap position around
        if (this.options.wrapAround && this.cells.length > 1) {
            x = utils.modulo(x, this.slideableWidth);
            x -= this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        x = this.options.rightToLeft ? -x : x;
        var translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? "translate3d(" + translateX + ",0,0)" : "translateX(" + translateX + ")";
    };
    proto.dispatchScrollEvent = function() {
        var firstSlide = this.slides[0];
        if (!firstSlide) return;
        var positionX = -this.x - firstSlide.target;
        var progress = positionX / this.slidesWidth;
        this.dispatchEvent("scroll", null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + "%";
        else // pixel positioning
        return Math.round(position) + "px";
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        var isResting = !this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent("settle", null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        var beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        for(var i = 0; i < cells.length; i++){
            var cell = cells[i];
            var cellShift = gap > 0 ? shift : 0;
            cell.wrapShift(cellShift);
            gap -= cell.size.outerWidth;
        }
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        for(var i = 0; i < cells.length; i++)cells[i].wrapShift(0);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        var dragVelocity = this.dragX - this.x;
        var dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        var dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        var distance = this.selectedSlide.target * -1 - this.x;
        var force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRegister("hmb6s", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "unidragger/unidragger",
        "fizzy-ui-utils/utils"
    ], function(Flickity, Unidragger, utils) {
        return factory(window1, Flickity, Unidragger, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("2aJDM")), (parcelRequire("96Meh")), (parcelRequire("22N8l")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unidragger, utils) {
    "use strict";
    // ----- defaults ----- //
    utils.extend(Flickity.defaults, {
        draggable: ">1",
        dragThreshold: 3
    });
    // ----- create ----- //
    Flickity.createMethods.push("_createDrag");
    // -------------------------- drag prototype -------------------------- //
    var proto = Flickity.prototype;
    utils.extend(proto, Unidragger.prototype);
    proto._touchActionValue = "pan-y";
    // --------------------------  -------------------------- //
    proto._createDrag = function() {
        this.on("activate", this.onActivateDrag);
        this.on("uiChange", this._uiChangeDrag);
        this.on("deactivate", this.onDeactivateDrag);
        this.on("cellChange", this.updateDraggable);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove("is-draggable");
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable == ">1") this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        if (this.isDraggable) this.element.classList.add("is-draggable");
        else this.element.classList.remove("is-draggable");
    };
    // backwards compatibility
    proto.bindDrag = function() {
        this.options.draggable = true;
        this.updateDraggable();
    };
    proto.unbindDrag = function() {
        this.options.draggable = false;
        this.updateDraggable();
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.pointerDown = function(event, pointer) {
        if (!this.isDraggable) {
            this._pointerDownDefault(event, pointer);
            return;
        }
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) return;
        this._pointerDownPreventDefault(event);
        this.pointerDownFocus(event);
        // blur
        if (document.activeElement != this.element) // do not blur if already focused
        this.pointerDownBlur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add("is-pointer-down");
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener("scroll", this);
        this._pointerDownDefault(event, pointer);
    };
    // default pointerDown logic, used for staticClick
    proto._pointerDownDefault = function(event, pointer) {
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        // bind move and end events
        this._bindPostStartEvents(event);
        this.dispatchEvent("pointerDown", event, [
            pointer
        ]);
    };
    var focusNodes = {
        INPUT: true,
        TEXTAREA: true,
        SELECT: true
    };
    proto.pointerDownFocus = function(event) {
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isFocusNode) this.focus();
    };
    proto._pointerDownPreventDefault = function(event) {
        var isTouchStart = event.type == "touchstart";
        var isTouchPointer = event.pointerType == "touch";
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.pointerUp = function(event, pointer) {
        delete this.isTouchScrolling;
        this.viewport.classList.remove("is-pointer-down");
        this.dispatchEvent("pointerUp", event, [
            pointer
        ]);
        this._dragPointerUp(event, pointer);
    };
    proto.pointerDone = function() {
        window1.removeEventListener("scroll", this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.dragStart = function(event, pointer) {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener("scroll", this);
        this.dispatchEvent("dragStart", event, [
            pointer
        ]);
    };
    proto.pointerMove = function(event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.dispatchEvent("pointerMove", event, [
            pointer,
            moveVector
        ]);
        this._dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        var direction = this.options.rightToLeft ? -1 : 1;
        if (this.options.wrapAround) // wrap around move. #589
        moveVector.x %= this.slideableWidth;
        var dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.options.wrapAround && this.slides.length) {
            // slow drag
            var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
        this.dispatchEvent("dragMove", event, [
            pointer,
            moveVector
        ]);
    };
    proto.dragEnd = function(event, pointer) {
        if (!this.isDraggable) return;
        if (this.options.freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        var index = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            var restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!this.options.freeScroll && index == this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // TODO refactor this, selecting here feels weird
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.options.wrapAround;
        this.select(index);
        delete this.isDragSelect;
        this.dispatchEvent("dragEnd", event, [
            pointer
        ]);
    };
    proto.dragEndRestingSelect = function() {
        var restingX = this.getRestingPosition();
        // how far away from selected slide
        var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        var positiveResting = this._getClosestResting(restingX, distance, 1);
        var negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
        return index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        var index = this.selectedIndex;
        var minDistance = Infinity;
        var condition = this.options.contain && !this.options.wrapAround ? // if contain, keep going if distance is equal to minDistance
        function(dist, minDist) {
            return dist <= minDist;
        } : function(dist, minDist) {
            return dist < minDist;
        };
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        var len = this.slides.length;
        // wrap around if at least 2 slides
        var isWrapAround = this.options.wrapAround && len > 1;
        var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        var slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        var delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- staticClick ----- //
    proto.staticClick = function(event, pointer) {
        // get clickedCell, if cell was clicked
        var clickedCell = this.getParentCell(event.target);
        var cellElem = clickedCell && clickedCell.element;
        var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
        this.dispatchEvent("staticClick", event, [
            pointer,
            cellElem,
            cellIndex
        ]);
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        var scroll = getScrollPosition();
        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this._pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("96Meh", function(module, exports) {

/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */ /*jshint browser: true, unused: true, undef: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == "function" && define.amd) // AMD
    define([
        "unipointer/unipointer"
    ], function(Unipointer) {
        return factory(window1, Unipointer);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("5sza0")));
    else // browser global
    window1.Unidragger = factory(window1, window1.Unipointer);
})(window, function factory(window1, Unipointer) {
    "use strict";
    // -------------------------- Unidragger -------------------------- //
    function Unidragger() {}
    // inherit Unipointer & EvEmitter
    var proto = Unidragger.prototype = Object.create(Unipointer.prototype);
    // ----- bind start ----- //
    proto.bindHandles = function() {
        this._bindHandles(true);
    };
    proto.unbindHandles = function() {
        this._bindHandles(false);
    };
    /**
 * Add or remove start event
 * @param {Boolean} isAdd
 */ proto._bindHandles = function(isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        // bind each handle
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        var touchAction = isAdd ? this._touchActionValue : "";
        for(var i = 0; i < this.handles.length; i++){
            var handle = this.handles[i];
            this._bindStartEvent(handle, isAdd);
            handle[bindMethod]("click", this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        }
    };
    // prototype so it can be overwriteable by Flickity
    proto._touchActionValue = "none";
    // ----- start event ----- //
    /**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) return;
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        event.preventDefault();
        this.pointerDownBlur();
        // bind move and end events
        this._bindPostStartEvents(event);
        this.emitEvent("pointerDown", [
            event,
            pointer
        ]);
    };
    // nodes that have text fields
    var cursorNodes = {
        TEXTAREA: true,
        INPUT: true,
        SELECT: true,
        OPTION: true
    };
    // input types that do not have text fields
    var clickTypes = {
        radio: true,
        checkbox: true,
        button: true,
        submit: true,
        image: true,
        file: true
    };
    // dismiss inputs with text fields. flickity#403, flickity#404
    proto.okayPointerDown = function(event) {
        var isCursorNode = cursorNodes[event.target.nodeName];
        var isClickType = clickTypes[event.target.type];
        var isOkay = !isCursorNode || isClickType;
        if (!isOkay) this._pointerReset();
        return isOkay;
    };
    // kludge to blur previously focused input
    proto.pointerDownBlur = function() {
        var focused = document.activeElement;
        // do not blur body for IE10, metafizzy/flickity#117
        var canBlur = focused && focused.blur && focused != document.body;
        if (canBlur) focused.blur();
    };
    // ----- move event ----- //
    /**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerMove = function(event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.emitEvent("pointerMove", [
            event,
            pointer,
            moveVector
        ]);
        this._dragMove(event, pointer, moveVector);
    };
    // base pointer move logic
    proto._dragPointerMove = function(event, pointer) {
        var moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        // start drag if pointer has moved far enough to start drag
        if (!this.isDragging && this.hasDragStarted(moveVector)) this._dragStart(event, pointer);
        return moveVector;
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- end event ----- //
    /**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerUp = function(event, pointer) {
        this.emitEvent("pointerUp", [
            event,
            pointer
        ]);
        this._dragPointerUp(event, pointer);
    };
    proto._dragPointerUp = function(event, pointer) {
        if (this.isDragging) this._dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this._staticClick(event, pointer);
    };
    // -------------------------- drag -------------------------- //
    // dragStart
    proto._dragStart = function(event, pointer) {
        this.isDragging = true;
        // prevent clicks
        this.isPreventingClicks = true;
        this.dragStart(event, pointer);
    };
    proto.dragStart = function(event, pointer) {
        this.emitEvent("dragStart", [
            event,
            pointer
        ]);
    };
    // dragMove
    proto._dragMove = function(event, pointer, moveVector) {
        // do not drag if not dragging yet
        if (!this.isDragging) return;
        this.dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        event.preventDefault();
        this.emitEvent("dragMove", [
            event,
            pointer,
            moveVector
        ]);
    };
    // dragEnd
    proto._dragEnd = function(event, pointer) {
        // set flags
        this.isDragging = false;
        // re-enable clicking async
        setTimeout((function() {
            delete this.isPreventingClicks;
        }).bind(this));
        this.dragEnd(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.emitEvent("dragEnd", [
            event,
            pointer
        ]);
    };
    // ----- onclick ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // ----- staticClick ----- //
    // triggered after pointer down & up with no/tiny movement
    proto._staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        if (this.isIgnoringMouseUp && event.type == "mouseup") return;
        this.staticClick(event, pointer);
        // set flag for emulated clicks 300ms after touchend
        if (event.type != "mouseup") {
            this.isIgnoringMouseUp = true;
            // reset flag after 300ms
            setTimeout((function() {
                delete this.isIgnoringMouseUp;
            }).bind(this), 400);
        }
    };
    proto.staticClick = function(event, pointer) {
        this.emitEvent("staticClick", [
            event,
            pointer
        ]);
    };
    // ----- utils ----- //
    Unidragger.getPointerPoint = Unipointer.getPointerPoint;
    // -----  ----- //
    return Unidragger;
});

});
parcelRegister("5sza0", function(module, exports) {

/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /*global define, module, require */ if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter"
    ], function(EvEmitter) {
        return factory(window1, EvEmitter);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("3BvQE")));
    else // browser global
    window1.Unipointer = factory(window1, window1.EvEmitter);
})(window, function factory(window1, EvEmitter) {
    "use strict";
    function noop() {}
    function Unipointer() {}
    // inherit EvEmitter
    var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);
    proto.bindStartEvent = function(elem) {
        this._bindStartEvent(elem, true);
    };
    proto.unbindStartEvent = function(elem) {
        this._bindStartEvent(elem, false);
    };
    /**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */ proto._bindStartEvent = function(elem, isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        // default to mouse events
        var startEvent = "mousedown";
        if ("ontouchstart" in window1) // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = "touchstart";
        else if (window1.PointerEvent) // Pointer Events
        startEvent = "pointerdown";
        elem[bindMethod](startEvent, this);
    };
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        var method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    // returns the touch that we're keeping track of
    proto.getTouch = function(touches) {
        for(var i = 0; i < touches.length; i++){
            var touch = touches[i];
            if (touch.identifier == this.pointerIdentifier) return touch;
        }
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        // dismiss clicks from right or middle buttons
        var button = event.button;
        if (button && button !== 0 && button !== 1) return;
        this._pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this._pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this._pointerDown(event, event);
    };
    /**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto._pointerDown = function(event, pointer) {
        // dismiss right click and other pointers
        // button = 0 is okay, 1-4 not
        if (event.button || this.isPointerDown) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        this.pointerDown(event, pointer);
    };
    proto.pointerDown = function(event, pointer) {
        this._bindPostStartEvents(event);
        this.emitEvent("pointerDown", [
            event,
            pointer
        ]);
    };
    // hash of events to be bound after start event
    var postStartEvents = {
        mousedown: [
            "mousemove",
            "mouseup"
        ],
        touchstart: [
            "touchmove",
            "touchend",
            "touchcancel"
        ],
        pointerdown: [
            "pointermove",
            "pointerup",
            "pointercancel"
        ]
    };
    proto._bindPostStartEvents = function(event) {
        if (!event) return;
        // get proper events to match start event
        var events = postStartEvents[event.type];
        // bind events to node
        events.forEach(function(eventName) {
            window1.addEventListener(eventName, this);
        }, this);
        // save these arguments
        this._boundPointerEvents = events;
    };
    proto._unbindPostStartEvents = function() {
        // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
        if (!this._boundPointerEvents) return;
        this._boundPointerEvents.forEach(function(eventName) {
            window1.removeEventListener(eventName, this);
        }, this);
        delete this._boundPointerEvents;
    };
    // ----- move event ----- //
    proto.onmousemove = function(event) {
        this._pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerMove(event, event);
    };
    proto.ontouchmove = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerMove(event, touch);
    };
    /**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerMove = function(event, pointer) {
        this.pointerMove(event, pointer);
    };
    // public
    proto.pointerMove = function(event, pointer) {
        this.emitEvent("pointerMove", [
            event,
            pointer
        ]);
    };
    // ----- end event ----- //
    proto.onmouseup = function(event) {
        this._pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerUp(event, event);
    };
    proto.ontouchend = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerUp(event, touch);
    };
    /**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerUp = function(event, pointer) {
        this._pointerDone();
        this.pointerUp(event, pointer);
    };
    // public
    proto.pointerUp = function(event, pointer) {
        this.emitEvent("pointerUp", [
            event,
            pointer
        ]);
    };
    // ----- pointer done ----- //
    // triggered on pointer up & pointer cancel
    proto._pointerDone = function() {
        this._pointerReset();
        this._unbindPostStartEvents();
        this.pointerDone();
    };
    proto._pointerReset = function() {
        // reset properties
        this.isPointerDown = false;
        delete this.pointerIdentifier;
    };
    proto.pointerDone = noop;
    // ----- pointer cancel ----- //
    proto.onpointercancel = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerCancel(event, event);
    };
    proto.ontouchcancel = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerCancel(event, touch);
    };
    /**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerCancel = function(event, pointer) {
        this._pointerDone();
        this.pointerCancel(event, pointer);
    };
    // public
    proto.pointerCancel = function(event, pointer) {
        this.emitEvent("pointerCancel", [
            event,
            pointer
        ]);
    };
    // -----  ----- //
    // utility function for getting x/y coords from event
    Unipointer.getPointerPoint = function(pointer) {
        return {
            x: pointer.pageX,
            y: pointer.pageY
        };
    };
    // -----  ----- //
    return Unipointer;
});

});



parcelRegister("4dDla", function(module, exports) {



// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "unipointer/unipointer",
        "fizzy-ui-utils/utils"
    ], function(Flickity, Unipointer, utils) {
        return factory(window1, Flickity, Unipointer, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("2aJDM")), (parcelRequire("5sza0")), (parcelRequire("22N8l")));
    else // browser global
    factory(window1, window1.Flickity, window1.Unipointer, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unipointer, utils) {
    "use strict";
    var svgURI = "http://www.w3.org/2000/svg";
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(direction, parent) {
        this.direction = direction;
        this.parent = parent;
        this._create();
    }
    PrevNextButton.prototype = Object.create(Unipointer.prototype);
    PrevNextButton.prototype._create = function() {
        // properties
        this.isEnabled = true;
        this.isPrevious = this.direction == -1;
        var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == leftDirection;
        var element = this.element = document.createElement("button");
        element.className = "flickity-button flickity-prev-next-button";
        element.className += this.isPrevious ? " previous" : " next";
        // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
        element.setAttribute("type", "button");
        // init as disabled
        this.disable();
        element.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        // create arrow
        var svg = this.createSVG();
        element.appendChild(svg);
        // events
        this.parent.on("select", this.update.bind(this));
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    };
    PrevNextButton.prototype.activate = function() {
        this.bindStartEvent(this.element);
        this.element.addEventListener("click", this);
        // add to DOM
        this.parent.element.appendChild(this.element);
    };
    PrevNextButton.prototype.deactivate = function() {
        // remove from DOM
        this.parent.element.removeChild(this.element);
        // click events
        this.unbindStartEvent(this.element);
        this.element.removeEventListener("click", this);
    };
    PrevNextButton.prototype.createSVG = function() {
        var svg = document.createElementNS(svgURI, "svg");
        svg.setAttribute("class", "flickity-button-icon");
        svg.setAttribute("viewBox", "0 0 100 100");
        var path = document.createElementNS(svgURI, "path");
        var pathMovements = getArrowMovements(this.parent.options.arrowShape);
        path.setAttribute("d", pathMovements);
        path.setAttribute("class", "arrow");
        // rotate arrow
        if (!this.isLeft) path.setAttribute("transform", "translate(100, 100) rotate(180) ");
        svg.appendChild(path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == "string") return shape;
        // create movement string
        return "M " + shape.x0 + ",50" + " L " + shape.x1 + "," + (shape.y1 + 50) + " L " + shape.x2 + "," + (shape.y2 + 50) + " L " + shape.x3 + ",50 " + " L " + shape.x2 + "," + (50 - shape.y2) + " L " + shape.x1 + "," + (50 - shape.y1) + " Z";
    }
    PrevNextButton.prototype.handleEvent = utils.handleEvent;
    PrevNextButton.prototype.onclick = function() {
        if (!this.isEnabled) return;
        this.parent.uiChange();
        var method = this.isPrevious ? "previous" : "next";
        this.parent[method]();
    };
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        if (this.isEnabled) return;
        this.element.disabled = false;
        this.isEnabled = true;
    };
    PrevNextButton.prototype.disable = function() {
        if (!this.isEnabled) return;
        this.element.disabled = true;
        this.isEnabled = false;
    };
    PrevNextButton.prototype.update = function() {
        // index of first or last slide, if previous or next
        var slides = this.parent.slides;
        // enable is wrapAround and at least 2 slides
        if (this.parent.options.wrapAround && slides.length > 1) {
            this.enable();
            return;
        }
        var lastIndex = slides.length ? slides.length - 1 : 0;
        var boundIndex = this.isPrevious ? 0 : lastIndex;
        var method = this.parent.selectedIndex == boundIndex ? "disable" : "enable";
        this[method]();
    };
    PrevNextButton.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };
    // -------------------------- Flickity prototype -------------------------- //
    utils.extend(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.createMethods.push("_createPrevNextButtons");
    var proto = Flickity.prototype;
    proto._createPrevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        this.prevButton = new PrevNextButton(-1, this);
        this.nextButton = new PrevNextButton(1, this);
        this.on("activate", this.activatePrevNextButtons);
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.activate();
        this.nextButton.activate();
        this.on("deactivate", this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate();
        this.nextButton.deactivate();
        this.off("deactivate", this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRegister("dkngm", function(module, exports) {



// page dots
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "unipointer/unipointer",
        "fizzy-ui-utils/utils"
    ], function(Flickity, Unipointer, utils) {
        return factory(window1, Flickity, Unipointer, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("2aJDM")), (parcelRequire("5sza0")), (parcelRequire("22N8l")));
    else // browser global
    factory(window1, window1.Flickity, window1.Unipointer, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unipointer, utils) {
    // -------------------------- PageDots -------------------------- //
    "use strict";
    function PageDots(parent) {
        this.parent = parent;
        this._create();
    }
    PageDots.prototype = Object.create(Unipointer.prototype);
    PageDots.prototype._create = function() {
        // create holder element
        this.holder = document.createElement("ol");
        this.holder.className = "flickity-page-dots";
        // create dots, array of elements
        this.dots = [];
        // events
        this.handleClick = this.onClick.bind(this);
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    };
    PageDots.prototype.activate = function() {
        this.setDots();
        this.holder.addEventListener("click", this.handleClick);
        this.bindStartEvent(this.holder);
        // add to DOM
        this.parent.element.appendChild(this.holder);
    };
    PageDots.prototype.deactivate = function() {
        this.holder.removeEventListener("click", this.handleClick);
        this.unbindStartEvent(this.holder);
        // remove from DOM
        this.parent.element.removeChild(this.holder);
    };
    PageDots.prototype.setDots = function() {
        // get difference between number of slides and number of dots
        var delta = this.parent.slides.length - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        var fragment = document.createDocumentFragment();
        var newDots = [];
        var length = this.dots.length;
        var max = length + count;
        for(var i = length; i < max; i++){
            var dot = document.createElement("li");
            dot.className = "dot";
            dot.setAttribute("aria-label", "Page dot " + (i + 1));
            fragment.appendChild(dot);
            newDots.push(dot);
        }
        this.holder.appendChild(fragment);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        var removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach(function(dot) {
            this.holder.removeChild(dot);
        }, this);
    };
    PageDots.prototype.updateSelected = function() {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.className = "dot";
            this.selectedDot.removeAttribute("aria-current");
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[this.parent.selectedIndex];
        this.selectedDot.className = "dot is-selected";
        this.selectedDot.setAttribute("aria-current", "step");
    };
    PageDots.prototype.onTap = PageDots.prototype.onClick = function(event) {
        var target = event.target;
        // only care about dot clicks
        if (target.nodeName != "LI") return;
        this.parent.uiChange();
        var index = this.dots.indexOf(target);
        this.parent.select(index);
    };
    PageDots.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    utils.extend(Flickity.defaults, {
        pageDots: true
    });
    Flickity.createMethods.push("_createPageDots");
    var proto = Flickity.prototype;
    proto._createPageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots(this);
        // events
        this.on("activate", this.activatePageDots);
        this.on("select", this.updateSelectedPageDots);
        this.on("cellChange", this.updatePageDots);
        this.on("resize", this.updatePageDots);
        this.on("deactivate", this.deactivatePageDots);
    };
    proto.activatePageDots = function() {
        this.pageDots.activate();
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected();
    };
    proto.updatePageDots = function() {
        this.pageDots.setDots();
    };
    proto.deactivatePageDots = function() {
        this.pageDots.deactivate();
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRegister("75ETk", function(module, exports) {



// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter",
        "fizzy-ui-utils/utils",
        "./flickity"
    ], function(EvEmitter, utils, Flickity) {
        return factory(EvEmitter, utils, Flickity);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("3BvQE")), (parcelRequire("22N8l")), (parcelRequire("2aJDM")));
    else // browser global
    factory(window1.EvEmitter, window1.fizzyUIUtils, window1.Flickity);
})(window, function factory(EvEmitter, utils, Flickity) {
    "use strict";
    // -------------------------- Player -------------------------- //
    function Player(parent) {
        this.parent = parent;
        this.state = "stopped";
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    Player.prototype = Object.create(EvEmitter.prototype);
    // start play
    Player.prototype.play = function() {
        if (this.state == "playing") return;
        // do not play if page is hidden, start playing when page is visible
        var isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener("visibilitychange", this.onVisibilityPlay);
            return;
        }
        this.state = "playing";
        // listen to visibility change
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state != "playing") return;
        var time = this.parent.options.autoPlay;
        // default to 3 seconds
        time = typeof time == "number" ? time : 3000;
        var _this = this;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(function() {
            _this.parent.next(true);
            _this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = "stopped";
        this.clear();
        // remove visibility change event
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state == "playing") {
            this.state = "paused";
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state == "paused") this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        var isPageHidden = document.hidden;
        this[isPageHidden ? "pause" : "unpause"]();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener("visibilitychange", this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    utils.extend(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.createMethods.push("_createPlayer");
    var proto = Flickity.prototype;
    proto._createPlayer = function() {
        this.player = new Player(this);
        this.on("activate", this.activatePlayer);
        this.on("uiChange", this.stopPlayer);
        this.on("pointerDown", this.stopPlayer);
        this.on("deactivate", this.deactivatePlayer);
    };
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener("mouseenter", this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener("mouseenter", this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener("mouseleave", this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener("mouseleave", this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRegister("jJEFi", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "fizzy-ui-utils/utils"
    ], function(Flickity, utils) {
        return factory(window1, Flickity, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("2aJDM")), (parcelRequire("22N8l")));
    else // browser global
    factory(window1, window1.Flickity, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, utils) {
    "use strict";
    // append cells to a document fragment
    function getCellsFragment(cells) {
        var fragment = document.createDocumentFragment();
        cells.forEach(function(cell) {
            fragment.appendChild(cell.element);
        });
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    var proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        var cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        var len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        var fragment = getCellsFragment(cells);
        // append to slider
        var isAppend = index == len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            var insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            var endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index, true);
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        var cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        var minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach(function(cell) {
            cell.remove();
            var index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        }, this);
        this.cellChange(minCellIndex, true);
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        var cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        var index = this.cells.indexOf(cell);
        this.cellChange(index);
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */ proto.cellChange = function(changedCellIndex, isPositioningSlider) {
        var prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._getWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex
        // try to maintain position & select previous selected element
        var cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent("cellChange", [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
        // do not position slider after lazy load
        if (isPositioningSlider) this.positionSliderAtSelected();
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRegister("gWVcH", function(module, exports) {


// lazyload
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "fizzy-ui-utils/utils"
    ], function(Flickity, utils) {
        return factory(window1, Flickity, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("2aJDM")), (parcelRequire("22N8l")));
    else // browser global
    factory(window1, window1.Flickity, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, utils) {
    "use strict";
    Flickity.createMethods.push("_createLazyload");
    var proto = Flickity.prototype;
    proto._createLazyload = function() {
        this.on("select", this.lazyLoad);
    };
    proto.lazyLoad = function() {
        var lazyLoad = this.options.lazyLoad;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
        var cellElems = this.getAdjacentCellElements(adjCount);
        // get lazy images in those cells
        var lazyImages = [];
        cellElems.forEach(function(cellElem) {
            var lazyCellImages = getCellLazyImages(cellElem);
            lazyImages = lazyImages.concat(lazyCellImages);
        });
        // load lazy images
        lazyImages.forEach(function(img) {
            new LazyLoader(img, this);
        }, this);
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.nodeName == "IMG") {
            var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload");
            var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
            var srcsetAttr = cellElem.getAttribute("data-flickity-lazyload-srcset");
            if (lazyloadAttr || srcAttr || srcsetAttr) return [
                cellElem
            ];
        }
        // select lazy images in cell
        var lazySelector = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
        var imgs = cellElem.querySelectorAll(lazySelector);
        return utils.makeArray(imgs);
    }
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */ function LazyLoader(img, flickity) {
        this.img = img;
        this.flickity = flickity;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        // get src & srcset
        var src = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src");
        var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute("srcset", srcset);
        // remove attr
        this.img.removeAttribute("data-flickity-lazyload");
        this.img.removeAttribute("data-flickity-lazyload-src");
        this.img.removeAttribute("data-flickity-lazyload-srcset");
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, "flickity-lazyloaded");
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, "flickity-lazyerror");
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
        var cell = this.flickity.getParentCell(this.img);
        var cellElem = cell && cell.element;
        this.flickity.cellSizeChange(cellElem);
        this.img.classList.add(className);
        this.flickity.dispatchEvent("lazyLoad", event, cellElem);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});

function $bf76b386537e82d7$export$28ee1007e174a2a6(fn) {
    if (document.readyState === "complete") return fn();
    document.addEventListener("DOMContentLoaded", fn, false);
}
function $bf76b386537e82d7$export$80bf7733f1207381(selector, root = document) {
    return root.querySelector(selector);
}
function $bf76b386537e82d7$export$84bf76cd7afc7469(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
}


const $9aa6cc01363e0798$var$e = {
    initialisedClass: "",
    activePanelClass: "",
    activeHeaderClass: "",
    headerButtonClass: "",
    animate: !0,
    multiselect: !0,
    prefix: "accordion"
};
function $9aa6cc01363e0798$var$t(e) {
    let t = window.getComputedStyle(e), n = t.getPropertyValue("transition-property");
    return parseFloat(t.getPropertyValue("transition-duration")) > 0 && [
        "all",
        "height"
    ].includes(n);
}
function $9aa6cc01363e0798$var$n(e, t, n) {
    window.requestAnimationFrame(()=>{
        e.style.height = `${t}px`, window.requestAnimationFrame(()=>{
            e.style.height = `${n}px`, e.addEventListener("transitionend", $9aa6cc01363e0798$var$i);
        });
    });
}
function $9aa6cc01363e0798$var$i(e) {
    if ("height" !== e.propertyName) return;
    let t = e.currentTarget;
    t instanceof HTMLElement && (0 === $9aa6cc01363e0798$var$a(t) && (t.style.display = "none"), t.style.height = "", t.removeEventListener("transitionend", $9aa6cc01363e0798$var$i));
}
function $9aa6cc01363e0798$var$a(e) {
    let t = window.getComputedStyle(e);
    return parseInt(t.getPropertyValue("height"), 10) - parseInt(t.getPropertyValue("padding-top"), 10) - parseInt(t.getPropertyValue("padding-bottom"), 10);
}
const $9aa6cc01363e0798$export$12d555061d854ced = {};
function $9aa6cc01363e0798$export$89b4be35062c4a3f(e) {
    if (Object.prototype.hasOwnProperty.call($9aa6cc01363e0798$export$12d555061d854ced, e)) return $9aa6cc01363e0798$export$12d555061d854ced[e];
}
function $9aa6cc01363e0798$export$77f5744dadf9dca6(i, o = {}) {
    const s = {
        ...$9aa6cc01363e0798$var$e,
        ...o
    }, d = document.getElementById(i);
    if (null === d) return;
    if ($9aa6cc01363e0798$export$89b4be35062c4a3f(i)) return $9aa6cc01363e0798$export$89b4be35062c4a3f(i);
    let u = !1, c = [], f = [], p = {};
    function b(e) {
        let t = function(e) {
            let t;
            return t = "number" == typeof e ? e : f.findIndex((t)=>t.id === e), t;
        }(e);
        if (-1 !== t) return f[t];
    }
    function m(e, t = !1) {
        let n;
        if (t) {
            let t = document.activeElement, i = f.findIndex((e)=>e.button === t);
            if (-1 === i) return !1;
            n = i + e;
        } else n = e;
        var i, a;
        f[i = n, a = f.length, (i % a + a) % a].button.focus();
    }
    function y(e, t = {}) {
        Array.isArray(e) ? e.forEach((e)=>E(e, t)) : E(e, t);
    }
    function h(e, t = {}) {
        let n = b(e);
        void 0 !== n && (n.active ? n.close(t) : n.open(t));
    }
    function v(e) {
        let t = b(e);
        void 0 !== t && C("enable", {
            cancelable: !0,
            detail: t
        }) && (t.disabled = !1, t.button.setAttribute("aria-disabled", "false"));
    }
    function g(e) {
        let t = b(e);
        void 0 !== t && C("disable", {
            cancelable: !0,
            detail: t
        }) && (t.disabled = !0, t.button.setAttribute("aria-disabled", "true"));
    }
    function A(e, { animate: i = s.animate, multiselect: a = s.multiselect } = {}) {
        let l = b(e);
        if (void 0 === l || l.active || l.disabled) return;
        if (!C("open", {
            cancelable: !0,
            detail: l
        })) return;
        l.active = !0, l.button.setAttribute("aria-expanded", "true");
        let { activePanelClass: r, activeHeaderClass: d } = s;
        r && l.panel.classList.add(r), d && l.header.classList.add(d), function(e, i = !0) {
            if (i && $9aa6cc01363e0798$var$t(e)) {
                let t = e.clientHeight;
                e.style.height = "auto", e.style.display = "block", $9aa6cc01363e0798$var$n(e, t, e.clientHeight);
            } else e.style.height = "", e.style.display = "block";
        }(l.panel, i), a || y(c, o), c.push(l.id);
    }
    function E(e, { animate: i = s.animate } = {}) {
        let l = b(e);
        if (void 0 === l || !l.active || l.disabled) return;
        if (!C("close", {
            cancelable: !0,
            detail: l
        })) return;
        l.active = !1, l.button.setAttribute("aria-expanded", "false");
        let { activePanelClass: r, activeHeaderClass: o } = s;
        r && l.panel.classList.remove(r), o && l.header.classList.remove(o), function(e, i = !0) {
            i && $9aa6cc01363e0798$var$t(e) ? $9aa6cc01363e0798$var$n(e, $9aa6cc01363e0798$var$a(e), 0) : e.style.display = "none";
        }(l.panel, i);
        let d = c.indexOf(l.id);
        d > -1 && c.splice(d, 1);
    }
    let L = function(e, t) {
        d.removeEventListener(w(e), t);
    };
    function C(e, t = {}) {
        let n = new CustomEvent(w(e), {
            bubbles: !0,
            cancelable: !1,
            ...t
        });
        return d.dispatchEvent(n);
    }
    function w(e) {
        return `${s.prefix}:${e};`;
    }
    function H(e) {
        return `data-${s.prefix}-${e}`;
    }
    return $9aa6cc01363e0798$export$12d555061d854ced[i] = {
        id: i,
        root: d,
        on: function(e, t) {
            let n = w(e);
            d.addEventListener(n, t), (p[n] || (p[n] = [])).push(t);
        },
        off: L,
        init: function() {
            if (u) return;
            Array.from(d.querySelectorAll(`[${H("for")}]`)).forEach((e)=>{
                if (!(e instanceof HTMLElement)) return;
                let t = function(e) {
                    let t = e.getAttribute(H("for"));
                    if (void 0 === t) return;
                    let n = document.getElementById(t), i = document.createElement("button");
                    if (null === n) return;
                    i.type = "button", i.id = `${t}-label`, s.headerButtonClass && (i.className = s.headerButtonClass);
                    i.innerHTML = e.innerHTML, e.innerHTML = "", e.appendChild(i), i.setAttribute("aria-controls", t), i.setAttribute("aria-expanded", "false"), i.addEventListener("click", (e)=>(function(e, t) {
                            h(t), e.preventDefault();
                        })(e, t)), i.addEventListener("keydown", (e)=>(function(e, t) {
                            let { key: n } = e, i = {
                                ArrowUp: ()=>m(-1, !0),
                                ArrowDown: ()=>m(1, !0),
                                End: ()=>m(f.length - 1),
                                Home: ()=>m(0),
                                Enter: ()=>h(t),
                                Space: ()=>h(t)
                            };
                            if (!Object.prototype.hasOwnProperty.call(i, n)) return;
                            i[n](), e.preventDefault();
                        })(e, t)), n.style.display = "none", n.setAttribute("role", "region"), n.setAttribute("aria-labelledby", `${t}-label`);
                    let a = {
                        id: t,
                        panel: n,
                        button: i,
                        header: e,
                        active: !1,
                        disabled: !1,
                        enable: ()=>v(t),
                        disable: ()=>g(t),
                        open: (e = {})=>A(t, e),
                        close: (e = {})=>E(t, e)
                    };
                    return f.push(a), a;
                }(e);
                void 0 !== t && (null !== e.getAttribute(H("expanded")) && t.open({
                    animate: !1
                }), null !== e.getAttribute(H("disabled")) && t.disable());
            }), u = !0, s.initialisedClass && d.classList.add(s.initialisedClass), C("init");
        },
        destroy: function() {
            if (u) {
                s.initialisedClass && d.classList.remove(s.initialisedClass), f.forEach((e)=>{
                    let t = e.button.innerHTML, n = e.button.parentNode, { activePanelClass: i, activeHeaderClass: a } = s;
                    a && e.button.classList.remove(a), i && e.panel.classList.remove(i), e.button.remove(), n.innerHTML = t, [
                        "role",
                        "style",
                        "aria-labelledby"
                    ].forEach((t)=>{
                        e.panel.removeAttribute(t);
                    });
                }), f.length = 0, c.length = 0, delete $9aa6cc01363e0798$export$12d555061d854ced[i], C("destroy");
                for (let [e, t] of Object.entries(p))t.forEach((t)=>L(e, t)), delete p[e];
                u = !1;
            }
        },
        open: function(e, t = {}) {
            Array.isArray(e) ? e.forEach((e)=>A(e, t)) : A(e, t);
        },
        close: y,
        toggle: h,
        enable: v,
        disable: g,
        openAll: function() {
            f.forEach((e)=>e.open({
                    animate: !1,
                    multiselect: !0
                }));
        },
        closeAll: function() {
            f.forEach((e)=>e.close({
                    animate: !1
                }));
        },
        getItem: b,
        items: f
    };
}


function $99182a5dbdb9dab7$export$2cd8252107eb640b() {
    let elements = Array.from(document.querySelectorAll(".js-accordion"));
    elements.forEach((element)=>{
        let instance = (0, $9aa6cc01363e0798$export$77f5744dadf9dca6)(element.id, {
            activePanelClass: "is-active",
            activeHeaderClass: "is-active"
        });
        if (!instance) return;
        instance.init();
    });
}


var $4cde099517bdf0a6$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $4cde099517bdf0a6$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


function $4136cc73fa9759c9$export$e67a095c620b86fe(value) {
    let date = new Date(value);
    let isValid = date instanceof Date && !isNaN(date);
    if (!isValid) return false;
    return date;
}


function $5b81460894221ee7$export$3abe133d5501edeb() {
    return {
        x: window.pageXOffset || document.documentElement.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop
    };
}


function $728cbab38740dbe7$export$b0622a6911dbeaf5() {
    let noop = ()=>{};
    let supported = false;
    try {
        let options = Object.defineProperty({}, "passive", {
            get () {
                return supported = true;
            }
        });
        window.addEventListener("testPassiveEventSupport", noop, options);
        window.removeEventListener("testPassiveEventSupport", noop, options);
    } catch (e) {} // eslint-disable-line no-empty
    return supported;
}


const $d31896c3ffaae1d6$var$UP = "up";
const $d31896c3ffaae1d6$var$DOWN = "down";
let $d31896c3ffaae1d6$var$topBarHeight = 0;
let $d31896c3ffaae1d6$var$header = document.querySelector(".js-header");
let $d31896c3ffaae1d6$var$topBar = document.querySelector(".c-header__top");
let $d31896c3ffaae1d6$var$eventOptions = (0, $728cbab38740dbe7$export$b0622a6911dbeaf5)() ? {
    passive: true
} : false;
let $d31896c3ffaae1d6$var$classes = {
    sticky: "is-sticky",
    animated: "is-animated"
};
let $d31896c3ffaae1d6$var$lastScrollY = 0;
let $d31896c3ffaae1d6$var$tolerance = {
    up: 10,
    down: 10
};
let $d31896c3ffaae1d6$var$topbarOffset = {
    top: 0,
    bottom: 0
};
let $d31896c3ffaae1d6$var$isSticky = false;
let $d31896c3ffaae1d6$var$isStuck = false;
let $d31896c3ffaae1d6$var$resizing = false;
function $d31896c3ffaae1d6$export$2cd8252107eb640b() {
    if (!$d31896c3ffaae1d6$var$header || !$d31896c3ffaae1d6$var$topBar) return;
    $d31896c3ffaae1d6$var$isSticky = $d31896c3ffaae1d6$var$header.dataset.sticky === "1";
    /**
	 * Defer event registration to handle browser potentially restoring previous
	 * scroll position.
	 */ setTimeout(function init() {
        $d31896c3ffaae1d6$export$bcfb1f8dedc00cc7();
        $d31896c3ffaae1d6$var$updateScroll();
        window.addEventListener("resize", $d31896c3ffaae1d6$var$onResize, $d31896c3ffaae1d6$var$eventOptions);
        document.addEventListener("scroll", $d31896c3ffaae1d6$var$onScroll, $d31896c3ffaae1d6$var$eventOptions);
    });
}
function $d31896c3ffaae1d6$export$bcfb1f8dedc00cc7() {
    let { y: scrollY } = (0, $5b81460894221ee7$export$3abe133d5501edeb)();
    let topBarRect = $d31896c3ffaae1d6$var$topBar.getBoundingClientRect();
    $d31896c3ffaae1d6$var$topBarHeight = topBarRect.height;
    $d31896c3ffaae1d6$var$topbarOffset.bottom = $d31896c3ffaae1d6$var$topBarHeight + scrollY;
    $d31896c3ffaae1d6$var$resizing = false;
}
function $d31896c3ffaae1d6$export$792f3d81ea979f55() {
    if (!$d31896c3ffaae1d6$var$isSticky) return;
    document.removeEventListener("scroll", $d31896c3ffaae1d6$var$updateScroll, $d31896c3ffaae1d6$var$eventOptions);
}
function $d31896c3ffaae1d6$export$5a02f26da2ae01b1() {
    if (!$d31896c3ffaae1d6$var$isSticky) return;
    document.addEventListener("scroll", $d31896c3ffaae1d6$var$updateScroll, $d31896c3ffaae1d6$var$eventOptions);
}
function $d31896c3ffaae1d6$var$updateScroll() {
    let { y: scrollY } = (0, $5b81460894221ee7$export$3abe133d5501edeb)();
    let distance = Math.abs(scrollY - $d31896c3ffaae1d6$var$lastScrollY);
    let direction = scrollY < $d31896c3ffaae1d6$var$lastScrollY ? $d31896c3ffaae1d6$var$UP : $d31896c3ffaae1d6$var$DOWN;
    let toleranceExceeded = distance > $d31896c3ffaae1d6$var$tolerance[direction];
    $d31896c3ffaae1d6$var$lastScrollY = scrollY;
    if ($d31896c3ffaae1d6$var$topBarHeight == 0 && scrollY >= 5) {
        $d31896c3ffaae1d6$var$stick();
        return;
    } else if ($d31896c3ffaae1d6$var$topBarHeight == 0 && scrollY < 5) {
        $d31896c3ffaae1d6$var$reset();
        return;
    }
    if ($d31896c3ffaae1d6$var$isStuck && (scrollY < $d31896c3ffaae1d6$var$topBarHeight || $d31896c3ffaae1d6$var$topBarHeight == 0)) {
        $d31896c3ffaae1d6$var$reset();
        return;
    }
    if (!$d31896c3ffaae1d6$var$isStuck && scrollY >= $d31896c3ffaae1d6$var$topBarHeight) {
        $d31896c3ffaae1d6$var$stick();
        return;
    }
    if (!$d31896c3ffaae1d6$var$isStuck || !toleranceExceeded) return;
}
function $d31896c3ffaae1d6$var$reset() {
    $d31896c3ffaae1d6$var$isStuck = false;
    $d31896c3ffaae1d6$var$header.classList.remove($d31896c3ffaae1d6$var$classes.sticky);
}
function $d31896c3ffaae1d6$var$stick() {
    $d31896c3ffaae1d6$var$isStuck = true;
    $d31896c3ffaae1d6$var$header.classList.add($d31896c3ffaae1d6$var$classes.sticky);
}
function $d31896c3ffaae1d6$var$onScroll() {
    if ($d31896c3ffaae1d6$var$resizing) return;
    $d31896c3ffaae1d6$var$updateScroll();
}
function $d31896c3ffaae1d6$var$onResize() {
    if ($d31896c3ffaae1d6$var$resizing) return;
    $d31896c3ffaae1d6$var$resizing = true;
    requestAnimationFrame($d31896c3ffaae1d6$export$bcfb1f8dedc00cc7);
}


const $14e72c11e5d59e2b$var$className = "is-hidden";
let $14e72c11e5d59e2b$var$cookieOptions = {
    sameSite: "strict"
};
function $14e72c11e5d59e2b$export$2cd8252107eb640b() {
    let elements = Array.from(document.querySelectorAll(".js-alert"));
    elements.forEach((element)=>$14e72c11e5d59e2b$var$createAlert(element));
}
function $14e72c11e5d59e2b$var$createAlert(element) {
    let cookieName = element.dataset.id;
    let cookieExpiry = (0, $4136cc73fa9759c9$export$e67a095c620b86fe)(element.dataset.expiry);
    let controls = Array.from(element.querySelectorAll(".js-alert-dismiss"));
    controls.forEach((elem)=>elem.addEventListener("click", (e)=>onClick(e)));
    if (cookieExpiry) $14e72c11e5d59e2b$var$cookieOptions.expires = cookieExpiry;
    function onClick() {
        element.classList.add($14e72c11e5d59e2b$var$className);
        (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).set(cookieName, "true", $14e72c11e5d59e2b$var$cookieOptions);
        (0, $d31896c3ffaae1d6$export$bcfb1f8dedc00cc7)();
    }
}


/* global dataLayer */ 
let $b9b0ca3f5decef8f$var$cookieOptions = {
    expires: 365,
    sameSite: "strict"
};
function $b9b0ca3f5decef8f$export$2cd8252107eb640b() {
    const cookieName = "cookie-notice";
    const className = "is-hidden";
    const cookieFooter = document.querySelector(".js-cookie-footer");
    const cookieToggle = document.querySelector(".js-cookie-toggle");
    let consented = undefined;
    let cookieButton = document.querySelectorAll(".js-cookie-button");
    let cookieButtonAllow = document.querySelectorAll(".js-cookie-allow");
    let cookieButtonDisallow = document.querySelectorAll(".js-cookie-disallow");
    let cookieRadioButtonAllow = document.querySelectorAll(".js-cookie-radio-allow");
    let cookieRadioButtonDisallow = document.querySelectorAll(".js-cookie-radio-disallow");
    cookieButton.forEach((elem)=>elem.addEventListener("click", (e)=>hide(e)));
    cookieButtonAllow.forEach((elem)=>elem.addEventListener("click", ()=>{
            allow();
            setConsent(true);
        }));
    cookieButtonDisallow.forEach((elem)=>elem.addEventListener("click", ()=>{
            disallow();
            setConsent(false);
        }));
    function init() {
        consented = getConsent();
        if (consented == undefined) {
            show();
            return;
        }
        if (!consented) {
            disallow();
            return;
        }
        allow();
    }
    function getConsent() {
        let value = (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).get(cookieName);
        if (value === undefined) return undefined;
        return value === "true";
    }
    function getElements() {
        return Array.from(document.querySelectorAll("[data-tracking-consent]"));
    }
    function loadAll() {
        loadScript(getElements());
    }
    function loadScript(element) {
        if (Array.isArray(element)) return element.forEach((element)=>loadScript(element));
        if (element.getAttribute("data-tracking-consent") !== "") return element.setAttribute("src", element.getAttribute("data-tracking-consent"));
        if (element instanceof HTMLScriptElement && element.hasAttribute("type")) return loadInlineScript(element);
    }
    function loadInlineScript(script) {
        let clone = script.cloneNode(true);
        clone.setAttribute("type", "text/javascript");
        script.after(clone);
        script.remove();
    }
    function hide() {
        cookieFooter.classList.add(className);
    }
    function show() {
        cookieFooter.classList.remove(className);
    }
    function toggleCookiesOn() {
        if (cookieToggle) {
            cookieRadioButtonAllow.forEach((elem)=>elem.checked = true);
            cookieRadioButtonDisallow.forEach((elem)=>elem.checked = false);
        }
    }
    function toggleCookiesOff() {
        if (cookieToggle) {
            cookieRadioButtonAllow.forEach((elem)=>elem.checked = false);
            cookieRadioButtonDisallow.forEach((elem)=>elem.checked = true);
        }
    }
    function setConsent(value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).set(cookieName, value, $b9b0ca3f5decef8f$var$cookieOptions);
    }
    function allow() {
        toggleCookiesOn();
        loadAll();
        if (typeof dataLayer !== "undefined") dataLayer.push({
            event: "cookie_consent_given"
        });
    }
    function disallow() {
        toggleCookiesOff();
    }
    init();
}


/* global FontLoader */ /*
 * anime.js v3.2.2
 * (c) 2023 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */ // Defaults
var $d5074f6a41fc61ab$var$defaultInstanceSettings = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: true,
    timelineOffset: 0
};
var $d5074f6a41fc61ab$var$defaultTweenSettings = {
    duration: 1000,
    delay: 0,
    endDelay: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
};
var $d5074f6a41fc61ab$var$validTransforms = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
];
// Caching
var $d5074f6a41fc61ab$var$cache = {
    CSS: {},
    springs: {}
};
// Utils
function $d5074f6a41fc61ab$var$minMax(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
function $d5074f6a41fc61ab$var$stringContains(str, text) {
    return str.indexOf(text) > -1;
}
function $d5074f6a41fc61ab$var$applyArguments(func, args) {
    return func.apply(null, args);
}
var $d5074f6a41fc61ab$var$is = {
    arr: function(a) {
        return Array.isArray(a);
    },
    obj: function(a) {
        return $d5074f6a41fc61ab$var$stringContains(Object.prototype.toString.call(a), "Object");
    },
    pth: function(a) {
        return $d5074f6a41fc61ab$var$is.obj(a) && a.hasOwnProperty("totalLength");
    },
    svg: function(a) {
        return a instanceof SVGElement;
    },
    inp: function(a) {
        return a instanceof HTMLInputElement;
    },
    dom: function(a) {
        return a.nodeType || $d5074f6a41fc61ab$var$is.svg(a);
    },
    str: function(a) {
        return typeof a === "string";
    },
    fnc: function(a) {
        return typeof a === "function";
    },
    und: function(a) {
        return typeof a === "undefined";
    },
    nil: function(a) {
        return $d5074f6a41fc61ab$var$is.und(a) || a === null;
    },
    hex: function(a) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
    },
    rgb: function(a) {
        return /^rgb/.test(a);
    },
    hsl: function(a) {
        return /^hsl/.test(a);
    },
    col: function(a) {
        return $d5074f6a41fc61ab$var$is.hex(a) || $d5074f6a41fc61ab$var$is.rgb(a) || $d5074f6a41fc61ab$var$is.hsl(a);
    },
    key: function(a) {
        return !$d5074f6a41fc61ab$var$defaultInstanceSettings.hasOwnProperty(a) && !$d5074f6a41fc61ab$var$defaultTweenSettings.hasOwnProperty(a) && a !== "targets" && a !== "keyframes";
    }
};
// Easings
function $d5074f6a41fc61ab$var$parseEasingParameters(string) {
    var match = /\(([^)]+)\)/.exec(string);
    return match ? match[1].split(",").map(function(p) {
        return parseFloat(p);
    }) : [];
}
// Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js
function $d5074f6a41fc61ab$var$spring(string, duration) {
    var params = $d5074f6a41fc61ab$var$parseEasingParameters(string);
    var mass = $d5074f6a41fc61ab$var$minMax($d5074f6a41fc61ab$var$is.und(params[0]) ? 1 : params[0], .1, 100);
    var stiffness = $d5074f6a41fc61ab$var$minMax($d5074f6a41fc61ab$var$is.und(params[1]) ? 100 : params[1], .1, 100);
    var damping = $d5074f6a41fc61ab$var$minMax($d5074f6a41fc61ab$var$is.und(params[2]) ? 10 : params[2], .1, 100);
    var velocity = $d5074f6a41fc61ab$var$minMax($d5074f6a41fc61ab$var$is.und(params[3]) ? 0 : params[3], .1, 100);
    var w0 = Math.sqrt(stiffness / mass);
    var zeta = damping / (2 * Math.sqrt(stiffness * mass));
    var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
    var a = 1;
    var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
    function solver(t) {
        var progress = duration ? duration * t / 1000 : t;
        if (zeta < 1) progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
        else progress = (a + b * progress) * Math.exp(-progress * w0);
        if (t === 0 || t === 1) return t;
        return 1 - progress;
    }
    function getDuration() {
        var cached = $d5074f6a41fc61ab$var$cache.springs[string];
        if (cached) return cached;
        var frame = 1 / 6;
        var elapsed = 0;
        var rest = 0;
        while(true){
            elapsed += frame;
            if (solver(elapsed) === 1) {
                rest++;
                if (rest >= 16) break;
            } else rest = 0;
        }
        var duration = elapsed * frame * 1000;
        $d5074f6a41fc61ab$var$cache.springs[string] = duration;
        return duration;
    }
    return duration ? solver : getDuration;
}
// Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function
function $d5074f6a41fc61ab$var$steps(steps) {
    if (steps === void 0) steps = 10;
    return function(t) {
        return Math.ceil($d5074f6a41fc61ab$var$minMax(t, 0.000001, 1) * steps) * (1 / steps);
    };
}
// BezierEasing https://github.com/gre/bezier-easing
var $d5074f6a41fc61ab$var$bezier = function() {
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > 0.0000001 && ++i < 10);
        return currentT;
    }
    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for(var i = 0; i < 4; ++i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function bezier(mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) return;
        var sampleValues = new Float32Array(kSplineTableSize);
        if (mX1 !== mY1 || mX2 !== mY2) for(var i = 0; i < kSplineTableSize; ++i)sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        function getTForX(aX) {
            var intervalStart = 0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;
            for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
            --currentSample;
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;
            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= 0.001) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            else if (initialSlope === 0.0) return guessForT;
            else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
        return function(x) {
            if (mX1 === mY1 && mX2 === mY2) return x;
            if (x === 0 || x === 1) return x;
            return calcBezier(getTForX(x), mY1, mY2);
        };
    }
    return bezier;
}();
var $d5074f6a41fc61ab$var$penner = function() {
    // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)
    var eases = {
        linear: function() {
            return function(t) {
                return t;
            };
        }
    };
    var functionEasings = {
        Sine: function() {
            return function(t) {
                return 1 - Math.cos(t * Math.PI / 2);
            };
        },
        Expo: function() {
            return function(t) {
                return t ? Math.pow(2, 10 * t - 10) : 0;
            };
        },
        Circ: function() {
            return function(t) {
                return 1 - Math.sqrt(1 - t * t);
            };
        },
        Back: function() {
            return function(t) {
                return t * t * (3 * t - 2);
            };
        },
        Bounce: function() {
            return function(t) {
                var pow2, b = 4;
                while(t < ((pow2 = Math.pow(2, --b)) - 1) / 11);
                return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
            };
        },
        Elastic: function(amplitude, period) {
            if (amplitude === void 0) amplitude = 1;
            if (period === void 0) period = .5;
            var a = $d5074f6a41fc61ab$var$minMax(amplitude, 1, 10);
            var p = $d5074f6a41fc61ab$var$minMax(period, .1, 2);
            return function(t) {
                return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
            };
        }
    };
    var baseEasings = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint"
    ];
    baseEasings.forEach(function(name, i) {
        functionEasings[name] = function() {
            return function(t) {
                return Math.pow(t, i + 2);
            };
        };
    });
    Object.keys(functionEasings).forEach(function(name) {
        var easeIn = functionEasings[name];
        eases["easeIn" + name] = easeIn;
        eases["easeOut" + name] = function(a, b) {
            return function(t) {
                return 1 - easeIn(a, b)(1 - t);
            };
        };
        eases["easeInOut" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 1 - easeIn(a, b)(t * -2 + 2) / 2;
            };
        };
        eases["easeOutIn" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : (easeIn(a, b)(t * 2 - 1) + 1) / 2;
            };
        };
    });
    return eases;
}();
function $d5074f6a41fc61ab$var$parseEasings(easing, duration) {
    if ($d5074f6a41fc61ab$var$is.fnc(easing)) return easing;
    var name = easing.split("(")[0];
    var ease = $d5074f6a41fc61ab$var$penner[name];
    var args = $d5074f6a41fc61ab$var$parseEasingParameters(easing);
    switch(name){
        case "spring":
            return $d5074f6a41fc61ab$var$spring(easing, duration);
        case "cubicBezier":
            return $d5074f6a41fc61ab$var$applyArguments($d5074f6a41fc61ab$var$bezier, args);
        case "steps":
            return $d5074f6a41fc61ab$var$applyArguments($d5074f6a41fc61ab$var$steps, args);
        default:
            return $d5074f6a41fc61ab$var$applyArguments(ease, args);
    }
}
// Strings
function $d5074f6a41fc61ab$var$selectString(str) {
    try {
        var nodes = document.querySelectorAll(str);
        return nodes;
    } catch (e) {
        return;
    }
}
// Arrays
function $d5074f6a41fc61ab$var$filterArray(arr, callback) {
    var len = arr.length;
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    var result = [];
    for(var i = 0; i < len; i++)if (i in arr) {
        var val = arr[i];
        if (callback.call(thisArg, val, i, arr)) result.push(val);
    }
    return result;
}
function $d5074f6a41fc61ab$var$flattenArray(arr) {
    return arr.reduce(function(a, b) {
        return a.concat($d5074f6a41fc61ab$var$is.arr(b) ? $d5074f6a41fc61ab$var$flattenArray(b) : b);
    }, []);
}
function $d5074f6a41fc61ab$var$toArray(o) {
    if ($d5074f6a41fc61ab$var$is.arr(o)) return o;
    if ($d5074f6a41fc61ab$var$is.str(o)) o = $d5074f6a41fc61ab$var$selectString(o) || o;
    if (o instanceof NodeList || o instanceof HTMLCollection) return [].slice.call(o);
    return [
        o
    ];
}
function $d5074f6a41fc61ab$var$arrayContains(arr, val) {
    return arr.some(function(a) {
        return a === val;
    });
}
// Objects
function $d5074f6a41fc61ab$var$cloneObject(o) {
    var clone = {};
    for(var p in o)clone[p] = o[p];
    return clone;
}
function $d5074f6a41fc61ab$var$replaceObjectProps(o1, o2) {
    var o = $d5074f6a41fc61ab$var$cloneObject(o1);
    for(var p in o1)o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
    return o;
}
function $d5074f6a41fc61ab$var$mergeObjects(o1, o2) {
    var o = $d5074f6a41fc61ab$var$cloneObject(o1);
    for(var p in o2)o[p] = $d5074f6a41fc61ab$var$is.und(o1[p]) ? o2[p] : o1[p];
    return o;
}
// Colors
function $d5074f6a41fc61ab$var$rgbToRgba(rgbValue) {
    var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
    return rgb ? "rgba(" + rgb[1] + ",1)" : rgbValue;
}
function $d5074f6a41fc61ab$var$hexToRgba(hexValue) {
    var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hex = hexValue.replace(rgx, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var r = parseInt(rgb[1], 16);
    var g = parseInt(rgb[2], 16);
    var b = parseInt(rgb[3], 16);
    return "rgba(" + r + "," + g + "," + b + ",1)";
}
function $d5074f6a41fc61ab$var$hslToRgba(hslValue) {
    var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
    var h = parseInt(hsl[1], 10) / 360;
    var s = parseInt(hsl[2], 10) / 100;
    var l = parseInt(hsl[3], 10) / 100;
    var a = hsl[4] || 1;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var r, g, b;
    if (s == 0) r = g = b = l;
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return "rgba(" + r * 255 + "," + g * 255 + "," + b * 255 + "," + a + ")";
}
function $d5074f6a41fc61ab$var$colorToRgb(val) {
    if ($d5074f6a41fc61ab$var$is.rgb(val)) return $d5074f6a41fc61ab$var$rgbToRgba(val);
    if ($d5074f6a41fc61ab$var$is.hex(val)) return $d5074f6a41fc61ab$var$hexToRgba(val);
    if ($d5074f6a41fc61ab$var$is.hsl(val)) return $d5074f6a41fc61ab$var$hslToRgba(val);
}
// Units
function $d5074f6a41fc61ab$var$getUnit(val) {
    var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
    if (split) return split[1];
}
function $d5074f6a41fc61ab$var$getTransformUnit(propName) {
    if ($d5074f6a41fc61ab$var$stringContains(propName, "translate") || propName === "perspective") return "px";
    if ($d5074f6a41fc61ab$var$stringContains(propName, "rotate") || $d5074f6a41fc61ab$var$stringContains(propName, "skew")) return "deg";
}
// Values
function $d5074f6a41fc61ab$var$getFunctionValue(val, animatable) {
    if (!$d5074f6a41fc61ab$var$is.fnc(val)) return val;
    return val(animatable.target, animatable.id, animatable.total);
}
function $d5074f6a41fc61ab$var$getAttribute(el, prop) {
    return el.getAttribute(prop);
}
function $d5074f6a41fc61ab$var$convertPxToUnit(el, value, unit) {
    var valueUnit = $d5074f6a41fc61ab$var$getUnit(value);
    if ($d5074f6a41fc61ab$var$arrayContains([
        unit,
        "deg",
        "rad",
        "turn"
    ], valueUnit)) return value;
    var cached = $d5074f6a41fc61ab$var$cache.CSS[value + unit];
    if (!$d5074f6a41fc61ab$var$is.und(cached)) return cached;
    var baseline = 100;
    var tempEl = document.createElement(el.tagName);
    var parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
    parentEl.appendChild(tempEl);
    tempEl.style.position = "absolute";
    tempEl.style.width = baseline + unit;
    var factor = baseline / tempEl.offsetWidth;
    parentEl.removeChild(tempEl);
    var convertedUnit = factor * parseFloat(value);
    $d5074f6a41fc61ab$var$cache.CSS[value + unit] = convertedUnit;
    return convertedUnit;
}
function $d5074f6a41fc61ab$var$getCSSValue(el, prop, unit) {
    if (prop in el.style) {
        var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || "0";
        return unit ? $d5074f6a41fc61ab$var$convertPxToUnit(el, value, unit) : value;
    }
}
function $d5074f6a41fc61ab$var$getAnimationType(el, prop) {
    if ($d5074f6a41fc61ab$var$is.dom(el) && !$d5074f6a41fc61ab$var$is.inp(el) && (!$d5074f6a41fc61ab$var$is.nil($d5074f6a41fc61ab$var$getAttribute(el, prop)) || $d5074f6a41fc61ab$var$is.svg(el) && el[prop])) return "attribute";
    if ($d5074f6a41fc61ab$var$is.dom(el) && $d5074f6a41fc61ab$var$arrayContains($d5074f6a41fc61ab$var$validTransforms, prop)) return "transform";
    if ($d5074f6a41fc61ab$var$is.dom(el) && prop !== "transform" && $d5074f6a41fc61ab$var$getCSSValue(el, prop)) return "css";
    if (el[prop] != null) return "object";
}
function $d5074f6a41fc61ab$var$getElementTransforms(el) {
    if (!$d5074f6a41fc61ab$var$is.dom(el)) return;
    var str = el.style.transform || "";
    var reg = /(\w+)\(([^)]*)\)/g;
    var transforms = new Map();
    var m;
    while(m = reg.exec(str))transforms.set(m[1], m[2]);
    return transforms;
}
function $d5074f6a41fc61ab$var$getTransformValue(el, propName, animatable, unit) {
    var defaultVal = $d5074f6a41fc61ab$var$stringContains(propName, "scale") ? 1 : 0 + $d5074f6a41fc61ab$var$getTransformUnit(propName);
    var value = $d5074f6a41fc61ab$var$getElementTransforms(el).get(propName) || defaultVal;
    if (animatable) {
        animatable.transforms.list.set(propName, value);
        animatable.transforms["last"] = propName;
    }
    return unit ? $d5074f6a41fc61ab$var$convertPxToUnit(el, value, unit) : value;
}
function $d5074f6a41fc61ab$var$getOriginalTargetValue(target, propName, unit, animatable) {
    switch($d5074f6a41fc61ab$var$getAnimationType(target, propName)){
        case "transform":
            return $d5074f6a41fc61ab$var$getTransformValue(target, propName, animatable, unit);
        case "css":
            return $d5074f6a41fc61ab$var$getCSSValue(target, propName, unit);
        case "attribute":
            return $d5074f6a41fc61ab$var$getAttribute(target, propName);
        default:
            return target[propName] || 0;
    }
}
function $d5074f6a41fc61ab$var$getRelativeValue(to, from) {
    var operator = /^(\*=|\+=|-=)/.exec(to);
    if (!operator) return to;
    var u = $d5074f6a41fc61ab$var$getUnit(to) || 0;
    var x = parseFloat(from);
    var y = parseFloat(to.replace(operator[0], ""));
    switch(operator[0][0]){
        case "+":
            return x + y + u;
        case "-":
            return x - y + u;
        case "*":
            return x * y + u;
    }
}
function $d5074f6a41fc61ab$var$validateValue(val, unit) {
    if ($d5074f6a41fc61ab$var$is.col(val)) return $d5074f6a41fc61ab$var$colorToRgb(val);
    if (/\s/g.test(val)) return val;
    var originalUnit = $d5074f6a41fc61ab$var$getUnit(val);
    var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
    if (unit) return unitLess + unit;
    return unitLess;
}
// getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744
function $d5074f6a41fc61ab$var$getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function $d5074f6a41fc61ab$var$getCircleLength(el) {
    return Math.PI * 2 * $d5074f6a41fc61ab$var$getAttribute(el, "r");
}
function $d5074f6a41fc61ab$var$getRectLength(el) {
    return $d5074f6a41fc61ab$var$getAttribute(el, "width") * 2 + $d5074f6a41fc61ab$var$getAttribute(el, "height") * 2;
}
function $d5074f6a41fc61ab$var$getLineLength(el) {
    return $d5074f6a41fc61ab$var$getDistance({
        x: $d5074f6a41fc61ab$var$getAttribute(el, "x1"),
        y: $d5074f6a41fc61ab$var$getAttribute(el, "y1")
    }, {
        x: $d5074f6a41fc61ab$var$getAttribute(el, "x2"),
        y: $d5074f6a41fc61ab$var$getAttribute(el, "y2")
    });
}
function $d5074f6a41fc61ab$var$getPolylineLength(el) {
    var points = el.points;
    var totalLength = 0;
    var previousPos;
    for(var i = 0; i < points.numberOfItems; i++){
        var currentPos = points.getItem(i);
        if (i > 0) totalLength += $d5074f6a41fc61ab$var$getDistance(previousPos, currentPos);
        previousPos = currentPos;
    }
    return totalLength;
}
function $d5074f6a41fc61ab$var$getPolygonLength(el) {
    var points = el.points;
    return $d5074f6a41fc61ab$var$getPolylineLength(el) + $d5074f6a41fc61ab$var$getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}
// Path animation
function $d5074f6a41fc61ab$var$getTotalLength(el) {
    if (el.getTotalLength) return el.getTotalLength();
    switch(el.tagName.toLowerCase()){
        case "circle":
            return $d5074f6a41fc61ab$var$getCircleLength(el);
        case "rect":
            return $d5074f6a41fc61ab$var$getRectLength(el);
        case "line":
            return $d5074f6a41fc61ab$var$getLineLength(el);
        case "polyline":
            return $d5074f6a41fc61ab$var$getPolylineLength(el);
        case "polygon":
            return $d5074f6a41fc61ab$var$getPolygonLength(el);
    }
}
function $d5074f6a41fc61ab$var$setDashoffset(el) {
    var pathLength = $d5074f6a41fc61ab$var$getTotalLength(el);
    el.setAttribute("stroke-dasharray", pathLength);
    return pathLength;
}
// Motion path
function $d5074f6a41fc61ab$var$getParentSvgEl(el) {
    var parentEl = el.parentNode;
    while($d5074f6a41fc61ab$var$is.svg(parentEl)){
        if (!$d5074f6a41fc61ab$var$is.svg(parentEl.parentNode)) break;
        parentEl = parentEl.parentNode;
    }
    return parentEl;
}
function $d5074f6a41fc61ab$var$getParentSvg(pathEl, svgData) {
    var svg = svgData || {};
    var parentSvgEl = svg.el || $d5074f6a41fc61ab$var$getParentSvgEl(pathEl);
    var rect = parentSvgEl.getBoundingClientRect();
    var viewBoxAttr = $d5074f6a41fc61ab$var$getAttribute(parentSvgEl, "viewBox");
    var width = rect.width;
    var height = rect.height;
    var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(" ") : [
        0,
        0,
        width,
        height
    ]);
    return {
        el: parentSvgEl,
        viewBox: viewBox,
        x: viewBox[0] / 1,
        y: viewBox[1] / 1,
        w: width,
        h: height,
        vW: viewBox[2],
        vH: viewBox[3]
    };
}
function $d5074f6a41fc61ab$var$getPath(path, percent) {
    var pathEl = $d5074f6a41fc61ab$var$is.str(path) ? $d5074f6a41fc61ab$var$selectString(path)[0] : path;
    var p = percent || 100;
    return function(property) {
        return {
            property: property,
            el: pathEl,
            svg: $d5074f6a41fc61ab$var$getParentSvg(pathEl),
            totalLength: $d5074f6a41fc61ab$var$getTotalLength(pathEl) * (p / 100)
        };
    };
}
function $d5074f6a41fc61ab$var$getPathProgress(path, progress, isPathTargetInsideSVG) {
    function point(offset) {
        if (offset === void 0) offset = 0;
        var l = progress + offset >= 1 ? progress + offset : 0;
        return path.el.getPointAtLength(l);
    }
    var svg = $d5074f6a41fc61ab$var$getParentSvg(path.el, path.svg);
    var p = point();
    var p0 = point(-1);
    var p1 = point(1);
    var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
    var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
    switch(path.property){
        case "x":
            return (p.x - svg.x) * scaleX;
        case "y":
            return (p.y - svg.y) * scaleY;
        case "angle":
            return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
    }
}
// Decompose value
function $d5074f6a41fc61ab$var$decomposeValue(val, unit) {
    // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
    // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var value = $d5074f6a41fc61ab$var$validateValue($d5074f6a41fc61ab$var$is.pth(val) ? val.totalLength : val, unit) + "";
    return {
        original: value,
        numbers: value.match(rgx) ? value.match(rgx).map(Number) : [
            0
        ],
        strings: $d5074f6a41fc61ab$var$is.str(val) || unit ? value.split(rgx) : []
    };
}
// Animatables
function $d5074f6a41fc61ab$var$parseTargets(targets) {
    var targetsArray = targets ? $d5074f6a41fc61ab$var$flattenArray($d5074f6a41fc61ab$var$is.arr(targets) ? targets.map($d5074f6a41fc61ab$var$toArray) : $d5074f6a41fc61ab$var$toArray(targets)) : [];
    return $d5074f6a41fc61ab$var$filterArray(targetsArray, function(item, pos, self) {
        return self.indexOf(item) === pos;
    });
}
function $d5074f6a41fc61ab$var$getAnimatables(targets) {
    var parsed = $d5074f6a41fc61ab$var$parseTargets(targets);
    return parsed.map(function(t, i) {
        return {
            target: t,
            id: i,
            total: parsed.length,
            transforms: {
                list: $d5074f6a41fc61ab$var$getElementTransforms(t)
            }
        };
    });
}
// Properties
function $d5074f6a41fc61ab$var$normalizePropertyTweens(prop, tweenSettings) {
    var settings = $d5074f6a41fc61ab$var$cloneObject(tweenSettings);
    // Override duration if easing is a spring
    if (/^spring/.test(settings.easing)) settings.duration = $d5074f6a41fc61ab$var$spring(settings.easing);
    if ($d5074f6a41fc61ab$var$is.arr(prop)) {
        var l = prop.length;
        var isFromTo = l === 2 && !$d5074f6a41fc61ab$var$is.obj(prop[0]);
        if (!isFromTo) // Duration divided by the number of tweens
        {
            if (!$d5074f6a41fc61ab$var$is.fnc(tweenSettings.duration)) settings.duration = tweenSettings.duration / l;
        } else // Transform [from, to] values shorthand to a valid tween value
        prop = {
            value: prop
        };
    }
    var propArray = $d5074f6a41fc61ab$var$is.arr(prop) ? prop : [
        prop
    ];
    return propArray.map(function(v, i) {
        var obj = $d5074f6a41fc61ab$var$is.obj(v) && !$d5074f6a41fc61ab$var$is.pth(v) ? v : {
            value: v
        };
        // Default delay value should only be applied to the first tween
        if ($d5074f6a41fc61ab$var$is.und(obj.delay)) obj.delay = !i ? tweenSettings.delay : 0;
        // Default endDelay value should only be applied to the last tween
        if ($d5074f6a41fc61ab$var$is.und(obj.endDelay)) obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
        return obj;
    }).map(function(k) {
        return $d5074f6a41fc61ab$var$mergeObjects(k, settings);
    });
}
function $d5074f6a41fc61ab$var$flattenKeyframes(keyframes) {
    var propertyNames = $d5074f6a41fc61ab$var$filterArray($d5074f6a41fc61ab$var$flattenArray(keyframes.map(function(key) {
        return Object.keys(key);
    })), function(p) {
        return $d5074f6a41fc61ab$var$is.key(p);
    }).reduce(function(a, b) {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
    }, []);
    var properties = {};
    var loop = function(i) {
        var propName = propertyNames[i];
        properties[propName] = keyframes.map(function(key) {
            var newKey = {};
            for(var p in key){
                if ($d5074f6a41fc61ab$var$is.key(p)) {
                    if (p == propName) newKey.value = key[p];
                } else newKey[p] = key[p];
            }
            return newKey;
        });
    };
    for(var i = 0; i < propertyNames.length; i++)loop(i);
    return properties;
}
function $d5074f6a41fc61ab$var$getProperties(tweenSettings, params) {
    var properties = [];
    var keyframes = params.keyframes;
    if (keyframes) params = $d5074f6a41fc61ab$var$mergeObjects($d5074f6a41fc61ab$var$flattenKeyframes(keyframes), params);
    for(var p in params)if ($d5074f6a41fc61ab$var$is.key(p)) properties.push({
        name: p,
        tweens: $d5074f6a41fc61ab$var$normalizePropertyTweens(params[p], tweenSettings)
    });
    return properties;
}
// Tweens
function $d5074f6a41fc61ab$var$normalizeTweenValues(tween, animatable) {
    var t = {};
    for(var p in tween){
        var value = $d5074f6a41fc61ab$var$getFunctionValue(tween[p], animatable);
        if ($d5074f6a41fc61ab$var$is.arr(value)) {
            value = value.map(function(v) {
                return $d5074f6a41fc61ab$var$getFunctionValue(v, animatable);
            });
            if (value.length === 1) value = value[0];
        }
        t[p] = value;
    }
    t.duration = parseFloat(t.duration);
    t.delay = parseFloat(t.delay);
    return t;
}
function $d5074f6a41fc61ab$var$normalizeTweens(prop, animatable) {
    var previousTween;
    return prop.tweens.map(function(t) {
        var tween = $d5074f6a41fc61ab$var$normalizeTweenValues(t, animatable);
        var tweenValue = tween.value;
        var to = $d5074f6a41fc61ab$var$is.arr(tweenValue) ? tweenValue[1] : tweenValue;
        var toUnit = $d5074f6a41fc61ab$var$getUnit(to);
        var originalValue = $d5074f6a41fc61ab$var$getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
        var previousValue = previousTween ? previousTween.to.original : originalValue;
        var from = $d5074f6a41fc61ab$var$is.arr(tweenValue) ? tweenValue[0] : previousValue;
        var fromUnit = $d5074f6a41fc61ab$var$getUnit(from) || $d5074f6a41fc61ab$var$getUnit(originalValue);
        var unit = toUnit || fromUnit;
        if ($d5074f6a41fc61ab$var$is.und(to)) to = previousValue;
        tween.from = $d5074f6a41fc61ab$var$decomposeValue(from, unit);
        tween.to = $d5074f6a41fc61ab$var$decomposeValue($d5074f6a41fc61ab$var$getRelativeValue(to, from), unit);
        tween.start = previousTween ? previousTween.end : 0;
        tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
        tween.easing = $d5074f6a41fc61ab$var$parseEasings(tween.easing, tween.duration);
        tween.isPath = $d5074f6a41fc61ab$var$is.pth(tweenValue);
        tween.isPathTargetInsideSVG = tween.isPath && $d5074f6a41fc61ab$var$is.svg(animatable.target);
        tween.isColor = $d5074f6a41fc61ab$var$is.col(tween.from.original);
        if (tween.isColor) tween.round = 1;
        previousTween = tween;
        return tween;
    });
}
// Tween progress
var $d5074f6a41fc61ab$var$setProgressValue = {
    css: function(t, p, v) {
        return t.style[p] = v;
    },
    attribute: function(t, p, v) {
        return t.setAttribute(p, v);
    },
    object: function(t, p, v) {
        return t[p] = v;
    },
    transform: function(t, p, v, transforms, manual) {
        transforms.list.set(p, v);
        if (p === transforms.last || manual) {
            var str = "";
            transforms.list.forEach(function(value, prop) {
                str += prop + "(" + value + ") ";
            });
            t.style.transform = str;
        }
    }
};
// Set Value helper
function $d5074f6a41fc61ab$var$setTargetsValue(targets, properties) {
    var animatables = $d5074f6a41fc61ab$var$getAnimatables(targets);
    animatables.forEach(function(animatable) {
        for(var property in properties){
            var value = $d5074f6a41fc61ab$var$getFunctionValue(properties[property], animatable);
            var target = animatable.target;
            var valueUnit = $d5074f6a41fc61ab$var$getUnit(value);
            var originalValue = $d5074f6a41fc61ab$var$getOriginalTargetValue(target, property, valueUnit, animatable);
            var unit = valueUnit || $d5074f6a41fc61ab$var$getUnit(originalValue);
            var to = $d5074f6a41fc61ab$var$getRelativeValue($d5074f6a41fc61ab$var$validateValue(value, unit), originalValue);
            var animType = $d5074f6a41fc61ab$var$getAnimationType(target, property);
            $d5074f6a41fc61ab$var$setProgressValue[animType](target, property, to, animatable.transforms, true);
        }
    });
}
// Animations
function $d5074f6a41fc61ab$var$createAnimation(animatable, prop) {
    var animType = $d5074f6a41fc61ab$var$getAnimationType(animatable.target, prop.name);
    if (animType) {
        var tweens = $d5074f6a41fc61ab$var$normalizeTweens(prop, animatable);
        var lastTween = tweens[tweens.length - 1];
        return {
            type: animType,
            property: prop.name,
            animatable: animatable,
            tweens: tweens,
            duration: lastTween.end,
            delay: tweens[0].delay,
            endDelay: lastTween.endDelay
        };
    }
}
function $d5074f6a41fc61ab$var$getAnimations(animatables, properties) {
    return $d5074f6a41fc61ab$var$filterArray($d5074f6a41fc61ab$var$flattenArray(animatables.map(function(animatable) {
        return properties.map(function(prop) {
            return $d5074f6a41fc61ab$var$createAnimation(animatable, prop);
        });
    })), function(a) {
        return !$d5074f6a41fc61ab$var$is.und(a);
    });
}
// Create Instance
function $d5074f6a41fc61ab$var$getInstanceTimings(animations, tweenSettings) {
    var animLength = animations.length;
    var getTlOffset = function(anim) {
        return anim.timelineOffset ? anim.timelineOffset : 0;
    };
    var timings = {};
    timings.duration = animLength ? Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration;
    })) : tweenSettings.duration;
    timings.delay = animLength ? Math.min.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.delay;
    })) : tweenSettings.delay;
    timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration - anim.endDelay;
    })) : tweenSettings.endDelay;
    return timings;
}
var $d5074f6a41fc61ab$var$instanceID = 0;
function $d5074f6a41fc61ab$var$createNewInstance(params) {
    var instanceSettings = $d5074f6a41fc61ab$var$replaceObjectProps($d5074f6a41fc61ab$var$defaultInstanceSettings, params);
    var tweenSettings = $d5074f6a41fc61ab$var$replaceObjectProps($d5074f6a41fc61ab$var$defaultTweenSettings, params);
    var properties = $d5074f6a41fc61ab$var$getProperties(tweenSettings, params);
    var animatables = $d5074f6a41fc61ab$var$getAnimatables(params.targets);
    var animations = $d5074f6a41fc61ab$var$getAnimations(animatables, properties);
    var timings = $d5074f6a41fc61ab$var$getInstanceTimings(animations, tweenSettings);
    var id = $d5074f6a41fc61ab$var$instanceID;
    $d5074f6a41fc61ab$var$instanceID++;
    return $d5074f6a41fc61ab$var$mergeObjects(instanceSettings, {
        id: id,
        children: [],
        animatables: animatables,
        animations: animations,
        duration: timings.duration,
        delay: timings.delay,
        endDelay: timings.endDelay
    });
}
// Core
var $d5074f6a41fc61ab$var$activeInstances = [];
var $d5074f6a41fc61ab$var$engine = function() {
    var raf;
    function play() {
        if (!raf && (!$d5074f6a41fc61ab$var$isDocumentHidden() || !$d5074f6a41fc61ab$var$anime.suspendWhenDocumentHidden) && $d5074f6a41fc61ab$var$activeInstances.length > 0) raf = requestAnimationFrame(step);
    }
    function step(t) {
        // memo on algorithm issue:
        // dangerous iteration over mutable `activeInstances`
        // (that collection may be updated from within callbacks of `tick`-ed animation instances)
        var activeInstancesLength = $d5074f6a41fc61ab$var$activeInstances.length;
        var i = 0;
        while(i < activeInstancesLength){
            var activeInstance = $d5074f6a41fc61ab$var$activeInstances[i];
            if (!activeInstance.paused) {
                activeInstance.tick(t);
                i++;
            } else {
                $d5074f6a41fc61ab$var$activeInstances.splice(i, 1);
                activeInstancesLength--;
            }
        }
        raf = i > 0 ? requestAnimationFrame(step) : undefined;
    }
    function handleVisibilityChange() {
        if (!$d5074f6a41fc61ab$var$anime.suspendWhenDocumentHidden) return;
        if ($d5074f6a41fc61ab$var$isDocumentHidden()) // suspend ticks
        raf = cancelAnimationFrame(raf);
        else {
            // first adjust animations to consider the time that ticks were suspended
            $d5074f6a41fc61ab$var$activeInstances.forEach(function(instance) {
                return instance._onDocumentVisibility();
            });
            $d5074f6a41fc61ab$var$engine();
        }
    }
    if (typeof document !== "undefined") document.addEventListener("visibilitychange", handleVisibilityChange);
    return play;
}();
function $d5074f6a41fc61ab$var$isDocumentHidden() {
    return !!document && document.hidden;
}
// Public Instance
function $d5074f6a41fc61ab$var$anime(params) {
    if (params === void 0) params = {};
    var startTime = 0, lastTime = 0, now = 0;
    var children, childrenLength = 0;
    var resolve = null;
    function makePromise(instance) {
        var promise = window.Promise && new Promise(function(_resolve) {
            return resolve = _resolve;
        });
        instance.finished = promise;
        return promise;
    }
    var instance = $d5074f6a41fc61ab$var$createNewInstance(params);
    var promise = makePromise(instance);
    function toggleInstanceDirection() {
        var direction = instance.direction;
        if (direction !== "alternate") instance.direction = direction !== "normal" ? "normal" : "reverse";
        instance.reversed = !instance.reversed;
        children.forEach(function(child) {
            return child.reversed = instance.reversed;
        });
    }
    function adjustTime(time) {
        return instance.reversed ? instance.duration - time : time;
    }
    function resetTime() {
        startTime = 0;
        lastTime = adjustTime(instance.currentTime) * (1 / $d5074f6a41fc61ab$var$anime.speed);
    }
    function seekChild(time, child) {
        if (child) child.seek(time - child.timelineOffset);
    }
    function syncInstanceChildren(time) {
        if (!instance.reversePlayback) for(var i = 0; i < childrenLength; i++)seekChild(time, children[i]);
        else for(var i$1 = childrenLength; i$1--;)seekChild(time, children[i$1]);
    }
    function setAnimationsProgress(insTime) {
        var i = 0;
        var animations = instance.animations;
        var animationsLength = animations.length;
        while(i < animationsLength){
            var anim = animations[i];
            var animatable = anim.animatable;
            var tweens = anim.tweens;
            var tweenLength = tweens.length - 1;
            var tween = tweens[tweenLength];
            // Only check for keyframes if there is more than one tween
            if (tweenLength) tween = $d5074f6a41fc61ab$var$filterArray(tweens, function(t) {
                return insTime < t.end;
            })[0] || tween;
            var elapsed = $d5074f6a41fc61ab$var$minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
            var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
            var strings = tween.to.strings;
            var round = tween.round;
            var numbers = [];
            var toNumbersLength = tween.to.numbers.length;
            var progress = void 0;
            for(var n = 0; n < toNumbersLength; n++){
                var value = void 0;
                var toNumber = tween.to.numbers[n];
                var fromNumber = tween.from.numbers[n] || 0;
                if (!tween.isPath) value = fromNumber + eased * (toNumber - fromNumber);
                else value = $d5074f6a41fc61ab$var$getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
                if (round) {
                    if (!(tween.isColor && n > 2)) value = Math.round(value * round) / round;
                }
                numbers.push(value);
            }
            // Manual Array.reduce for better performances
            var stringsLength = strings.length;
            if (!stringsLength) progress = numbers[0];
            else {
                progress = strings[0];
                for(var s = 0; s < stringsLength; s++){
                    var a = strings[s];
                    var b = strings[s + 1];
                    var n$1 = numbers[s];
                    if (!isNaN(n$1)) {
                        if (!b) progress += n$1 + " ";
                        else progress += n$1 + b;
                    }
                }
            }
            $d5074f6a41fc61ab$var$setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
            anim.currentValue = progress;
            i++;
        }
    }
    function setCallback(cb) {
        if (instance[cb] && !instance.passThrough) instance[cb](instance);
    }
    function countIteration() {
        if (instance.remaining && instance.remaining !== true) instance.remaining--;
    }
    function setInstanceProgress(engineTime) {
        var insDuration = instance.duration;
        var insDelay = instance.delay;
        var insEndDelay = insDuration - instance.endDelay;
        var insTime = adjustTime(engineTime);
        instance.progress = $d5074f6a41fc61ab$var$minMax(insTime / insDuration * 100, 0, 100);
        instance.reversePlayback = insTime < instance.currentTime;
        if (children) syncInstanceChildren(insTime);
        if (!instance.began && instance.currentTime > 0) {
            instance.began = true;
            setCallback("begin");
        }
        if (!instance.loopBegan && instance.currentTime > 0) {
            instance.loopBegan = true;
            setCallback("loopBegin");
        }
        if (insTime <= insDelay && instance.currentTime !== 0) setAnimationsProgress(0);
        if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) setAnimationsProgress(insDuration);
        if (insTime > insDelay && insTime < insEndDelay) {
            if (!instance.changeBegan) {
                instance.changeBegan = true;
                instance.changeCompleted = false;
                setCallback("changeBegin");
            }
            setCallback("change");
            setAnimationsProgress(insTime);
        } else if (instance.changeBegan) {
            instance.changeCompleted = true;
            instance.changeBegan = false;
            setCallback("changeComplete");
        }
        instance.currentTime = $d5074f6a41fc61ab$var$minMax(insTime, 0, insDuration);
        if (instance.began) setCallback("update");
        if (engineTime >= insDuration) {
            lastTime = 0;
            countIteration();
            if (!instance.remaining) {
                instance.paused = true;
                if (!instance.completed) {
                    instance.completed = true;
                    setCallback("loopComplete");
                    setCallback("complete");
                    if (!instance.passThrough && "Promise" in window) {
                        resolve();
                        promise = makePromise(instance);
                    }
                }
            } else {
                startTime = now;
                setCallback("loopComplete");
                instance.loopBegan = false;
                if (instance.direction === "alternate") toggleInstanceDirection();
            }
        }
    }
    instance.reset = function() {
        var direction = instance.direction;
        instance.passThrough = false;
        instance.currentTime = 0;
        instance.progress = 0;
        instance.paused = true;
        instance.began = false;
        instance.loopBegan = false;
        instance.changeBegan = false;
        instance.completed = false;
        instance.changeCompleted = false;
        instance.reversePlayback = false;
        instance.reversed = direction === "reverse";
        instance.remaining = instance.loop;
        children = instance.children;
        childrenLength = children.length;
        for(var i = childrenLength; i--;)instance.children[i].reset();
        if (instance.reversed && instance.loop !== true || direction === "alternate" && instance.loop === 1) instance.remaining++;
        setAnimationsProgress(instance.reversed ? instance.duration : 0);
    };
    // internal method (for engine) to adjust animation timings before restoring engine ticks (rAF)
    instance._onDocumentVisibility = resetTime;
    // Set Value helper
    instance.set = function(targets, properties) {
        $d5074f6a41fc61ab$var$setTargetsValue(targets, properties);
        return instance;
    };
    instance.tick = function(t) {
        now = t;
        if (!startTime) startTime = now;
        setInstanceProgress((now + (lastTime - startTime)) * $d5074f6a41fc61ab$var$anime.speed);
    };
    instance.seek = function(time) {
        setInstanceProgress(adjustTime(time));
    };
    instance.pause = function() {
        instance.paused = true;
        resetTime();
    };
    instance.play = function() {
        if (!instance.paused) return;
        if (instance.completed) instance.reset();
        instance.paused = false;
        $d5074f6a41fc61ab$var$activeInstances.push(instance);
        resetTime();
        $d5074f6a41fc61ab$var$engine();
    };
    instance.reverse = function() {
        toggleInstanceDirection();
        instance.completed = instance.reversed ? false : true;
        resetTime();
    };
    instance.restart = function() {
        instance.reset();
        instance.play();
    };
    instance.remove = function(targets) {
        var targetsArray = $d5074f6a41fc61ab$var$parseTargets(targets);
        $d5074f6a41fc61ab$var$removeTargetsFromInstance(targetsArray, instance);
    };
    instance.reset();
    if (instance.autoplay) instance.play();
    return instance;
}
// Remove targets from animation
function $d5074f6a41fc61ab$var$removeTargetsFromAnimations(targetsArray, animations) {
    for(var a = animations.length; a--;)if ($d5074f6a41fc61ab$var$arrayContains(targetsArray, animations[a].animatable.target)) animations.splice(a, 1);
}
function $d5074f6a41fc61ab$var$removeTargetsFromInstance(targetsArray, instance) {
    var animations = instance.animations;
    var children = instance.children;
    $d5074f6a41fc61ab$var$removeTargetsFromAnimations(targetsArray, animations);
    for(var c = children.length; c--;){
        var child = children[c];
        var childAnimations = child.animations;
        $d5074f6a41fc61ab$var$removeTargetsFromAnimations(targetsArray, childAnimations);
        if (!childAnimations.length && !child.children.length) children.splice(c, 1);
    }
    if (!animations.length && !children.length) instance.pause();
}
function $d5074f6a41fc61ab$var$removeTargetsFromActiveInstances(targets) {
    var targetsArray = $d5074f6a41fc61ab$var$parseTargets(targets);
    for(var i = $d5074f6a41fc61ab$var$activeInstances.length; i--;){
        var instance = $d5074f6a41fc61ab$var$activeInstances[i];
        $d5074f6a41fc61ab$var$removeTargetsFromInstance(targetsArray, instance);
    }
}
// Stagger helpers
function $d5074f6a41fc61ab$var$stagger(val, params) {
    if (params === void 0) params = {};
    var direction = params.direction || "normal";
    var easing = params.easing ? $d5074f6a41fc61ab$var$parseEasings(params.easing) : null;
    var grid = params.grid;
    var axis = params.axis;
    var fromIndex = params.from || 0;
    var fromFirst = fromIndex === "first";
    var fromCenter = fromIndex === "center";
    var fromLast = fromIndex === "last";
    var isRange = $d5074f6a41fc61ab$var$is.arr(val);
    var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
    var val2 = isRange ? parseFloat(val[1]) : 0;
    var unit = $d5074f6a41fc61ab$var$getUnit(isRange ? val[1] : val) || 0;
    var start = params.start || 0 + (isRange ? val1 : 0);
    var values = [];
    var maxValue = 0;
    return function(el, i, t) {
        if (fromFirst) fromIndex = 0;
        if (fromCenter) fromIndex = (t - 1) / 2;
        if (fromLast) fromIndex = t - 1;
        if (!values.length) {
            for(var index = 0; index < t; index++){
                if (!grid) values.push(Math.abs(fromIndex - index));
                else {
                    var fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
                    var fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
                    var toX = index % grid[0];
                    var toY = Math.floor(index / grid[0]);
                    var distanceX = fromX - toX;
                    var distanceY = fromY - toY;
                    var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                    if (axis === "x") value = -distanceX;
                    if (axis === "y") value = -distanceY;
                    values.push(value);
                }
                maxValue = Math.max.apply(Math, values);
            }
            if (easing) values = values.map(function(val) {
                return easing(val / maxValue) * maxValue;
            });
            if (direction === "reverse") values = values.map(function(val) {
                return axis ? val < 0 ? val * -1 : -val : Math.abs(maxValue - val);
            });
        }
        var spacing = isRange ? (val2 - val1) / maxValue : val1;
        return start + spacing * (Math.round(values[i] * 100) / 100) + unit;
    };
}
// Timeline
function $d5074f6a41fc61ab$var$timeline(params) {
    if (params === void 0) params = {};
    var tl = $d5074f6a41fc61ab$var$anime(params);
    tl.duration = 0;
    tl.add = function(instanceParams, timelineOffset) {
        var tlIndex = $d5074f6a41fc61ab$var$activeInstances.indexOf(tl);
        var children = tl.children;
        if (tlIndex > -1) $d5074f6a41fc61ab$var$activeInstances.splice(tlIndex, 1);
        function passThrough(ins) {
            ins.passThrough = true;
        }
        for(var i = 0; i < children.length; i++)passThrough(children[i]);
        var insParams = $d5074f6a41fc61ab$var$mergeObjects(instanceParams, $d5074f6a41fc61ab$var$replaceObjectProps($d5074f6a41fc61ab$var$defaultTweenSettings, params));
        insParams.targets = insParams.targets || params.targets;
        var tlDuration = tl.duration;
        insParams.autoplay = false;
        insParams.direction = tl.direction;
        insParams.timelineOffset = $d5074f6a41fc61ab$var$is.und(timelineOffset) ? tlDuration : $d5074f6a41fc61ab$var$getRelativeValue(timelineOffset, tlDuration);
        passThrough(tl);
        tl.seek(insParams.timelineOffset);
        var ins = $d5074f6a41fc61ab$var$anime(insParams);
        passThrough(ins);
        children.push(ins);
        var timings = $d5074f6a41fc61ab$var$getInstanceTimings(children, params);
        tl.delay = timings.delay;
        tl.endDelay = timings.endDelay;
        tl.duration = timings.duration;
        tl.seek(0);
        tl.reset();
        if (tl.autoplay) tl.play();
        return tl;
    };
    return tl;
}
$d5074f6a41fc61ab$var$anime.version = "3.2.1";
$d5074f6a41fc61ab$var$anime.speed = 1;
// TODO:#review: naming, documentation
$d5074f6a41fc61ab$var$anime.suspendWhenDocumentHidden = true;
$d5074f6a41fc61ab$var$anime.running = $d5074f6a41fc61ab$var$activeInstances;
$d5074f6a41fc61ab$var$anime.remove = $d5074f6a41fc61ab$var$removeTargetsFromActiveInstances;
$d5074f6a41fc61ab$var$anime.get = $d5074f6a41fc61ab$var$getOriginalTargetValue;
$d5074f6a41fc61ab$var$anime.set = $d5074f6a41fc61ab$var$setTargetsValue;
$d5074f6a41fc61ab$var$anime.convertPx = $d5074f6a41fc61ab$var$convertPxToUnit;
$d5074f6a41fc61ab$var$anime.path = $d5074f6a41fc61ab$var$getPath;
$d5074f6a41fc61ab$var$anime.setDashoffset = $d5074f6a41fc61ab$var$setDashoffset;
$d5074f6a41fc61ab$var$anime.stagger = $d5074f6a41fc61ab$var$stagger;
$d5074f6a41fc61ab$var$anime.timeline = $d5074f6a41fc61ab$var$timeline;
$d5074f6a41fc61ab$var$anime.easing = $d5074f6a41fc61ab$var$parseEasings;
$d5074f6a41fc61ab$var$anime.penner = $d5074f6a41fc61ab$var$penner;
$d5074f6a41fc61ab$var$anime.random = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
var $d5074f6a41fc61ab$export$2e2bcd8739ae039 = $d5074f6a41fc61ab$var$anime;


function $5840d364b7df7ca4$export$62f76462b494bd4d() {
    return !window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
}



let $9ec512fce550e4ea$var$defaults = {
    start: "0 1",
    end: "1 0",
    onUpdate () {},
    onExitForward () {},
    onExitBackward () {},
    onEnterForward () {},
    onEnterBackward () {}
};
let $9ec512fce550e4ea$var$eventOptions = (0, $728cbab38740dbe7$export$b0622a6911dbeaf5)() ? {
    passive: true
} : false;
function $9ec512fce550e4ea$export$875bcbe48555930(element, options) {
    let config = {
        ...$9ec512fce550e4ea$var$defaults,
        ...options
    };
    let { start: start, end: end } = config;
    let viewport = document.documentElement;
    let elementRect = getBoundingRect(element);
    let endPoint = getTriggerPoint(end, viewport, element);
    let startPoint = getTriggerPoint(start, viewport, element);
    let entry = getScrollTriggerEntry(getScrollPosition());
    checkScroll();
    window.addEventListener("resize", resize, $9ec512fce550e4ea$var$eventOptions);
    document.addEventListener("scroll", checkScroll, $9ec512fce550e4ea$var$eventOptions);
    function checkScroll() {
        let scrollY = getScrollPosition();
        let { isAboveViewport: wasAboveViewport, isBelowViewport: wasBelowViewport } = entry;
        let { isAboveViewport: isAboveViewport, isBelowViewport: isBelowViewport } = entry = getScrollTriggerEntry(scrollY);
        if (wasBelowViewport && !isBelowViewport) triggerCallback("onEnterForward");
        if (!wasAboveViewport && isAboveViewport) triggerCallback("onExitForward");
        if (wasAboveViewport && !isAboveViewport) triggerCallback("onEnterBackward");
        if (!wasBelowViewport && isBelowViewport) triggerCallback("onExitBackward");
        if (scrollY >= startPoint.scrollY && scrollY <= endPoint.scrollY) triggerCallback("onUpdate");
    }
    function getScrollPosition() {
        return window.scrollY || document.documentElement.scrollTop;
    }
    function triggerCallback(name) {
        config[name](entry);
    }
    function getScrollTriggerEntry(scrollY) {
        let rect = getVisibleRect();
        return {
            visibleRect: rect,
            isVisible: rect.height > 0,
            isAboveViewport: scrollY > endPoint.scrollY,
            isBelowViewport: scrollY < startPoint.scrollY,
            ratio: rect.height / elementRect.height,
            progress: getProgress()
        };
        function getProgress() {
            if (scrollY <= startPoint.scrollY) return 0;
            else if (scrollY >= endPoint.scrollY) return 1;
            else return (scrollY - startPoint.scrollY) / (endPoint.scrollY - startPoint.scrollY);
        }
        function getVisibleRect() {
            let rect = {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: 0,
                height: 0
            };
            if (scrollY < startPoint.scrollY || scrollY > endPoint.scrollY) return rect;
            let vT = scrollY;
            let vB = viewport.clientHeight + scrollY;
            let rT = elementRect.topOffset;
            let rB = elementRect.bottomOffset;
            rect.top = Math.max(vT, rT);
            rect.bottom = Math.min(vB, rB);
            rect.left = elementRect.left;
            rect.right = elementRect.right;
            rect.width = elementRect.width;
            rect.height = rect.bottom - rect.top;
            return rect;
        }
    }
    function getBoundingRect(element) {
        let scrollY = getScrollPosition();
        let rect = element.getBoundingClientRect();
        rect["topOffset"] = rect.top + scrollY;
        rect["bottomOffset"] = rect.bottom + scrollY;
        return rect;
    }
    function resize() {
        elementRect = getBoundingRect(element);
        endPoint = getTriggerPoint(end, viewport, element);
        startPoint = getTriggerPoint(start, viewport, element);
        checkScroll();
    }
    function enable() {
        window.addEventListener("resize", resize, $9ec512fce550e4ea$var$eventOptions);
        document.addEventListener("scroll", checkScroll, $9ec512fce550e4ea$var$eventOptions);
    }
    function disable() {
        window.removeEventListener("resize", resize, $9ec512fce550e4ea$var$eventOptions);
        document.removeEventListener("scroll", checkScroll, $9ec512fce550e4ea$var$eventOptions);
    }
    function getTriggerPoint(value, viewport, element) {
        let parts = value.split(" ");
        let viewportHeight = viewport.clientHeight;
        let elementRect = element.getBoundingClientRect();
        let elementTop = elementRect.top + getScrollPosition();
        let elementOffset = elementRect.height * parts[0];
        let viewportOffset = viewportHeight * parts[1];
        return {
            viewport: viewportOffset,
            element: elementTop + elementOffset,
            scrollY: elementTop + elementOffset + (1 - viewportOffset)
        };
    }
    return {
        enable: enable,
        disable: disable
    };
}


function $b613fbde0dfc41de$export$2beb1a7260fb8d07() {
    if ((0, $5840d364b7df7ca4$export$62f76462b494bd4d)()) return;
    Array.from(document.querySelectorAll(".c-block-a")).forEach((e)=>$b613fbde0dfc41de$var$create(e));
}
function $b613fbde0dfc41de$var$create(element) {
    let played = false;
    let media = element.querySelector(".c-block-a__media");
    let content = element.querySelector(".c-block-a__content");
    (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).set(media, {
        opacity: 0
    });
    (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).set(content, {
        opacity: 0,
        translateY: "10%"
    });
    let animation = (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).timeline({
        autoplay: false,
        easing: "easeInQuad"
    }).add({
        targets: media,
        duration: 600,
        opacity: 1
    }).add({
        targets: content,
        duration: 1000,
        opacity: 1,
        translateY: 0
    }, 0);
    (0, $9ec512fce550e4ea$export$875bcbe48555930)(element, {
        start: "0.2 1",
        onUpdate: onUpdate
    });
    function onUpdate(entry) {
        if (played || !entry.isVisible) return;
        played = true;
        animation.play();
    }
}




function $aae6fa0829563c82$export$54ccdbbe83e316ef() {
    let header = document.querySelector(".a-homepage .c-header");
    let media = document.querySelector(".a-homepage .c-hero__media");
    let content = document.querySelector(".a-homepage .c-hero__content");
    if (!header || !media || !content) return;
    let animation = (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).timeline({
        easing: "easeInQuad",
        autoplay: false
    }).add({
        targets: ".c-header",
        delay: 300,
        duration: 600,
        opacity: 1
    }).add({
        targets: media,
        opacity: 1,
        duration: 1000
    }, "+=100").add({
        targets: content,
        opacity: 1,
        duration: 600,
        translateY: [
            "20%",
            "0%"
        ]
    }, "+=300");
    if (!(0, $5840d364b7df7ca4$export$62f76462b494bd4d)()) animation.play();
    else animation.seek(1 * animation.duration);
}






function $eedc8cbf9aa3f3ef$export$b8ec3d2580fbba02() {
    (0, $bf76b386537e82d7$export$84bf76cd7afc7469)(".c-hero-x-sell").forEach((element)=>{
        let style = window.getComputedStyle(element);
        let mediaQueryString = style.getPropertyValue("--parallax");
        if (!mediaQueryString || (0, $5840d364b7df7ca4$export$62f76462b494bd4d)()) return;
        let mediaQuery = window.matchMedia(mediaQueryString);
        let content = (0, $bf76b386537e82d7$export$80bf7733f1207381)(".c-hero-x-sell__content", element);
        let parallax = (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
            targets: content,
            autoplay: false,
            duration: 100,
            easing: "linear",
            translateY: [
                "100%",
                "-100%"
            ]
        });
        let trigger = (0, $9ec512fce550e4ea$export$875bcbe48555930)(element, {
            onUpdate (entry) {
                parallax.seek(entry.progress * parallax.duration);
            }
        });
        testMq();
        mediaQuery.addListener(testMq);
        function testMq() {
            if (mediaQuery.matches) return trigger.enable();
            trigger.disable();
            // Halfway the translate will 0.
            parallax.seek(0.5 * parallax.duration);
        }
    });
}


function $33dde29d418793f4$export$2cd8252107eb640b() {
    if (typeof FontLoader === "undefined") _init();
    else FontLoader.then(()=>_init());
    function _init() {
        (0, $b613fbde0dfc41de$export$2beb1a7260fb8d07)();
        (0, $aae6fa0829563c82$export$54ccdbbe83e316ef)();
        (0, $eedc8cbf9aa3f3ef$export$b8ec3d2580fbba02)();
    }
}


function $e2e038d4180de51b$export$7d15b64cf5a3a4c4(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}


const $9d9a4a02115a6bf3$var$elements = Array.from(document.querySelectorAll(".js-spinbutton"));
function $9d9a4a02115a6bf3$export$2cd8252107eb640b() {
    $9d9a4a02115a6bf3$var$elements.forEach((element)=>$9d9a4a02115a6bf3$var$create(element));
}
const $9d9a4a02115a6bf3$export$12d555061d854ced = {};
function $9d9a4a02115a6bf3$var$create(element) {
    let timer;
    let currentValue;
    let input = element.querySelector("input");
    let incrementButton = document.createElement("button");
    let decrementButton = document.createElement("button");
    change(input.value);
    incrementButton.setAttribute("type", "button");
    decrementButton.setAttribute("type", "button");
    incrementButton.setAttribute("tabindex", "-1");
    decrementButton.setAttribute("tabindex", "-1");
    incrementButton.classList.add("c-spinbutton__increment");
    decrementButton.classList.add("c-spinbutton__decrement");
    incrementButton.addEventListener("mousedown", ()=>autoChange(1));
    decrementButton.addEventListener("mousedown", ()=>autoChange(-1));
    incrementButton.addEventListener("mouseup", clearTimer);
    decrementButton.addEventListener("mouseup", clearTimer);
    incrementButton.addEventListener("mouseout", clearTimer);
    decrementButton.addEventListener("mouseout", clearTimer);
    function autoChange(amount) {
        change(Number(input.value) + amount);
        timer = setTimeout(()=>{
            clearTimeout(timer);
            timer = setInterval(()=>change(Number(input.value) + amount), 100);
        }, 300);
    }
    function clearTimer() {
        clearTimeout(timer);
        clearInterval(timer);
    }
    element.append(incrementButton);
    element.prepend(decrementButton);
    input.setAttribute("pattern", "[0-9]*");
    input.setAttribute("inputmode", "numeric");
    input.setAttribute("autocomplete", "off");
    input.setAttribute("aria-role", "spinbutton");
    input.setAttribute("aria-valuemin", element.dataset.min);
    input.setAttribute("aria-valuemax", element.dataset.max);
    input.addEventListener("keydown", handleKeydown);
    input.addEventListener("blur", ()=>change(input.value));
    input.addEventListener("input", ()=>{
        // User might be trying to clear input so lets stop interfering
        if (input.value === "") return;
        change(input.value);
    });
    function increment(step = 1) {
        change(currentValue + step);
    }
    function decrement(step = 1) {
        change(currentValue - step);
    }
    function setMin(value) {
        element.dataset.min = value;
        input.setAttribute("aria-valuemin", element.dataset.min);
        change(input.value);
    }
    function setMax(value) {
        element.dataset.max = value;
        input.setAttribute("aria-valuemax", element.dataset.max);
        change(input.value);
    }
    function change(value) {
        if (input.disabled) return;
        if (typeof value == "string") value = value.replace(/\D/g, "");
        if (value === "") value = element.dataset.default;
        value = (0, $e2e038d4180de51b$export$7d15b64cf5a3a4c4)(Number(value), Number(element.dataset.min), Number(element.dataset.max));
        decrementButton.classList.toggle("is-disabled", value == element.dataset.min);
        incrementButton.classList.toggle("is-disabled", value == element.dataset.max);
        currentValue = value;
        input.value = currentValue;
        input.setAttribute("aria-valuenow", currentValue);
        let event = new Event("spinbutton:change");
        input.dispatchEvent(event);
    }
    function handleKeydown(event) {
        if (event.key === "ArrowUp") {
            increment();
            event.preventDefault();
        }
        if (event.key === "ArrowDown") {
            decrement();
            event.preventDefault();
        }
        if (event.key === "End") {
            event.preventDefault();
            change(Number(element.dataset.max));
        }
        if (event.key === "Home") {
            event.preventDefault();
            change(Number(element.dataset.min));
        }
    }
    $9d9a4a02115a6bf3$export$12d555061d854ced[input.id] = {
        setMin: setMin,
        setMax: setMax,
        setValue: change
    };
}


function $e108066b85995f38$export$c8a8987d4410bf2d(element) {
    return document.createElement(element);
}


/**
 * Splits an array into sub arrays.
 *
 * @param {array} array Array to chunk
 * @param {number} size Size of the chunk
 */ function $faa29fed8a8b4f74$export$5f7ec48d69707ddd(array, size) {
    let chunks = [];
    let i = 0;
    let n = array.length;
    while(i < n)chunks.push(array.slice(i, i += size));
    return chunks;
}
function $faa29fed8a8b4f74$export$43128fadae87b74a(array) {
    return array && array.length ? array[0] : undefined;
}
function $faa29fed8a8b4f74$export$4c7897fafd92b108(array) {
    let length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
function $faa29fed8a8b4f74$export$d0c8ecbd4ed8940c(value) {
    if (Array.isArray(value)) return value;
    else return [
        value
    ];
}


function $89cf0c53e889b57d$export$a6cdc56e425d0d0a(value) {
    if (value === null) return false;
    return typeof value === "object";
}
function $89cf0c53e889b57d$export$c615a4d8c3fee905(object, path, value) {
    let ref = object;
    let keys = path.split(".");
    for(let i = 0; i < keys.length; i++){
        let key = keys[i];
        if (i !== keys.length - 1) ref = ref[key] || {};
        else ref = ref[key] = value;
    }
    return object;
}
function $89cf0c53e889b57d$export$4370d69198e9314a(property) {
    return property.replace(/([A-Z])/g, "-$1").toLowerCase();
}


function $78d3e8b7d5e47526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78d3e8b7d5e47526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78d3e8b7d5e47526$export$2e2bcd8739ae039(o);
}


function $b320e4b5494ae3f6$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $2285621ea3fa8491$export$2e2bcd8739ae039(argument) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $e186b8b389b84e48$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $f66cd00649fade9f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}



function $9ff66a5d682467d6$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var time = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $c0d321040488d36f$export$dfd9b671c89acc8e = 7;
var $c0d321040488d36f$export$3913210603d8e9ae = 365.2425;
var $c0d321040488d36f$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $c0d321040488d36f$export$91246f0b9bd9beff = 60000;
var $c0d321040488d36f$export$7f72910d6dfd237a = 3600000;
var $c0d321040488d36f$export$397c2d5776aa9055 = 1000;
var $c0d321040488d36f$export$4dec998e48f9c246 = -$c0d321040488d36f$export$81caae6e1cc7a622;
var $c0d321040488d36f$export$f2f5ae5a8e2d8f9f = 60;
var $c0d321040488d36f$export$3c58128db900d44e = 3;
var $c0d321040488d36f$export$80d7e435f744f319 = 12;
var $c0d321040488d36f$export$4db7641526e3241f = 4;
var $c0d321040488d36f$export$698aec755e92c695 = 3600;
var $c0d321040488d36f$export$a77c1a7ebebe2a5a = 60;
var $c0d321040488d36f$export$815a9362476d2fe3 = $c0d321040488d36f$export$698aec755e92c695 * 24;
var $c0d321040488d36f$export$34804a017b31e2fe = $c0d321040488d36f$export$815a9362476d2fe3 * 7;
var $c0d321040488d36f$export$7271e9e3478110d1 = $c0d321040488d36f$export$815a9362476d2fe3 * $c0d321040488d36f$export$3913210603d8e9ae;
var $c0d321040488d36f$export$8e6600bbdee7dabb = $c0d321040488d36f$export$7271e9e3478110d1 / 12;
var $c0d321040488d36f$export$be1dccf2de902d31 = $c0d321040488d36f$export$8e6600bbdee7dabb * 3;


function $500b4253bc9fbade$var$testBoolean(value) {
    if (typeof value !== "boolean") return false;
    return value;
}
function $500b4253bc9fbade$var$testDate(date, value) {
    if (!(value instanceof Date)) return false;
    return (0, $f66cd00649fade9f$export$2e2bcd8739ae039)(date, value);
}
function $500b4253bc9fbade$var$testFunction(date, value) {
    if (typeof value !== "function") return;
    return value(date);
}
function $500b4253bc9fbade$var$isStartDate(date, value) {
    if (value === undefined || !(0, $89cf0c53e889b57d$export$a6cdc56e425d0d0a)(value) || !("from" in value)) return false;
    return $500b4253bc9fbade$var$testDate(date, value.from);
}
function $500b4253bc9fbade$var$isEndDate(date, value) {
    if (value === undefined || !(0, $89cf0c53e889b57d$export$a6cdc56e425d0d0a)(value) || !("to" in value)) return false;
    return $500b4253bc9fbade$var$testDate(date, value.to);
}
function $500b4253bc9fbade$var$testRange(date, value) {
    if (value === undefined || !(0, $89cf0c53e889b57d$export$a6cdc56e425d0d0a)(value) || !("from" in value) && !("to" in value)) return false;
    let after = true;
    let before = true;
    if (!value.from && !value.to) return false;
    if (value.from !== undefined) after = (0, $9ff66a5d682467d6$export$2e2bcd8739ae039)(date, {
        start: value.from,
        end: (0, $c0d321040488d36f$export$81caae6e1cc7a622)
    });
    if (value.to !== undefined) before = (0, $9ff66a5d682467d6$export$2e2bcd8739ae039)(date, {
        start: (0, $c0d321040488d36f$export$4dec998e48f9c246),
        end: value.to
    });
    return before && after;
}
function $500b4253bc9fbade$export$c75b394c7bb60e7e(date, dates) {
    let tests = (0, $faa29fed8a8b4f74$export$d0c8ecbd4ed8940c)(dates);
    let matches = tests.some((value)=>{
        return $500b4253bc9fbade$var$testBoolean(value) || $500b4253bc9fbade$var$testDate(date, value) || $500b4253bc9fbade$var$testRange(date, value) || $500b4253bc9fbade$var$testFunction(date, value);
    });
    return {
        matches: matches,
        isEnd: tests.some((value)=>$500b4253bc9fbade$var$isEndDate(date, value)),
        isStart: tests.some((value)=>$500b4253bc9fbade$var$isStartDate(date, value))
    };
}





function $fe9da62f9bebba04$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}



function $11e0888ce93790e3$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}



function $1b1a5c4dabfd9a23$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}



function $50fed5e925715bd4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    return (0, $f66cd00649fade9f$export$2e2bcd8739ae039)(dirtyDate, Date.now());
}


let $67ce65454bc85ba2$var$defaults = {
    today: (0, $50fed5e925715bd4$export$2e2bcd8739ae039),
    hidden: false,
    outside: false,
    disabled: false,
    selected: false
};
function $67ce65454bc85ba2$export$8fd03b29ab57a08f(date, month, config) {
    let modifiers = {
        ...$67ce65454bc85ba2$var$defaults,
        ...config.modifiers
    };
    modifiers.disabled = [
        (date)=>(0, $fe9da62f9bebba04$export$2e2bcd8739ae039)(date, config.maxDate),
        (date)=>(0, $11e0888ce93790e3$export$2e2bcd8739ae039)(date, config.minDate)
    ];
    modifiers.outside = !(0, $1b1a5c4dabfd9a23$export$2e2bcd8739ae039)(date, month);
    modifiers.hidden = modifiers.outside && !config.showOutsideDays;
    for (let [key, value] of Object.entries(modifiers)){
        let { matches: matches, isStart: isStart, isEnd: isEnd } = (0, $500b4253bc9fbade$export$c75b394c7bb60e7e)(date, value);
        modifiers[key] = matches;
        if (isEnd) modifiers[key + "End"] = true;
        if (isStart) modifiers[key + "Start"] = true;
    }
    return modifiers;
}
function $67ce65454bc85ba2$export$aeca4cd84e0bb2a4(modifiers, classNames) {
    let classes = [
        classNames.day
    ];
    for (let [key, value] of Object.entries(modifiers)){
        if (!value) continue;
        if (Object.prototype.hasOwnProperty.call(classNames, key)) classes.push(classNames[key]);
        else classes.push((0, $89cf0c53e889b57d$export$4370d69198e9314a)(key));
    }
    return classes;
}


function $3b8926a85ac1848e$export$7a9a31a911eb9a20(date, month, config) {
    let td = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("td");
    let button = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("button");
    let modifiers = (0, $67ce65454bc85ba2$export$8fd03b29ab57a08f)(date, month, config);
    function focus() {
        button.focus();
        enableKeyboardFocus();
    }
    function blur() {
        button.blur();
        disableKeyboardFocus();
    }
    function enableKeyboardFocus() {
        button.setAttribute("tabindex", "0");
    }
    function disableKeyboardFocus() {
        button.setAttribute("tabindex", "-1");
    }
    function render() {
        let tabIndex = modifiers.today ? "0" : "-1";
        td.className = (0, $67ce65454bc85ba2$export$aeca4cd84e0bb2a4)(modifiers, config.classes).join(" ");
        td.setAttribute("role", "gridcell");
        if (!modifiers.hidden) td.append(button);
        button.className = config.classes.dayButton;
        button.setAttribute("type", "button");
        button.setAttribute("tabindex", tabIndex);
        button.setAttribute("aria-hidden", modifiers.hidden);
        button.setAttribute("aria-disabled", modifiers.disabled);
        button.setAttribute("aria-selected", modifiers.selected);
        button.addEventListener("click", handleClick);
        button.addEventListener("focus", handleFocus);
        button.addEventListener("keydown", handleKeydown);
        button.innerHTML = date.getDate();
        if (!modifiers.hidden) td.append(button);
        function handleFocus(event) {
            let focus = new CustomEvent("dayFocus", {
                bubbles: true,
                detail: {
                    ...day,
                    event: event
                }
            });
            event.target.dispatchEvent(focus);
        }
        function handleClick(event) {
            if (modifiers.disabled) return event.stopPropagation();
            let click = new CustomEvent("dayClick", {
                bubbles: true,
                detail: {
                    ...day,
                    event: event
                }
            });
            event.stopPropagation();
            event.target.dispatchEvent(click);
        }
        function handleKeydown(event) {
            let keys = [
                "ArrowUp",
                "ArrowDown",
                "ArrowLeft",
                "ArrowRight"
            ];
            let keydown = new CustomEvent("dayKeydown", {
                bubbles: true,
                detail: {
                    ...day,
                    event: event
                }
            });
            if (keys.includes(event.key)) event.preventDefault();
            event.target.dispatchEvent(keydown);
        }
        return td;
    }
    let day = {
        date: date,
        blur: blur,
        focus: focus,
        render: render,
        modifiers: modifiers,
        element: button,
        enableKeyboardFocus: enableKeyboardFocus,
        disableKeyboardFocus: disableKeyboardFocus
    };
    for (const [key, value] of Object.entries(config)){
        if (key[0] !== "o" && key[1] !== "n") continue;
        // todo add a check to see if it's a valid event name
        let name = key.toLowerCase().slice(2);
        button.addEventListener(name, (event)=>value(day, event));
    }
    return day;
}




const $5856e358a916d87e$export$ac6bf0d1b953e7f8 = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $5856e358a916d87e$export$2e59fa295abca125 = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $5856e358a916d87e$export$c905be7fba5c07b7 = 7;
const $5856e358a916d87e$export$930f21d9195dcda7 = 6;


function $e988ad2ce58d9c6e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $9260a9ed67d17426$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}



function $a662b26130678ea8$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
    while(currentDate.getTime() <= endTime){
        dates.push((0, $2285621ea3fa8491$export$2e2bcd8739ae039)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}



function $1da06aa14904949d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

var $bac751230e4fc222$var$defaultOptions = {};
function $bac751230e4fc222$export$430a3269e24b912e() {
    return $bac751230e4fc222$var$defaultOptions;
}
function $bac751230e4fc222$export$95365be1b0704abc(newOptions) {
    $bac751230e4fc222$var$defaultOptions = newOptions;
}





function $c6b1a6da55ca19a0$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $bac751230e4fc222$export$430a3269e24b912e)();
    var weekStartsOn = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}





function $6f841cfcdd03d288$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $bac751230e4fc222$export$430a3269e24b912e)();
    var weekStartsOn = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $34df346d5c5052d9$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}



var $86a7ce153407e07b$var$MILLISECONDS_IN_WEEK = 604800000;
function $86a7ce153407e07b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var startOfWeekLeft = (0, $6f841cfcdd03d288$export$2e2bcd8739ae039)(dirtyDateLeft, options);
    var startOfWeekRight = (0, $6f841cfcdd03d288$export$2e2bcd8739ae039)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $34df346d5c5052d9$export$2e2bcd8739ae039)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $34df346d5c5052d9$export$2e2bcd8739ae039)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $86a7ce153407e07b$var$MILLISECONDS_IN_WEEK);
}




function $bc7ca23f54715bd6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $0b5a5175ac65e18c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $c05117f00daad42f$export$2e2bcd8739ae039(date, options) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    return (0, $86a7ce153407e07b$export$2e2bcd8739ae039)((0, $bc7ca23f54715bd6$export$2e2bcd8739ae039)(date), (0, $0b5a5175ac65e18c$export$2e2bcd8739ae039)(date), options) + 1;
}


function $df014fd766c47089$export$5f84d4e06c0693c4(month, weekStartsOn, fixedWeeks) {
    let lastDayOfMonth = (0, $1da06aa14904949d$export$2e2bcd8739ae039)(month);
    let firstDayOfMonth = (0, $0b5a5175ac65e18c$export$2e2bcd8739ae039)(month);
    let weeksInMonth = (0, $c05117f00daad42f$export$2e2bcd8739ae039)(month, {
        weekStartsOn: weekStartsOn
    });
    let dates = (0, $a662b26130678ea8$export$2e2bcd8739ae039)({
        end: (0, $c6b1a6da55ca19a0$export$2e2bcd8739ae039)(lastDayOfMonth, {
            weekStartsOn: weekStartsOn
        }),
        start: (0, $6f841cfcdd03d288$export$2e2bcd8739ae039)(firstDayOfMonth, {
            weekStartsOn: weekStartsOn
        })
    });
    if (fixedWeeks && weeksInMonth < (0, $5856e358a916d87e$export$930f21d9195dcda7)) {
        let currentNumberOfDays = dates.length;
        let requiredNumberOfDays = (0, $5856e358a916d87e$export$c905be7fba5c07b7) * (0, $5856e358a916d87e$export$930f21d9195dcda7);
        let numberOfDaysToAdd = requiredNumberOfDays - currentNumberOfDays;
        let lastDate = (0, $faa29fed8a8b4f74$export$4c7897fafd92b108)(dates);
        dates.push(...(0, $a662b26130678ea8$export$2e2bcd8739ae039)({
            start: (0, $9260a9ed67d17426$export$2e2bcd8739ae039)(lastDate, 1),
            end: (0, $9260a9ed67d17426$export$2e2bcd8739ae039)(lastDate, numberOfDaysToAdd)
        }));
    }
    return dates;
}


/**
 * Gets an array of adjusted weekdays names for a given start day.
 *
 * @param {array} names Array of weekday names, the first value being Sunday.
 * @param {number} start The first day of the week, 0 being Sunday.
 */ function $ba19adeba24f5e4d$export$d03409b923543a08(names, start = 0) {
    return [
        ...names.slice(start),
        ...names.slice(0, start)
    ];
}




function $0332e0457981f2c2$export$951c8378cdfec6e6(month, config) {
    let { fixedWeeks: fixedWeeks, weekStartsOn: weekStartsOn } = config;
    let dates = (0, $df014fd766c47089$export$5f84d4e06c0693c4)(month, weekStartsOn, fixedWeeks);
    let days = dates.map((date)=>(0, $3b8926a85ac1848e$export$7a9a31a911eb9a20)(date, month, config));
    function render() {
        let header = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("div");
        let wrapper = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("div");
        let table = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("table");
        header.className = config.classes.header;
        wrapper.className = config.classes.month;
        table.setAttribute("role", "grid");
        header.textContent = formatCaption(month);
        let head = createHead(weekStartsOn);
        let rows = (0, $faa29fed8a8b4f74$export$5f7ec48d69707ddd)(days, 7).map((week)=>{
            let row = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("tr");
            row.className = config.classes.week;
            row.append(...week.map((day)=>day.render()));
            return row;
        });
        table.append(head, ...rows);
        wrapper.append(header, table);
        return wrapper;
    }
    function formatCaption(date) {
        return `${(0, $5856e358a916d87e$export$2e59fa295abca125)[date.getMonth()]} ${date.getFullYear()}`;
    }
    function createHead(weekStartsOn) {
        let row = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("tr");
        let head = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("thead");
        (0, $ba19adeba24f5e4d$export$d03409b923543a08)((0, $5856e358a916d87e$export$ac6bf0d1b953e7f8), weekStartsOn).forEach((day)=>{
            let th = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("th");
            th.scope = "col";
            th.textContent = day;
            th.className = config.classes.dayName;
            row.append(th);
        });
        head.append(row);
        return head;
    }
    return {
        days: days,
        month: month,
        render: render
    };
}



const $cd5cb10b23b08281$export$ebe90cb607ad99e = {
    container: undefined,
    date: new Date(),
    minDate: new Date(),
    maxDate: new Date((0, $c0d321040488d36f$export$81caae6e1cc7a622)),
    modifiers: {},
    disabled: undefined,
    selected: undefined,
    weekStartsOn: 0,
    numberOfMonths: 1,
    fixedWeeks: false,
    pagedNavigation: false,
    showOutsideDays: false,
    dir: "ltr"
};
const $cd5cb10b23b08281$export$188d75d71883854a = {
    root: "datepicker",
    months: "datepicker-months",
    month: "datepicker-month",
    week: "datepicker-week",
    day: "datepicker-day",
    dayButton: "datepicker-day-button",
    dayName: "datepicker-day-name",
    header: "datepicker-header",
    prev: "datepicker-prev",
    next: "datepicker-next"
};





function $5d2ade1f43999b17$export$da7ed8f98360d15(num, min, max) {
    return Math.min(Math.max(num, min), max);
}





function $687e4eba6b739049$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}




function $1953ec1884275a13$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}


function $f7dd9b9e40f38545$export$85dec8dbdacdad72(date, minDate, maxDate) {
    return (0, $1953ec1884275a13$export$2e2bcd8739ae039)([
        (0, $687e4eba6b739049$export$2e2bcd8739ae039)([
            date,
            minDate
        ]),
        maxDate
    ]);
}





function $45cd2fa86cd3abf5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}



function $0c02c7faee7ab2f0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}



function $dc627fc1be47665b$export$2e2bcd8739ae039(dirtyInterval) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    var dates = [];
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    while(currentDate.getTime() <= endTime){
        dates.push((0, $2285621ea3fa8491$export$2e2bcd8739ae039)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return dates;
}




function $cd45f25018a6a3b6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $45cd2fa86cd3abf5$export$2e2bcd8739ae039)(dirtyDate, -amount);
}


function $399a8b509011e38d$export$ab152e6ff2cc840e(date, options = {}) {
    const { minDate: minDate, maxDate: maxDate, numberOfMonths: numberOfMonths } = options;
    /**
	 * We respect the numberOfMonths param even when the difference between
	 * minDate and maxDate are less than numberOfMonths. In this case we
	 * show the minDate + n months.
	 */ if ((0, $0c02c7faee7ab2f0$export$2e2bcd8739ae039)(maxDate, minDate) < numberOfMonths) return (0, $dc627fc1be47665b$export$2e2bcd8739ae039)({
        start: minDate,
        end: (0, $45cd2fa86cd3abf5$export$2e2bcd8739ae039)(minDate, numberOfMonths - 1)
    });
    let clampedDate = monthClamp(date);
    let diff = (0, $0c02c7faee7ab2f0$export$2e2bcd8739ae039)(maxDate, clampedDate);
    let endPadding = (0, $5d2ade1f43999b17$export$da7ed8f98360d15)(diff, 0, numberOfMonths - 1);
    let startPadding = numberOfMonths - 1 - endPadding;
    function monthClamp(date) {
        return (0, $f7dd9b9e40f38545$export$85dec8dbdacdad72)(date, minDate, maxDate);
    }
    return (0, $dc627fc1be47665b$export$2e2bcd8739ae039)({
        end: monthClamp((0, $45cd2fa86cd3abf5$export$2e2bcd8739ae039)(clampedDate, endPadding)),
        start: monthClamp((0, $cd45f25018a6a3b6$export$2e2bcd8739ae039)(clampedDate, startPadding))
    });
}





function $2df2057e3bc960c4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $9260a9ed67d17426$export$2e2bcd8739ae039)(dirtyDate, -amount);
}


function $1400728785ad4393$export$5109c6dd95d8fb00(options) {
    let config = {
        ...(0, $cd5cb10b23b08281$export$ebe90cb607ad99e),
        ...options,
        classes: {
            ...(0, $cd5cb10b23b08281$export$188d75d71883854a),
            ...options.classes
        }
    };
    config.date = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(config.date);
    config.minDate = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(config.minDate);
    config.maxDate = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(config.maxDate);
    let state = {
        days: [],
        months: [],
        focusedDay: undefined
    };
    let monthsElement = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("div");
    let { prevMonthButton: prevMonthButton, nextMonthButton: nextMonthButton } = $1400728785ad4393$var$createUI();
    monthsElement.className = config.classes.months;
    prevMonthButton.addEventListener("click", ()=>prev());
    nextMonthButton.addEventListener("click", ()=>next());
    config.container.classList.add(config.classes.root);
    config.container.append(prevMonthButton, nextMonthButton, monthsElement);
    render();
    registerEventListeners();
    function render(date = config.date) {
        state.days = [];
        state.months = [];
        monthsElement.innerHTML = "";
        let months = (0, $399a8b509011e38d$export$ab152e6ff2cc840e)(date, config);
        months.map((month)=>{
            let { render: render, days: days } = (0, $0332e0457981f2c2$export$951c8378cdfec6e6)(month, config);
            state.days.push(...days);
            state.months.push(month);
            monthsElement.append(render());
        });
        config.date = date;
        if (state.focusedDay) state.focusedDay.focus();
    }
    function goTo(date) {
        render(date);
    }
    function next(step = 1) {
        let { pagedNavigation: pagedNavigation, numberOfMonths: numberOfMonths } = config;
        let n = pagedNavigation ? numberOfMonths : step;
        let date = (0, $45cd2fa86cd3abf5$export$2e2bcd8739ae039)((0, $faa29fed8a8b4f74$export$43128fadae87b74a)(state.months), n);
        render(date);
        makeFirstFocusable();
    }
    function prev(step = 1) {
        let { pagedNavigation: pagedNavigation, numberOfMonths: numberOfMonths } = config;
        let n = pagedNavigation ? numberOfMonths : step;
        let date = (0, $cd45f25018a6a3b6$export$2e2bcd8739ae039)((0, $faa29fed8a8b4f74$export$43128fadae87b74a)(state.months), n);
        render(date);
        makeFirstFocusable();
    }
    function registerEventListeners() {
        config.container.addEventListener("dayClick", handleDayClick);
        config.container.addEventListener("dayFocus", handleDayFocus);
        config.container.addEventListener("dayKeydown", handleDayKeydown);
    }
    function handleDayClick(event) {
        event.detail.focus();
    }
    function handleDayFocus(event) {
        if (state.focusedDay && state.focusedDay.element !== event.detail.element) state.focusedDay.blur();
        state.focusedDay = event.detail;
    }
    function handleDayKeydown(event) {
        let handled = false;
        let { date: date, event: { key: key } } = event.detail;
        switch(key){
            case "ArrowLeft":
                handled = true;
                focus((0, $2df2057e3bc960c4$export$2e2bcd8739ae039)(date, 1));
                break;
            case "ArrowRight":
                handled = true;
                focus((0, $9260a9ed67d17426$export$2e2bcd8739ae039)(date, 1));
                break;
            case "ArrowUp":
                handled = true;
                focus((0, $2df2057e3bc960c4$export$2e2bcd8739ae039)(date, 7));
                break;
            case "ArrowDown":
                handled = true;
                focus((0, $9260a9ed67d17426$export$2e2bcd8739ae039)(date, 7));
                break;
        }
        if (handled) event.preventDefault();
        function focus(date) {
            let { minDate: minDate, maxDate: maxDate } = config;
            let days = state.days.filter(isFocusable);
            let day = days.find((day)=>(0, $f66cd00649fade9f$export$2e2bcd8739ae039)(day.date, date));
            if (day) return day.focus();
            if ((0, $9ff66a5d682467d6$export$2e2bcd8739ae039)(date, {
                start: minDate,
                end: maxDate
            })) {
                render(date);
                focus(date);
            }
            function isFocusable(day) {
                return !day.modifiers.outside && !day.modifiers.hidden;
            }
        }
    }
    function makeFirstFocusable() {
        let days = state.days.filter(isFocusable);
        if (days.length) days[0].enableKeyboardFocus();
        function isFocusable(day) {
            return !day.modifiers.outside && !day.modifiers.hidden;
        }
    }
    function set(key, value, refresh = true) {
        config = (0, $89cf0c53e889b57d$export$c615a4d8c3fee905)(config, key, value);
        if (refresh) render();
    }
    return {
        goTo: goTo,
        next: next,
        prev: prev,
        set: set,
        config: config,
        render: render
    };
}
function $1400728785ad4393$var$createUI() {
    const nextMonthButton = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("button");
    const prevMonthButton = (0, $e108066b85995f38$export$c8a8987d4410bf2d)("button");
    nextMonthButton.classList.add("datepicker-next");
    prevMonthButton.classList.add("datepicker-prev");
    nextMonthButton.setAttribute("type", "button");
    prevMonthButton.setAttribute("type", "button");
    nextMonthButton.setAttribute("aria-label", "Next month");
    prevMonthButton.setAttribute("aria-label", "Previous month");
    return {
        prevMonthButton: prevMonthButton,
        nextMonthButton: nextMonthButton
    };
}


function $457fc60be9d3d6b3$export$4667e3f69e3ef411(input, datepicker) {
    let currentDate = parse(input.value);
    hide();
    setSelectedDate(parse(input.value));
    datepicker.config.container.addEventListener("dayClick", (event)=>{
        let { date: date } = event.detail;
        hide();
        setSelectedDate(date);
        input.value = format(date);
    });
    input.setAttribute("readonly", "true");
    input.setAttribute("autocomplete", "off");
    input.addEventListener("focus", show);
    input.addEventListener("click", show);
    document.addEventListener("click", (event)=>{
        let { target: target } = event;
        if (target === input || datepicker.config.container.contains(target)) return;
        hide();
    });
    function format(date) {
        let d = String(date.getDate()).padStart(2, "0");
        let m = String(date.getMonth() + 1).padStart(2, "0");
        let y = date.getFullYear();
        return [
            d,
            m,
            y
        ].join("/");
    }
    function parse(value) {
        let parts = value.split("/");
        let d = parseInt(parts[0], 10);
        let m = parseInt(parts[1], 10) - 1;
        let y = parseInt(parts[2], 10);
        return new Date(y, m, d);
    }
    function setSelectedDate(date) {
        currentDate = date;
        return datepicker.set("modifiers.selected", date);
    }
    function getCurrentDate() {
        return currentDate;
    }
    function show() {
        input.classList.add("active");
        datepicker.config.container.removeAttribute("hidden");
    }
    function hide() {
        input.classList.remove("active");
        datepicker.config.container.setAttribute("hidden", "");
    }
    return {
        getCurrentDate: getCurrentDate,
        show: show,
        hide: hide,
        ...datepicker
    };
}




let $aa6385e02abbadf3$var$forms = Array.from(document.querySelectorAll(".js-book"));
function $aa6385e02abbadf3$export$2cd8252107eb640b() {
    $aa6385e02abbadf3$var$forms.forEach((form)=>{
        let site = form.elements["siteId"];
        let group = form.querySelector(".js-book-fields");
        let fields = {
            date: form.elements["date"],
            adults: form.elements["adults"],
            children: form.elements["children"]
        };
        let dpContainer = document.createElement("div");
        dpContainer.className = "datepicker-modal";
        let datePickerInstance = (0, $457fc60be9d3d6b3$export$4667e3f69e3ef411)(fields.date, (0, $1400728785ad4393$export$5109c6dd95d8fb00)({
            container: dpContainer
        }));
        fields.date.after(dpContainer);
        form.addEventListener("submit", onSubmit);
        if (site) site.addEventListener("change", onUpdateSite);
        if (fields.children) fields.children.addEventListener("spinbutton:change", onUpdateChildren);
        onUpdateSite();
        onUpdateChildren();
        function onUpdateSite() {
            let adultsInputId = fields.adults.id;
            let childrenInputId = fields.children.id;
            let adultsSpinButton = (0, $9d9a4a02115a6bf3$export$12d555061d854ced)[adultsInputId];
            let childrenSpinButton = (0, $9d9a4a02115a6bf3$export$12d555061d854ced)[childrenInputId];
            let { options: options, selectedIndex: selectedIndex } = site;
            let option = options[selectedIndex];
            if (option.value !== "1") enable();
            else disable();
            adultsSpinButton.setMax(option.dataset.maxAdults);
            childrenSpinButton.setMax(option.dataset.maxChildren);
            if (option.dataset.maxChildren > 0) form.querySelector(".js-book-children").removeAttribute("hidden");
            else form.querySelector(".js-book-children").setAttribute("hidden", "");
        }
        function enable() {
            group.style.opacity = "";
            getInputs().map((element)=>element.removeAttribute("disabled"));
        }
        function disable() {
            group.style.opacity = 0.5;
            getInputs().map((element)=>element.setAttribute("disabled", "true"));
        }
        function getInputs() {
            return Array.from(form.querySelectorAll("input, select")).filter((element)=>element.name !== "siteId");
        }
        function onUpdateChildren() {
            let value = fields.children.value;
            let container = form.querySelector(".js-book-ages");
            let ages = Array.from(container.querySelectorAll(".js-book-age"));
            if (value > 0) container.removeAttribute("hidden");
            else container.setAttribute("hidden", "");
            function show(elem) {
                elem.removeAttribute("hidden");
            }
            function hide(elem) {
                elem.setAttribute("hidden", "");
            }
            ages.forEach((elem, i)=>{
                i + 1 <= value ? show(elem) : hide(elem);
            });
        }
        let occupancy;
        function getOccupancyChildren(childrenCount) {
            let childAges = "";
            let ageUnit;
            for(let i = 0; i < childrenCount; i++){
                i === 0 ? ageUnit = "" : ageUnit = "+";
                let bookingDrawId = i + 1;
                let ageField = document.getElementById(`booking-drawer-age-${bookingDrawId}`);
                let ageValue = ageField.value;
                childAges += ageUnit + ageValue;
            }
            return childAges;
        }
        function getOccupancy(adults) {
            if (site.value === "2") {
                occupancy = adults;
                return occupancy;
            }
            if (site.value === "3") {
                let childrenCount = fields.children.value;
                let childAges = getOccupancyChildren(childrenCount);
                childrenCount > 0 ? occupancy = `${adults}+${childrenCount}#${childAges}` : occupancy = adults;
                return occupancy;
            }
        }
        function onSubmit(event) {
            event.preventDefault();
            let errors = [];
            let errorContainer = form.querySelector(".js-book-errors");
            let rules = [
                {
                    field: site,
                    rule: validateSite,
                    message: "Please select a hotel"
                },
                {
                    field: fields.date,
                    rule: validateDate,
                    message: "Date must be in dd/mm/yyyy format"
                }
            ];
            for(let i = 0; i < rules.length; i++){
                let fieldValid = rules[i].rule(rules[i].field);
                if (fieldValid) continue;
                errors.push(rules[i].message);
                rules[i].field.setAttribute("aria-invalid", "true");
                rules[i].field.setAttribute("aria-describedby", `error-${i}`);
            }
            if (errors.length === 0) {
                let date = datePickerInstance.getCurrentDate();
                let d = String(date.getDate()).padStart(2, "0");
                let m = String(date.getMonth() + 1).padStart(2, "0");
                let y = date.getFullYear();
                let dateSelected = [
                    y,
                    m,
                    d
                ].join("-");
                let nights = form.elements["nights"].value;
                let adults = fields.adults.value;
                let occupancy = getOccupancy(adults);
                let roomId = form.elements["roomId"];
                let offerId = form.elements["offerId"];
                let promoCode = form.elements["promoCode"];
                // eslint-disable-next-line no-undef
                Booking.Open({
                    checkin: dateSelected,
                    nights: nights,
                    occupancy: occupancy,
                    Currency: "GBP",
                    RoomID: roomId ? roomId.value : "",
                    OfferID: offerId ? offerId.value : "",
                    promocode: promoCode ? promoCode.value : ""
                });
                return true;
            }
            errorContainer.innerHTML = "";
            for(let i = 0; i < errors.length; i++){
                let li = document.createElement("li");
                li.id = `error-${i}`;
                li.className = "error";
                li.textContent = errors[i];
                errorContainer.appendChild(li);
            }
        }
        function validateSite(field) {
            let { options: options, selectedIndex: selectedIndex } = field;
            let option = options[selectedIndex];
            return option.value != "" && option.value != "1";
        }
        function validateDate(field) {
            let pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
            return pattern.test(field.value);
        }
    });
    window.addEventListener("load", ()=>{
        var switcher = document.querySelectorAll(".c-switcher__tab");
        function myTabClicks(switcherClickEvent) {
            for(var i = 0; i < switcher.length; i++)switcher[i].classList.remove("c-switcher__tab--active");
            var clickedTab = switcherClickEvent.currentTarget;
            clickedTab.classList.add("c-switcher__tab--active");
            switcherClickEvent.preventDefault();
            var myContentPanes = document.querySelectorAll(".c-switcher__content--tab");
            for(i = 0; i < myContentPanes.length; i++)myContentPanes[i].classList.remove("c-switcher__content--tab--active");
            var anchorReference = switcherClickEvent.target;
            var activePaneId = anchorReference.getAttribute("href");
            var activePane = document.querySelector(activePaneId);
            activePane.classList.add("c-switcher__content--tab--active");
        }
        for(var i = 0; i < switcher.length; i++)switcher[i].addEventListener("click", myTabClicks);
    });
    var bedruthanRestaurantSelector = document.querySelector(".js-switch-booking-restaurant");
    if (bedruthanRestaurantSelector !== null) bedruthanRestaurantSelector.addEventListener("change", (e)=>{
        let src = "https://booking.resdiary.com/widget/Standard/";
        let bookingFrame = document.querySelector(".c-frame--booking--bedruthan");
        let val = e.target.value;
        if (val == 0) bookingFrame.classList.add("hidden");
        else {
            bookingFrame.classList.remove("hidden");
            bookingFrame.src = src + val;
        }
    });
}


var $d3af62ba6a2674d8$exports = {};







/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */ (function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "./drag",
        "./prev-next-button",
        "./page-dots",
        "./player",
        "./add-remove-cell",
        "./lazyload"
    ], factory);
    else if (0, $d3af62ba6a2674d8$exports) // CommonJS
    $d3af62ba6a2674d8$exports = factory((parcelRequire("2aJDM")), (parcelRequire("hmb6s")), (parcelRequire("4dDla")), (parcelRequire("dkngm")), (parcelRequire("75ETk")), (parcelRequire("jJEFi")), (parcelRequire("gWVcH")));
})(window, function factory(Flickity) {
    return Flickity;
});


// Custom SVG path for Flickity, drawn on a 100 100 viewbox.
const $bd832e7031ff2e30$export$6d4f5bf8305fffe0 = "M62.7 98a3.27 3.27 0 002.3-1 3.39 3.39 0 000-4.74L23.34 50 65 7.72A3.39 3.39 0 0065 3a3.27 3.27 0 00-4.67 0L14 50l46.36 47a3.3 3.3 0 002.34 1z";


let $7da2b7f22c19466a$var$defaults = {
    arrowShape: (0, $bd832e7031ff2e30$export$6d4f5bf8305fffe0)
};
function $7da2b7f22c19466a$export$1ed4e0ee0871b47c(element, options = {}) {
    let config = {
        ...$7da2b7f22c19466a$var$defaults,
        ...options
    };
    let flkty = new (0, (/*@__PURE__*/$parcel$interopDefault($d3af62ba6a2674d8$exports)))(element, config);
    update(flkty);
    function update(instance) {
        let enabled = instance.slideableWidth > instance.size.width;
        instance.options.draggable = enabled;
        if (enabled) {
            instance.prevButton.element.removeAttribute("hidden");
            instance.nextButton.element.removeAttribute("hidden");
        } else {
            instance.prevButton.element.setAttribute("hidden", "");
            instance.nextButton.element.setAttribute("hidden", "");
        }
        instance.updateDraggable();
        positionArrows(instance);
    }
    function positionArrows(instance) {
        let element = instance.element;
        let images = Array.from(element.querySelectorAll(".js-flickity-media"));
        if (images.length === 0) return;
        let imageHeights = images.map((image)=>image.clientHeight);
        let maxImageHeight = Math.max(...imageHeights);
        instance.prevButton.element.style.top = `${maxImageHeight / 2}px`;
        instance.nextButton.element.style.top = `${maxImageHeight / 2}px`;
    }
    flkty.on("resize", ()=>update(flkty));
    return flkty;
}


function $e18e62e0f1712f3a$export$2cd8252107eb640b() {
    let elements = Array.from(document.querySelectorAll(".js-carousel"));
    elements.forEach((element)=>(0, $7da2b7f22c19466a$export$1ed4e0ee0871b47c)(element, {
            cellAlign: "left",
            contain: true,
            pageDots: false
        }));
}



function $679445dd87babde3$export$2cd8252107eb640b() {
    let element = document.querySelector(".js-curtains");
    if (!element) return;
    let left = element.querySelector(".js-curtain-left");
    let right = element.querySelector(".js-curtain-right");
    let content = element.querySelector(".js-curtain-content");
    if (!(left && right && content)) return;
    calcTransform();
    (0, $9ec512fce550e4ea$export$875bcbe48555930)(element, {
        onUpdate: onUpdate,
        start: "0 0.5"
    });
    function onUpdate(entry) {
        if (!entry.isVisible) return;
        left.style.transform = "";
        right.style.transform = "";
    }
    function calcTransform() {
        let contentWidth = content.clientWidth;
        left.style.transform = `translateX(${contentWidth * 0.9}px)`;
        right.style.transform = `translateX(${-contentWidth * 0.9}px)`;
    }
}



const $da8a4b399816f51f$var$expandedClass = "is-expanded";
function $da8a4b399816f51f$export$2cd8252107eb640b() {
    const toggles = Array.from(document.querySelectorAll(".js-disclosure"));
    toggles.forEach((element)=>{
        let isExpanded = false;
        let targetId = element.dataset.target;
        let target = document.getElementById(targetId);
        let label = element.querySelector(".js-disclosure-label");
        if (!target) return;
        close();
        let flkty = (0, (/*@__PURE__*/$parcel$interopDefault($d3af62ba6a2674d8$exports))).data(target.firstElementChild);
        target.removeAttribute("hidden");
        element.removeAttribute("hidden");
        element.setAttribute("aria-controls", targetId);
        element.setAttribute("aria-expanded", "false");
        element.addEventListener("click", toggle);
        function toggle() {
            isExpanded ? close() : open();
        }
        function open() {
            isExpanded = true;
            target.style.display = "block";
            target.classList.add($da8a4b399816f51f$var$expandedClass);
            element.classList.add($da8a4b399816f51f$var$expandedClass);
            element.setAttribute("aria-expanded", "true");
            if (label) label.textContent = label.textContent.replace(/show/i, "Hide");
            if (flkty) flkty.resize();
        }
        function close() {
            isExpanded = false;
            target.style.display = "none";
            target.classList.remove($da8a4b399816f51f$var$expandedClass);
            element.classList.remove($da8a4b399816f51f$var$expandedClass);
            element.setAttribute("aria-expanded", "false");
            if (label) label.textContent = label.textContent.replace(/hide/i, "Show");
        }
    });
}



const $ad06ab661ab8a671$var$e = [
    "input",
    "select",
    "textarea",
    "button",
    "summary",
    "a[href]",
    "area[href]",
    "embed",
    "iframe",
    "object",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
];
function $ad06ab661ab8a671$var$t(e, t = !1) {
    if (!e || !e instanceof HTMLElement) return !1;
    e.focus({
        preventScroll: !t
    });
}
function $ad06ab661ab8a671$var$n(e, n = !1) {
    const o = $ad06ab661ab8a671$var$r(e);
    if (!o.length) return !1;
    $ad06ab661ab8a671$var$t(o[0], n);
}
function $ad06ab661ab8a671$var$r(t) {
    return Array.from(t.querySelectorAll($ad06ab661ab8a671$var$e)).filter((t)=>(function(t) {
            if (!t) return !1;
            if ($ad06ab661ab8a671$var$o(t) && !function(e) {
                if (!$ad06ab661ab8a671$var$o(e)) return !1;
                if (!Array.from(document.getElementsByName(e.name)).some((e)=>e.checked)) return !0;
                return e.checked;
            }(t)) return !1;
            let n = parseInt(t.getAttribute("tabindex"), 10);
            if (n && n < 0) return !1;
            if (!t.matches($ad06ab661ab8a671$var$e)) return !1;
            return !t.hidden && !t.disabled && !(null === t.offsetParent || "hidden" === window.getComputedStyle(t).visibility);
        })(t));
}
function $ad06ab661ab8a671$var$o(e) {
    return "INPUT" === e.tagName || "radio" === e.type;
}
const $ad06ab661ab8a671$var$i = {
    description: "",
    label: "Dialog",
    alert: !1,
    openClass: "is-open"
};
let $ad06ab661ab8a671$var$a, $ad06ab661ab8a671$var$l;
function $ad06ab661ab8a671$var$c(e) {
    let t = $ad06ab661ab8a671$export$89b4be35062c4a3f(e.currentTarget.dataset.dialogOpen);
    t && (t.open(), e.preventDefault());
}
function $ad06ab661ab8a671$var$u(e) {
    let t = $ad06ab661ab8a671$export$89b4be35062c4a3f(e.currentTarget.dataset.dialogClose);
    t && (t.close(), e.preventDefault());
}
var $ad06ab661ab8a671$export$c9ace314e306b16d = Object.freeze({
    __proto__: null,
    get openers () {
        return $ad06ab661ab8a671$var$a;
    },
    get closers () {
        return $ad06ab661ab8a671$var$l;
    },
    mount: function() {
        $ad06ab661ab8a671$var$a = Array.from(document.querySelectorAll("[data-dialog-open]")), $ad06ab661ab8a671$var$l = Array.from(document.querySelectorAll("[data-dialog-close]")), $ad06ab661ab8a671$var$a.forEach((e)=>e.addEventListener("click", $ad06ab661ab8a671$var$c)), $ad06ab661ab8a671$var$l.forEach((e)=>e.addEventListener("click", $ad06ab661ab8a671$var$u));
    },
    unmount: function() {
        $ad06ab661ab8a671$var$a = [], $ad06ab661ab8a671$var$l = [], $ad06ab661ab8a671$var$a.forEach((e)=>e.removeEventListener("click", $ad06ab661ab8a671$var$c)), $ad06ab661ab8a671$var$l.forEach((e)=>e.removeEventListener("click", $ad06ab661ab8a671$var$u));
    }
});
const $ad06ab661ab8a671$export$12d555061d854ced = {};
function $ad06ab661ab8a671$export$89b4be35062c4a3f(e) {
    return void 0 === e ? null : $ad06ab661ab8a671$export$12d555061d854ced.hasOwnProperty(e) ? $ad06ab661ab8a671$export$12d555061d854ced[e] : null;
}
function $ad06ab661ab8a671$export$518824cf31321346(e, o) {
    let a = !1, l = !1, c = document.getElementById(e);
    if (!c) return null;
    if ($ad06ab661ab8a671$export$12d555061d854ced.hasOwnProperty(e)) return $ad06ab661ab8a671$export$12d555061d854ced[e];
    const u = Object.assign({}, $ad06ab661ab8a671$var$i, o), d = function(e, o = {}) {
        let i, a, l = !1, { restoreFocus: c = !0 } = o;
        function u(r) {
            if (e.contains(r.target)) return r.stopPropagation(), void (a = r.target);
            r.preventDefault(), a ? $ad06ab661ab8a671$var$t(a, !0) : $ad06ab661ab8a671$var$n(e, !0);
        }
        function d(n) {
            "Tab" !== n.key || n.altKey || n.ctrlKey || n.metaKey || function(e, n) {
                let o = document.activeElement, i = $ad06ab661ab8a671$var$r(e), a = i[0], l = i[i.length - 1];
                n.shiftKey && o == a ? ($ad06ab661ab8a671$var$t(l, !0), n.preventDefault()) : n.shiftKey || o != l || ($ad06ab661ab8a671$var$t(a, !0), n.preventDefault());
            }(e, n);
        }
        return {
            activated: l,
            activate: function(r, o = !1) {
                l || (i = document.activeElement, r instanceof HTMLElement ? $ad06ab661ab8a671$var$t(r, o) : $ad06ab661ab8a671$var$n(e, o), document.addEventListener("focusin", u, !1), document.addEventListener("keydown", d, !1), l = !0);
            },
            deactivate: function(e, n = !1) {
                if (!l) return;
                document.removeEventListener("focusin", u, !1), document.removeEventListener("keydown", d, !1);
                let r = e || !!c && i;
                r && (a = $ad06ab661ab8a671$var$t(r, n)), l = !1, a = void 0;
            }
        };
    }(c);
    function f(e) {
        "Escape" === e.key && v();
    }
    function m(e) {
        !a && l && b("open") && (a = !0, c.classList.add(u.openClass), document.addEventListener("keydown", f, !0), void 0 === e && (e = c.querySelector("[data-dialog-autofocus]")), d.activate(e));
    }
    function v(e) {
        a && l && b("close") && (d.deactivate(e), a = !1, document.removeEventListener("keydown", f, !0), c.classList.remove(u.openClass));
    }
    function b(e) {
        let t = new CustomEvent("dialog:" + e, {
            bubbles: !0,
            cancelable: !0
        });
        return c.dispatchEvent(t);
    }
    const y = {
        on: function(e, t) {
            c.addEventListener("dialog:" + e, t);
        },
        off: function(e, t) {
            c.removeEventListener("dialog:" + e, t);
        },
        open: m,
        close: v,
        isOpen: a,
        initiated: l,
        create: function() {
            if (l) return !1;
            let e = u.alert ? "alertdialog" : "dialog";
            if (c.setAttribute("tabindex", -1), c.setAttribute("role", e), c.setAttribute("aria-modal", !0), u.label) {
                let e = document.getElementById(u.label) ? "aria-labelledby" : "aria-label";
                c.setAttribute(e, u.label);
            }
            u.description && document.getElementById(u.description) && c.setAttribute("aria-describedby", u.description), l = !0, b("create");
        },
        toggle: function(e = !a) {
            e ? m() : v();
        },
        destroy: function() {
            if (!l) return !1;
            v(), l = !1, [
                "role",
                "tabindex",
                "aria-modal",
                "aria-label",
                "aria-labelledby",
                "aria-describedby"
            ].forEach((e)=>c.removeAttribute(e)), b("destroy");
        },
        id: e,
        element: c
    };
    return $ad06ab661ab8a671$export$12d555061d854ced[e] = y;
}


let $d687fc76f6d31de1$var$testMode = false;
let $d687fc76f6d31de1$var$instanceId = "exit-modal";
function $d687fc76f6d31de1$export$2cd8252107eb640b() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).get($d687fc76f6d31de1$var$instanceId) && !$d687fc76f6d31de1$var$testMode) return;
    setTimeout(function trackMouse() {
        document.addEventListener("mouseout", $d687fc76f6d31de1$var$onMouseout);
    }, !$d687fc76f6d31de1$var$testMode ? 60000 : 0);
}
function $d687fc76f6d31de1$var$onMouseout(event) {
    let { toElement: toElement, relatedTarget: relatedTarget, clientY: clientY } = event;
    let modal = (0, $ad06ab661ab8a671$export$89b4be35062c4a3f)($d687fc76f6d31de1$var$instanceId);
    let isExiting = !toElement && !relatedTarget && clientY < 10;
    if (!isExiting || !modal) return;
    modal.open();
    if ($d687fc76f6d31de1$var$testMode) return;
    // Set a cookie to prevent showing again for x days.
    (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).set($d687fc76f6d31de1$var$instanceId, "true", {
        expires: 7,
        sameSite: "strict"
    });
    document.removeEventListener("mouseout", $d687fc76f6d31de1$var$onMouseout);
}


/* global google */ function $7f28b2da0928e478$export$2cb99e4be0dc4646(src, callback) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    if (callback) script.onload = callback;
    document.getElementsByTagName("head")[0].appendChild(script);
    script.src = src;
}


const $68e9d1d72ebb7b5f$var$API_KEY = "AIzaSyDZW3hvWbjobm6KbErKIgmk6yT__QxzZok";
const $68e9d1d72ebb7b5f$var$SCRIPT_URL = "https://maps.googleapis.com/maps/api/js";
let $68e9d1d72ebb7b5f$var$callbacks = [];
let $68e9d1d72ebb7b5f$var$isLoading = false;
function $68e9d1d72ebb7b5f$export$2cd8252107eb640b() {
    let elements = Array.from(document.querySelectorAll(".js-google-map"));
    elements.forEach((element)=>$68e9d1d72ebb7b5f$var$defer(()=>{
            let lat = parseFloat(element.dataset.lat);
            let lng = parseFloat(element.dataset.lng);
            let map = $68e9d1d72ebb7b5f$var$createMap(element, {
                center: {
                    lat: lat,
                    lng: lng
                }
            });
            $68e9d1d72ebb7b5f$var$createMarker(map, lat, lng, {
                url: element.dataset.markerUrl
            });
        }));
}
function $68e9d1d72ebb7b5f$var$createMap(canvas, options) {
    if (!(canvas instanceof HTMLElement)) return false;
    let defaults = {
        disableDefaultUI: true,
        mapTypeControl: false,
        zoom: 10,
        zoomControl: true
    };
    return new google.maps.Map(canvas, {
        ...defaults,
        ...options
    });
}
function $68e9d1d72ebb7b5f$var$defer(callback) {
    let url = `${$68e9d1d72ebb7b5f$var$SCRIPT_URL}?key=${$68e9d1d72ebb7b5f$var$API_KEY}`;
    if ($68e9d1d72ebb7b5f$var$isGoogleMapsLoaded()) return callback();
    $68e9d1d72ebb7b5f$var$callbacks.push(callback);
    if ($68e9d1d72ebb7b5f$var$isLoading) return;
    $68e9d1d72ebb7b5f$var$isLoading = true;
    (0, $7f28b2da0928e478$export$2cb99e4be0dc4646)(url, function onLoad() {
        $68e9d1d72ebb7b5f$var$isLoading = false;
        for(let i = 0; i < $68e9d1d72ebb7b5f$var$callbacks.length; i++)$68e9d1d72ebb7b5f$var$callbacks.pop()();
    });
}
function $68e9d1d72ebb7b5f$var$isGoogleMapsLoaded() {
    return typeof google === "object" && typeof google.maps === "object";
}
function $68e9d1d72ebb7b5f$var$createMarker(map, lat, lng, options = {}) {
    let { url: url = "/assets/icons/map-marker.svg" } = options;
    return new google.maps.Marker({
        clickable: false,
        map: map,
        position: {
            lat: lat,
            lng: lng
        },
        icon: {
            url: url,
            size: new google.maps.Size(32, 40),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(16, 40),
            scaledSize: new google.maps.Size(32, 40)
        }
    });
}


var $2512afe22a2105d0$exports = {};
$2512afe22a2105d0$exports = $2512afe22a2105d0$var$robustPointInPolygon;
var $fb626d47fb0834ee$exports = {};
"use strict";
var $50930e7038b33565$exports = {};
"use strict";
$50930e7038b33565$exports = $50930e7038b33565$var$twoProduct;
var $50930e7038b33565$var$SPLITTER = +(Math.pow(2, 27) + 1.0);
function $50930e7038b33565$var$twoProduct(a, b, result) {
    var x = a * b;
    var c = $50930e7038b33565$var$SPLITTER * a;
    var abig = c - a;
    var ahi = c - abig;
    var alo = a - ahi;
    var d = $50930e7038b33565$var$SPLITTER * b;
    var bbig = d - b;
    var bhi = d - bbig;
    var blo = b - bhi;
    var err1 = x - ahi * bhi;
    var err2 = err1 - alo * bhi;
    var err3 = err2 - ahi * blo;
    var y = alo * blo - err3;
    if (result) {
        result[0] = y;
        result[1] = x;
        return result;
    }
    return [
        y,
        x
    ];
}


var $37a3bd3287852029$exports = {};
"use strict";
$37a3bd3287852029$exports = $37a3bd3287852029$var$linearExpansionSum;
//Easy case: Add two scalars
function $37a3bd3287852029$var$scalarScalar(a, b) {
    var x = a + b;
    var bv = x - a;
    var av = x - bv;
    var br = b - bv;
    var ar = a - av;
    var y = ar + br;
    if (y) return [
        y,
        x
    ];
    return [
        x
    ];
}
function $37a3bd3287852029$var$linearExpansionSum(e, f) {
    var ne = e.length | 0;
    var nf = f.length | 0;
    if (ne === 1 && nf === 1) return $37a3bd3287852029$var$scalarScalar(e[0], f[0]);
    var n = ne + nf;
    var g = new Array(n);
    var count = 0;
    var eptr = 0;
    var fptr = 0;
    var abs = Math.abs;
    var ei = e[eptr];
    var ea = abs(ei);
    var fi = f[fptr];
    var fa = abs(fi);
    var a, b;
    if (ea < fa) {
        b = ei;
        eptr += 1;
        if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
        }
    } else {
        b = fi;
        fptr += 1;
        if (fptr < nf) {
            fi = f[fptr];
            fa = abs(fi);
        }
    }
    if (eptr < ne && ea < fa || fptr >= nf) {
        a = ei;
        eptr += 1;
        if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
        }
    } else {
        a = fi;
        fptr += 1;
        if (fptr < nf) {
            fi = f[fptr];
            fa = abs(fi);
        }
    }
    var x = a + b;
    var bv = x - a;
    var y = b - bv;
    var q0 = y;
    var q1 = x;
    var _x, _bv, _av, _br, _ar;
    while(eptr < ne && fptr < nf){
        if (ea < fa) {
            a = ei;
            eptr += 1;
            if (eptr < ne) {
                ei = e[eptr];
                ea = abs(ei);
            }
        } else {
            a = fi;
            fptr += 1;
            if (fptr < nf) {
                fi = f[fptr];
                fa = abs(fi);
            }
        }
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
    }
    while(eptr < ne){
        a = ei;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        eptr += 1;
        if (eptr < ne) ei = e[eptr];
    }
    while(fptr < nf){
        a = fi;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        fptr += 1;
        if (fptr < nf) fi = f[fptr];
    }
    if (q0) g[count++] = q0;
    if (q1) g[count++] = q1;
    if (!count) g[count++] = 0.0;
    g.length = count;
    return g;
}


var $dad50f0bf4c79f14$exports = {};
"use strict";

var $da14a7b13f1ec3e8$exports = {};
"use strict";
$da14a7b13f1ec3e8$exports = $da14a7b13f1ec3e8$var$fastTwoSum;
function $da14a7b13f1ec3e8$var$fastTwoSum(a, b, result) {
    var x = a + b;
    var bv = x - a;
    var av = x - bv;
    var br = b - bv;
    var ar = a - av;
    if (result) {
        result[0] = ar + br;
        result[1] = x;
        return result;
    }
    return [
        ar + br,
        x
    ];
}


$dad50f0bf4c79f14$exports = $dad50f0bf4c79f14$var$scaleLinearExpansion;
function $dad50f0bf4c79f14$var$scaleLinearExpansion(e, scale) {
    var n = e.length;
    if (n === 1) {
        var ts = $50930e7038b33565$exports(e[0], scale);
        if (ts[0]) return ts;
        return [
            ts[1]
        ];
    }
    var g = new Array(2 * n);
    var q = [
        0.1,
        0.1
    ];
    var t = [
        0.1,
        0.1
    ];
    var count = 0;
    $50930e7038b33565$exports(e[0], scale, q);
    if (q[0]) g[count++] = q[0];
    for(var i = 1; i < n; ++i){
        $50930e7038b33565$exports(e[i], scale, t);
        var pq = q[1];
        $da14a7b13f1ec3e8$exports(pq, t[0], q);
        if (q[0]) g[count++] = q[0];
        var a = t[1];
        var b = q[1];
        var x = a + b;
        var bv = x - a;
        var y = b - bv;
        q[1] = x;
        if (y) g[count++] = y;
    }
    if (q[1]) g[count++] = q[1];
    if (count === 0) g[count++] = 0.0;
    g.length = count;
    return g;
}


var $710be5dad6c9a05d$exports = {};
"use strict";
$710be5dad6c9a05d$exports = $710be5dad6c9a05d$var$robustSubtract;
//Easy case: Add two scalars
function $710be5dad6c9a05d$var$scalarScalar(a, b) {
    var x = a + b;
    var bv = x - a;
    var av = x - bv;
    var br = b - bv;
    var ar = a - av;
    var y = ar + br;
    if (y) return [
        y,
        x
    ];
    return [
        x
    ];
}
function $710be5dad6c9a05d$var$robustSubtract(e, f) {
    var ne = e.length | 0;
    var nf = f.length | 0;
    if (ne === 1 && nf === 1) return $710be5dad6c9a05d$var$scalarScalar(e[0], -f[0]);
    var n = ne + nf;
    var g = new Array(n);
    var count = 0;
    var eptr = 0;
    var fptr = 0;
    var abs = Math.abs;
    var ei = e[eptr];
    var ea = abs(ei);
    var fi = -f[fptr];
    var fa = abs(fi);
    var a, b;
    if (ea < fa) {
        b = ei;
        eptr += 1;
        if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
        }
    } else {
        b = fi;
        fptr += 1;
        if (fptr < nf) {
            fi = -f[fptr];
            fa = abs(fi);
        }
    }
    if (eptr < ne && ea < fa || fptr >= nf) {
        a = ei;
        eptr += 1;
        if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
        }
    } else {
        a = fi;
        fptr += 1;
        if (fptr < nf) {
            fi = -f[fptr];
            fa = abs(fi);
        }
    }
    var x = a + b;
    var bv = x - a;
    var y = b - bv;
    var q0 = y;
    var q1 = x;
    var _x, _bv, _av, _br, _ar;
    while(eptr < ne && fptr < nf){
        if (ea < fa) {
            a = ei;
            eptr += 1;
            if (eptr < ne) {
                ei = e[eptr];
                ea = abs(ei);
            }
        } else {
            a = fi;
            fptr += 1;
            if (fptr < nf) {
                fi = -f[fptr];
                fa = abs(fi);
            }
        }
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
    }
    while(eptr < ne){
        a = ei;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        eptr += 1;
        if (eptr < ne) ei = e[eptr];
    }
    while(fptr < nf){
        a = fi;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        fptr += 1;
        if (fptr < nf) fi = -f[fptr];
    }
    if (q0) g[count++] = q0;
    if (q1) g[count++] = q1;
    if (!count) g[count++] = 0.0;
    g.length = count;
    return g;
}


var $fb626d47fb0834ee$var$NUM_EXPAND = 5;
var $fb626d47fb0834ee$var$EPSILON = 1.1102230246251565e-16;
var $fb626d47fb0834ee$var$ERRBOUND3 = (3.0 + 16.0 * $fb626d47fb0834ee$var$EPSILON) * $fb626d47fb0834ee$var$EPSILON;
var $fb626d47fb0834ee$var$ERRBOUND4 = (7.0 + 56.0 * $fb626d47fb0834ee$var$EPSILON) * $fb626d47fb0834ee$var$EPSILON;
function $fb626d47fb0834ee$var$orientation_3(sum, prod, scale, sub) {
    return function orientation3Exact(m0, m1, m2) {
        var p = sum(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])));
        var n = sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0]));
        var d = sub(p, n);
        return d[d.length - 1];
    };
}
function $fb626d47fb0834ee$var$orientation_4(sum, prod, scale, sub) {
    return function orientation4Exact(m0, m1, m2, m3) {
        var p = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))));
        var n = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))));
        var d = sub(p, n);
        return d[d.length - 1];
    };
}
function $fb626d47fb0834ee$var$orientation_5(sum, prod, scale, sub) {
    return function orientation5Exact(m0, m1, m2, m3, m4) {
        var p = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m1[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), -m2[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m3[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), -m4[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m1[3])))), sum(sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m3[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), -m4[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), m0[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m1[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m3[3])))));
        var n = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m2[3])), sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), m3[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m4[3]))), sum(sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), -m1[3])), sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m4[3]))));
        var d = sub(p, n);
        return d[d.length - 1];
    };
}
function $fb626d47fb0834ee$var$orientation(n) {
    var fn = n === 3 ? $fb626d47fb0834ee$var$orientation_3 : n === 4 ? $fb626d47fb0834ee$var$orientation_4 : $fb626d47fb0834ee$var$orientation_5;
    return fn($37a3bd3287852029$exports, $50930e7038b33565$exports, $dad50f0bf4c79f14$exports, $710be5dad6c9a05d$exports);
}
var $fb626d47fb0834ee$var$orientation3Exact = $fb626d47fb0834ee$var$orientation(3);
var $fb626d47fb0834ee$var$orientation4Exact = $fb626d47fb0834ee$var$orientation(4);
var $fb626d47fb0834ee$var$CACHED = [
    function orientation0() {
        return 0;
    },
    function orientation1() {
        return 0;
    },
    function orientation2(a, b) {
        return b[0] - a[0];
    },
    function orientation3(a, b, c) {
        var l = (a[1] - c[1]) * (b[0] - c[0]);
        var r = (a[0] - c[0]) * (b[1] - c[1]);
        var det = l - r;
        var s;
        if (l > 0) {
            if (r <= 0) return det;
            else s = l + r;
        } else if (l < 0) {
            if (r >= 0) return det;
            else s = -(l + r);
        } else return det;
        var tol = $fb626d47fb0834ee$var$ERRBOUND3 * s;
        if (det >= tol || det <= -tol) return det;
        return $fb626d47fb0834ee$var$orientation3Exact(a, b, c);
    },
    function orientation4(a, b, c, d) {
        var adx = a[0] - d[0];
        var bdx = b[0] - d[0];
        var cdx = c[0] - d[0];
        var ady = a[1] - d[1];
        var bdy = b[1] - d[1];
        var cdy = c[1] - d[1];
        var adz = a[2] - d[2];
        var bdz = b[2] - d[2];
        var cdz = c[2] - d[2];
        var bdxcdy = bdx * cdy;
        var cdxbdy = cdx * bdy;
        var cdxady = cdx * ady;
        var adxcdy = adx * cdy;
        var adxbdy = adx * bdy;
        var bdxady = bdx * ady;
        var det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
        var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
        var tol = $fb626d47fb0834ee$var$ERRBOUND4 * permanent;
        if (det > tol || -det > tol) return det;
        return $fb626d47fb0834ee$var$orientation4Exact(a, b, c, d);
    }
];
function $fb626d47fb0834ee$var$slowOrient(args) {
    var proc = $fb626d47fb0834ee$var$CACHED[args.length];
    if (!proc) proc = $fb626d47fb0834ee$var$CACHED[args.length] = $fb626d47fb0834ee$var$orientation(args.length);
    return proc.apply(undefined, args);
}
function $fb626d47fb0834ee$var$proc(slow, o0, o1, o2, o3, o4, o5) {
    return function getOrientation(a0, a1, a2, a3, a4) {
        switch(arguments.length){
            case 0:
            case 1:
                return 0;
            case 2:
                return o2(a0, a1);
            case 3:
                return o3(a0, a1, a2);
            case 4:
                return o4(a0, a1, a2, a3);
            case 5:
                return o5(a0, a1, a2, a3, a4);
        }
        var s = new Array(arguments.length);
        for(var i = 0; i < arguments.length; ++i)s[i] = arguments[i];
        return slow(s);
    };
}
function $fb626d47fb0834ee$var$generateOrientationProc() {
    while($fb626d47fb0834ee$var$CACHED.length <= $fb626d47fb0834ee$var$NUM_EXPAND)$fb626d47fb0834ee$var$CACHED.push($fb626d47fb0834ee$var$orientation($fb626d47fb0834ee$var$CACHED.length));
    $fb626d47fb0834ee$exports = $fb626d47fb0834ee$var$proc.apply(undefined, [
        $fb626d47fb0834ee$var$slowOrient
    ].concat($fb626d47fb0834ee$var$CACHED));
    for(var i = 0; i <= $fb626d47fb0834ee$var$NUM_EXPAND; ++i)$fb626d47fb0834ee$exports[i] = $fb626d47fb0834ee$var$CACHED[i];
}
$fb626d47fb0834ee$var$generateOrientationProc();


function $2512afe22a2105d0$var$robustPointInPolygon(vs, point) {
    var x = point[0];
    var y = point[1];
    var n = vs.length;
    var inside = 1;
    var lim = n;
    for(var i = 0, j = n - 1; i < lim; j = i++){
        var a = vs[i];
        var b = vs[j];
        var yi = a[1];
        var yj = b[1];
        if (yj < yi) {
            if (yj < y && y < yi) {
                var s = $fb626d47fb0834ee$exports(a, b, point);
                if (s === 0) return 0;
                else inside ^= 0 < s | 0;
            } else if (y === yi) {
                var c = vs[(i + 1) % n];
                var yk = c[1];
                if (yi < yk) {
                    var s = $fb626d47fb0834ee$exports(a, b, point);
                    if (s === 0) return 0;
                    else inside ^= 0 < s | 0;
                }
            }
        } else if (yi < yj) {
            if (yi < y && y < yj) {
                var s = $fb626d47fb0834ee$exports(a, b, point);
                if (s === 0) return 0;
                else inside ^= s < 0 | 0;
            } else if (y === yi) {
                var c = vs[(i + 1) % n];
                var yk = c[1];
                if (yk < yi) {
                    var s = $fb626d47fb0834ee$exports(a, b, point);
                    if (s === 0) return 0;
                    else inside ^= s < 0 | 0;
                }
            }
        } else if (y === yi) {
            var x0 = Math.min(a[0], b[0]);
            var x1 = Math.max(a[0], b[0]);
            if (i === 0) {
                while(j > 0){
                    var k = (j + n - 1) % n;
                    var p = vs[k];
                    if (p[1] !== y) break;
                    var px = p[0];
                    x0 = Math.min(x0, px);
                    x1 = Math.max(x1, px);
                    j = k;
                }
                if (j === 0) {
                    if (x0 <= x && x <= x1) return 0;
                    return 1;
                }
                lim = j + 1;
            }
            var y0 = vs[(j + n - 1) % n][1];
            while(i + 1 < lim){
                var p = vs[i + 1];
                if (p[1] !== y) break;
                var px = p[0];
                x0 = Math.min(x0, px);
                x1 = Math.max(x1, px);
                i += 1;
            }
            if (x0 <= x && x <= x1) return 0;
            var y1 = vs[(i + 1) % n][1];
            if (x < x0 && y0 < y !== y1 < y) inside ^= 1;
        }
    }
    return 2 * inside - 1;
}



let $f874cc1b66f9c8bd$var$activeNav;
let $f874cc1b66f9c8bd$var$activeClass = "is-open";
let $f874cc1b66f9c8bd$var$activeHeaderClass = "has-active-menu";
let $f874cc1b66f9c8bd$var$closeTimer;
let $f874cc1b66f9c8bd$var$isTouch = false;
let $f874cc1b66f9c8bd$var$mouseData = {
    x: 0,
    y: 0
};
let $f874cc1b66f9c8bd$var$movingHorizontally = false;
let $f874cc1b66f9c8bd$var$timer;
let $f874cc1b66f9c8bd$var$backdrop;
const $f874cc1b66f9c8bd$var$SAMPLE_RATE = 80;
let $f874cc1b66f9c8bd$var$header = document.querySelector(".js-header");
let $f874cc1b66f9c8bd$var$triggers = Array.from(document.querySelectorAll(".js-mega-nav-trigger"));
function $f874cc1b66f9c8bd$export$2cd8252107eb640b() {
    document.addEventListener("mousemove", $f874cc1b66f9c8bd$var$trackMouse);
    $f874cc1b66f9c8bd$var$triggers.forEach((element)=>{
        element.addEventListener("mouseleave", $f874cc1b66f9c8bd$var$onMouseLeave);
        element.addEventListener("mouseenter", $f874cc1b66f9c8bd$var$onMouseEnter, false);
        element.addEventListener("touchstart", $f874cc1b66f9c8bd$var$onTouchstart, {
            passive: false
        });
    });
}
function $f874cc1b66f9c8bd$var$onTouchstart(event) {
    $f874cc1b66f9c8bd$var$isTouch = true;
    let trigger = event.currentTarget;
    let dropdown = document.getElementById(trigger.dataset.target);
    if ($f874cc1b66f9c8bd$var$activeNav && event.currentTarget === $f874cc1b66f9c8bd$var$activeNav.trigger) {
        $f874cc1b66f9c8bd$var$closeActiveNav();
        event.preventDefault();
        return;
    }
    if ($f874cc1b66f9c8bd$var$activeNav && $f874cc1b66f9c8bd$var$outsideNav(event.clientX, event.clientY)) $f874cc1b66f9c8bd$var$closeActiveNav();
    if (!dropdown) return;
    event.preventDefault();
    $f874cc1b66f9c8bd$var$openNav(trigger, dropdown);
}
function $f874cc1b66f9c8bd$var$onMouseEnter(event) {
    let x = event.clientX;
    let y = event.clientY;
    let dropdown;
    let trigger = event.currentTarget;
    if (trigger.dataset.target) dropdown = document.getElementById(trigger.dataset.target);
    $f874cc1b66f9c8bd$var$timer = setInterval(shouldActivate, $f874cc1b66f9c8bd$var$SAMPLE_RATE);
    function shouldActivate() {
        let open = Math.hypot(Math.abs($f874cc1b66f9c8bd$var$mouseData.x - x), Math.abs($f874cc1b66f9c8bd$var$mouseData.y - y)) < 5 || $f874cc1b66f9c8bd$var$movingHorizontally;
        x = $f874cc1b66f9c8bd$var$mouseData.x;
        y = $f874cc1b66f9c8bd$var$mouseData.y;
        if (open) {
            $f874cc1b66f9c8bd$var$closeActiveNav();
            clearInterval($f874cc1b66f9c8bd$var$timer);
            if (!dropdown) return;
            $f874cc1b66f9c8bd$var$openNav(trigger, dropdown);
        }
    }
}
function $f874cc1b66f9c8bd$var$onMouseLeave() {
    clearInterval($f874cc1b66f9c8bd$var$timer);
    $f874cc1b66f9c8bd$var$timer = undefined;
}
function $f874cc1b66f9c8bd$var$openNav(trigger, dropdown) {
    (0, $d31896c3ffaae1d6$export$792f3d81ea979f55)();
    $f874cc1b66f9c8bd$var$activeNav = {
        trigger: trigger,
        dropdown: dropdown
    };
    $f874cc1b66f9c8bd$var$header.classList.add($f874cc1b66f9c8bd$var$activeHeaderClass);
    $f874cc1b66f9c8bd$var$activeNav.trigger.classList.add($f874cc1b66f9c8bd$var$activeClass);
    $f874cc1b66f9c8bd$var$activeNav.dropdown.classList.add($f874cc1b66f9c8bd$var$activeClass);
    $f874cc1b66f9c8bd$var$closeTimer = setInterval($f874cc1b66f9c8bd$var$closeTimerFn, $f874cc1b66f9c8bd$var$SAMPLE_RATE * 2);
    $f874cc1b66f9c8bd$var$backdrop = document.createElement("div");
    $f874cc1b66f9c8bd$var$backdrop.className = "c-header__backdrop";
    $f874cc1b66f9c8bd$var$header.parentElement.appendChild($f874cc1b66f9c8bd$var$backdrop);
}
function $f874cc1b66f9c8bd$var$closeTimerFn() {
    if (!$f874cc1b66f9c8bd$var$isTouch && $f874cc1b66f9c8bd$var$outsideNav($f874cc1b66f9c8bd$var$mouseData.x, $f874cc1b66f9c8bd$var$mouseData.y)) $f874cc1b66f9c8bd$var$closeActiveNav();
}
function $f874cc1b66f9c8bd$var$closeActiveNav() {
    if (!$f874cc1b66f9c8bd$var$activeNav) return;
    (0, $d31896c3ffaae1d6$export$5a02f26da2ae01b1)();
    clearInterval($f874cc1b66f9c8bd$var$closeTimer);
    $f874cc1b66f9c8bd$var$header.classList.remove($f874cc1b66f9c8bd$var$activeHeaderClass);
    $f874cc1b66f9c8bd$var$activeNav.trigger.classList.remove($f874cc1b66f9c8bd$var$activeClass);
    $f874cc1b66f9c8bd$var$activeNav.dropdown.classList.remove($f874cc1b66f9c8bd$var$activeClass);
    $f874cc1b66f9c8bd$var$activeNav = undefined;
    $f874cc1b66f9c8bd$var$backdrop.remove();
}
function $f874cc1b66f9c8bd$var$trackMouse(event) {
    $f874cc1b66f9c8bd$var$isTouch = false;
    let x = event.clientX;
    let y = event.clientY;
    clearInterval($f874cc1b66f9c8bd$var$closeTimer);
    if ($f874cc1b66f9c8bd$var$activeNav) {
        let rect = $f874cc1b66f9c8bd$var$activeNav.dropdown.getBoundingClientRect();
        let slopeA = $f874cc1b66f9c8bd$var$slope({
            x: x,
            y: y
        }, {
            x: rect.left,
            y: rect.top
        });
        let slopeB = $f874cc1b66f9c8bd$var$slope({
            x: x,
            y: y
        }, {
            x: rect.right,
            y: rect.top
        });
        let prevSlopeA = $f874cc1b66f9c8bd$var$slope($f874cc1b66f9c8bd$var$mouseData, {
            x: rect.left,
            y: rect.top
        });
        let prevSlopeB = $f874cc1b66f9c8bd$var$slope($f874cc1b66f9c8bd$var$mouseData, {
            x: rect.right,
            y: rect.top
        });
        let movingTowardMenu = slopeA < prevSlopeA + 5 || slopeB < prevSlopeB + 5;
        if ($f874cc1b66f9c8bd$var$outsideNav(x, y) && !movingTowardMenu) $f874cc1b66f9c8bd$var$closeActiveNav();
        else {
            clearInterval($f874cc1b66f9c8bd$var$closeTimer);
            $f874cc1b66f9c8bd$var$closeTimer = setInterval($f874cc1b66f9c8bd$var$closeTimerFn, $f874cc1b66f9c8bd$var$SAMPLE_RATE * 2);
        }
    }
    $f874cc1b66f9c8bd$var$movingHorizontally = Math.abs($f874cc1b66f9c8bd$var$mouseData.x - x) > Math.abs($f874cc1b66f9c8bd$var$mouseData.y - y);
    $f874cc1b66f9c8bd$var$mouseData.x = x;
    $f874cc1b66f9c8bd$var$mouseData.y = y;
}
function $f874cc1b66f9c8bd$var$slope(a, b) {
    return Number((b.y - a.y) / (b.x - a.x)).toFixed(3);
}
function $f874cc1b66f9c8bd$var$outsideNav(x, y) {
    const point = (0, (/*@__PURE__*/$parcel$interopDefault($2512afe22a2105d0$exports)))($f874cc1b66f9c8bd$var$getBounds($f874cc1b66f9c8bd$var$activeNav), [
        x + 1,
        y + 1
    ]);
    return point === 1;
}
function $f874cc1b66f9c8bd$var$getBounds(item) {
    const padding = 15;
    let t = item.trigger.getBoundingClientRect();
    let d = item.dropdown.getBoundingClientRect();
    /**
	 *       C +---------+ D
	 *         | Trigger |
	 *	A +-- B +---------+ E ---------------+ F
	 *	  |                                  |
	 *	  |             Dropdown             |
	 *	  |                                  |
	 *	H +----------------------------------+ G
	 */ return [
        /* A */ [
            d.left,
            d.top
        ],
        /* B */ [
            t.left,
            t.bottom
        ],
        /* C */ [
            t.left,
            t.top
        ],
        /* D */ [
            t.left + t.width,
            t.top
        ],
        /* E */ [
            t.right,
            t.bottom
        ],
        /* F */ [
            d.left + d.width,
            d.top
        ],
        /* G */ [
            d.left + d.width,
            d.top + d.height + padding
        ],
        /* H */ [
            d.left,
            d.top + d.height + padding
        ]
    ];
}



function $c766d48b0039b09e$export$2cd8252107eb640b() {
    Array.from(document.querySelectorAll(".js-hz-menu")).forEach((element)=>$c766d48b0039b09e$export$9c9340a389bd1d5f(element));
}
function $c766d48b0039b09e$export$9c9340a389bd1d5f(element) {
    if (!element) return;
    (0, $7da2b7f22c19466a$export$1ed4e0ee0871b47c)(element, {
        cellAlign: "left",
        contain: true,
        freeScroll: true,
        lazyLoad: true,
        pageDots: false
    });
}



function $afaff6b8eb7d8e18$export$2cd8252107eb640b() {
    let elements = Array.from(document.querySelectorAll(".js-image-carousel"));
    elements.forEach((element)=>(0, $7da2b7f22c19466a$export$1ed4e0ee0871b47c)(element, {
            cellAlign: "left",
            contain: true,
            pageDots: false
        }));
}


/* global Site */ function $338352bcfef59b50$export$2cd8252107eb640b() {
    let element = document.querySelector(".js-instagram-feed");
    if (!element) return;
    let selector = ".js-instagram-image";
    let placeholders = Array.from(element.querySelectorAll(selector));
    let observer = new IntersectionObserver(onIntersection, {
        rootMargin: "20%"
    });
    observer.observe(element);
    function onIntersection(entries) {
        let entry = entries[0];
        if (!entry.isIntersecting) return;
        getMedia(placeholders.length).then((json)=>{
            json.media.forEach((media, i)=>{
                let img = document.createElement("img");
                img.src = media.mediaUrl;
                placeholders[i].appendChild(img);
            });
        });
        observer.unobserve(element);
    }
    function getMedia(limit) {
        let url = `${Site.baseUrl}actions/instagram/media/fetch?limit=${limit}`;
        return fetch(url).then((response)=>response.json());
    }
}


/**
 * Generic modal interface, used for drawers, navigation and modals.
 */ 
function $f4e1325d163bbb61$export$2cd8252107eb640b() {
    (0, $ad06ab661ab8a671$export$c9ace314e306b16d).mount();
    Array.from(document.querySelectorAll(".js-modal")).forEach((element)=>$f4e1325d163bbb61$var$create(element));
}
function $f4e1325d163bbb61$var$create(element) {
    let instance = (0, $ad06ab661ab8a671$export$518824cf31321346)(element.id);
    let contentElement = element.querySelector(".js-modal-content");
    if (instance) {
        instance.create();
        instance.on("open", ()=>{
            $f4e1325d163bbb61$var$loadFormScript(instance);
            element.scrollTop = 0;
            let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
        });
        instance.on("close", ()=>{
            instance.element.addEventListener("transitionend", onTransitionEnd);
        });
        instance.element.addEventListener("click", (event)=>{
            if (!contentElement || contentElement.contains(event.target)) return;
            instance.close();
        }, true);
    }
    function onTransitionEnd(event) {
        if (event.propertyName !== "opacity") return;
        document.body.style = "";
        document.body.style.paddingRight = "";
        document.documentElement.style.setProperty("--scrollbar-width", "");
        instance.element.removeEventListener("transitionend", onTransitionEnd);
    }
}
function $f4e1325d163bbb61$var$loadFormScript(instance) {
    let element = instance.element;
    let target = element.querySelector("[data-modal-script]");
    if (!target) return;
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = target.dataset.modalScript;
    element.appendChild(script);
}


function $76443b823084b133$export$931cbfb6bfb85fc(element) {
    let isExpanded = false;
    let expandedClass = "is-expanded";
    let collapsedClass = "is-collapsed";
    let targetId = element.dataset.target;
    let targetElement = document.getElementById(targetId);
    if (!targetElement) return;
    function create() {
        collapse(true);
        element.addEventListener("click", toggle);
        element.addEventListener("keydown", handleKeydown);
        element.setAttribute("tabindex", 0);
        element.setAttribute("role", "button");
        element.setAttribute("aria-expanded", "false");
        element.setAttribute("aria-controls", targetId);
    }
    function destroy() {
        element.removeEventListener("click", toggle);
        element.removeEventListener("keydown", handleKeydown);
        element.removeAttribute("role");
        element.removeAttribute("tabindex");
        element.removeAttribute("aria-expanded");
        element.removeAttribute("aria-controls");
        element.classList.remove(expandedClass, collapsedClass);
        targetElement.classList.remove(expandedClass, collapsedClass);
    }
    function toggle() {
        isExpanded ? collapse() : expand();
    }
    function expand(force = false) {
        if (isExpanded && !force) return;
        element.setAttribute("aria-expanded", "true");
        element.classList.add(expandedClass);
        element.classList.remove(collapsedClass);
        targetElement.classList.add(expandedClass);
        targetElement.classList.remove(collapsedClass);
        isExpanded = true;
    }
    function collapse(force = false) {
        if (!isExpanded && !force) return;
        element.setAttribute("aria-expanded", "false");
        element.classList.add(collapsedClass);
        element.classList.remove(expandedClass);
        targetElement.classList.add(collapsedClass);
        targetElement.classList.remove(expandedClass);
        isExpanded = false;
    }
    function handleKeydown(event) {
        if (!(event.key === " " || event.key === "Enter")) return;
        toggle();
        event.preventDefault();
    }
    return {
        create: create,
        destroy: destroy
    };
}


let $c56be13a4b0aff0b$var$style;
let $c56be13a4b0aff0b$var$menus = [];
let $c56be13a4b0aff0b$var$mediaQueries = {};
let $c56be13a4b0aff0b$var$element = document.querySelector(".js-navigation");
function $c56be13a4b0aff0b$export$2cd8252107eb640b() {
    if (!$c56be13a4b0aff0b$var$element) return;
    $c56be13a4b0aff0b$var$style = window.getComputedStyle($c56be13a4b0aff0b$var$element);
    $c56be13a4b0aff0b$var$mediaQueries = {
        expandedMenus: $c56be13a4b0aff0b$var$style.getPropertyValue("--expanded-menus"),
        verticalCurve: $c56be13a4b0aff0b$var$style.getPropertyValue("--vertical-curve")
    };
    Array.from(document.querySelectorAll(".js-nav-header")).forEach((e)=>{
        $c56be13a4b0aff0b$var$menus.push((0, $76443b823084b133$export$931cbfb6bfb85fc)(e));
    });
    $c56be13a4b0aff0b$var$element.addEventListener("dialog:open", ()=>{
        $c56be13a4b0aff0b$var$calcLayout();
        window.addEventListener("resize", $c56be13a4b0aff0b$var$resize);
    });
    $c56be13a4b0aff0b$var$element.addEventListener("dialog:close", ()=>{
        window.removeEventListener("resize", $c56be13a4b0aff0b$var$resize);
    });
}
function $c56be13a4b0aff0b$var$resize() {
    $c56be13a4b0aff0b$var$calcLayout();
}
function $c56be13a4b0aff0b$var$calcLayout() {
    let main = document.querySelector(".js-header-main");
    let curve = document.querySelector(".js-navigation-curve");
    let navigationHeader = document.querySelector(".js-navigation-header");
    curve.style.top = "";
    if (main && navigationHeader) navigationHeader.style.height = `${main.clientHeight}px`;
    if ($c56be13a4b0aff0b$var$mediaQueries.verticalCurve && window.matchMedia($c56be13a4b0aff0b$var$mediaQueries.verticalCurve).matches) curve.style.top = `${-curve.getBoundingClientRect().top}px`;
    $c56be13a4b0aff0b$var$menus.forEach((menu)=>{
        if (!$c56be13a4b0aff0b$var$mediaQueries.expandedMenus || !window.matchMedia($c56be13a4b0aff0b$var$mediaQueries.expandedMenus).matches) menu.create();
        else menu.destroy();
    });
}


function $eac35a776db42d53$export$2cd8252107eb640b() {
    let form = document.querySelector(".js-newsletter");
    if (!form) return;
    let className = "float-label";
    let fields = Array.from(form.querySelectorAll(".js-newsletter-field"));
    form.classList.add("is-enhanced");
    fields.forEach((field)=>{
        field.addEventListener("focus", ()=>field.classList.add(className), true);
        field.addEventListener("blur", (e)=>field.classList.toggle(className, !!e.target.value), true);
    });
}


/**
 * Quick Jump. Uses value from select field to redirect.
 *
 * <select class="js-quick-jump">
 *   <option value="https://www.example.com">...</option>
 * </select>
 */ const $c14333cb453f2307$var$elements = Array.from(document.querySelectorAll(".js-quick-jump"));
function $c14333cb453f2307$export$2cd8252107eb640b() {
    $c14333cb453f2307$var$elements.forEach((element)=>element.addEventListener("change", $c14333cb453f2307$var$redirect));
}
function $c14333cb453f2307$var$redirect(event) {
    const { target: target } = event;
    if (target.tagName.toLowerCase() !== "select") return;
    const selectedIndex = target.selectedIndex;
    const selectedValue = target.options[selectedIndex].value;
    if (selectedValue !== "") window.location.href = selectedValue;
}




let $bb32774d9e489d00$var$element;
function $bb32774d9e489d00$export$2cd8252107eb640b() {
    $bb32774d9e489d00$var$element = document.querySelector(".js-sticky-footer");
    if (!$bb32774d9e489d00$var$element) return;
    $bb32774d9e489d00$var$calcOffset();
    window.addEventListener("resize", $bb32774d9e489d00$var$calcOffset);
}
function $bb32774d9e489d00$var$calcOffset() {
    document.body.style.paddingBottom = `${$bb32774d9e489d00$var$element.clientHeight}px`;
}



function $a8aed38198c5649f$export$2cd8252107eb640b() {
    let elements = (0, $bf76b386537e82d7$export$84bf76cd7afc7469)(".js-faux-link");
    elements.forEach((element)=>{
        element.addEventListener("mouseout", ()=>$a8aed38198c5649f$var$toggleHover(element, false));
        element.addEventListener("mouseenter", ()=>$a8aed38198c5649f$var$toggleHover(element, true));
    });
}
function $a8aed38198c5649f$var$toggleHover(element, force) {
    if (!element) return;
    element.classList.toggle("hover", force);
}


const $057b6001bc37b2ce$var$embeds = Array.from(document.querySelectorAll("[data-video-embed]"));
function $057b6001bc37b2ce$export$2cd8252107eb640b() {
    $057b6001bc37b2ce$var$embeds.forEach((element)=>{
        element.addEventListener("click", $057b6001bc37b2ce$var$onClick, true);
    });
}
function $057b6001bc37b2ce$var$onClick(event) {
    const embedCode = event.currentTarget.dataset.videoEmbed;
    if (embedCode) {
        event.currentTarget.innerHTML = embedCode;
        event.currentTarget.removeEventListener("click", $057b6001bc37b2ce$var$onClick);
    }
}


const $48c2c3b7dbf5b89e$var$defaults = {
    root: null,
    rootMargin: "20%",
    threshold: 0,
    srcAttr: "data-src",
    srcsetAttr: "data-srcset",
    selector: "[data-src], [data-srcset]",
    onLoad: (elem)=>elem.classList.add("has-loaded"),
    onError: (elem)=>elem.classList.add("has-errored")
};
function $48c2c3b7dbf5b89e$export$e7975a21b41d4767(options) {
    const config = {
        ...$48c2c3b7dbf5b89e$var$defaults,
        ...options
    };
    const io = new IntersectionObserver(onIntersection, {
        root: config.root,
        rootMargin: config.rootMargin,
        threshold: config.threshold
    });
    let elements;
    function getElements() {
        return Array.from(document.querySelectorAll(config.selector));
    }
    function update() {
        elements = getElements();
        elements.forEach((elem)=>io.observe(elem));
    }
    function onIntersection(entries) {
        entries.filter((entry)=>entry.isIntersecting).map((entry)=>load(entry.target));
    }
    function setAttributes(elem) {
        const { srcAttr: srcAttr, srcsetAttr: srcsetAttr } = config;
        const src = elem.getAttribute(srcAttr);
        const srcset = elem.getAttribute(srcsetAttr);
        if (srcset) {
            elem.srcset = srcset;
            elem.removeAttribute(srcsetAttr);
        }
        if (src) {
            elem.src = src;
            elem.removeAttribute(srcAttr);
        }
    }
    function load(elem) {
        const index = elements.indexOf(elem);
        elem.onload = ()=>config.onLoad(elem);
        elem.onerror = ()=>config.onError(elem);
        setAttributes(elem);
        io.unobserve(elem);
        elements.splice(index, 1);
    }
    return {
        update: update
    };
}


(0, $bf76b386537e82d7$export$28ee1007e174a2a6)(function onReady() {
    $5a3fc3e2587399e4$var$init();
    /*
	 * We have a class on the document root that disables all css transitions in
	 * order to avoid flashes as the scripts initialise which may add classes based on
	 * state. Once we're done initialising we re-enable them by removing this class.
	 */ window.requestAnimationFrame(()=>{
        document.documentElement.classList.remove("no-transition");
    });
});
function $5a3fc3e2587399e4$var$init() {
    (0, $48c2c3b7dbf5b89e$export$e7975a21b41d4767)().update();
    (0, $33dde29d418793f4$export$2cd8252107eb640b)();
    (0, $679445dd87babde3$export$2cd8252107eb640b)();
    (0, $99182a5dbdb9dab7$export$2cd8252107eb640b)();
    (0, $14e72c11e5d59e2b$export$2cd8252107eb640b)();
    (0, $b9b0ca3f5decef8f$export$2cd8252107eb640b)();
    (0, $f874cc1b66f9c8bd$export$2cd8252107eb640b)();
    (0, $f4e1325d163bbb61$export$2cd8252107eb640b)();
    (0, $c56be13a4b0aff0b$export$2cd8252107eb640b)();
    (0, $eac35a776db42d53$export$2cd8252107eb640b)();
    (0, $c14333cb453f2307$export$2cd8252107eb640b)();
    (0, $9d9a4a02115a6bf3$export$2cd8252107eb640b)();
    (0, $aa6385e02abbadf3$export$2cd8252107eb640b)();
    (0, $d31896c3ffaae1d6$export$2cd8252107eb640b)();
    (0, $bb32774d9e489d00$export$2cd8252107eb640b)();
    (0, $e18e62e0f1712f3a$export$2cd8252107eb640b)();
    (0, $afaff6b8eb7d8e18$export$2cd8252107eb640b)();
    (0, $338352bcfef59b50$export$2cd8252107eb640b)();
    (0, $d687fc76f6d31de1$export$2cd8252107eb640b)();
    (0, $c766d48b0039b09e$export$2cd8252107eb640b)();
    (0, $da8a4b399816f51f$export$2cd8252107eb640b)();
    (0, $68e9d1d72ebb7b5f$export$2cd8252107eb640b)();
    (0, $a8aed38198c5649f$export$2cd8252107eb640b)();
    (0, $057b6001bc37b2ce$export$2cd8252107eb640b)();
}

})();
//# sourceMappingURL=main.js.map
